import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, ViewChild, ElementRef, EventEmitter, Input, Output, NgModule, Optional, Self, ChangeDetectorRef } from '@angular/core';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { map, debounceTime, distinctUntilChanged, tap, switchMap, catchError } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { isNullOrUndefined, isNumber, isArray, isDate, isObject } from 'util';
import { BsModalRef, ModalOptions, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { Subject, concat, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormControl, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsLocaleService, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DualListComponent, AngularDualListBoxModule } from 'angular-dual-listbox';
import { BrMaskModel, BrMaskDirective, BrMaskerModule } from 'br-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxCurrencyModule } from 'ngx-currency';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AmazingTimePickerModule } from 'amazing-time-picker';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const AlertType = {
    info: 0, success: 1, wait: 2, error: 3, warning: 4,
};
AlertType[AlertType.info] = 'info';
AlertType[AlertType.success] = 'success';
AlertType[AlertType.wait] = 'wait';
AlertType[AlertType.error] = 'error';
AlertType[AlertType.warning] = 'warning';
class AlertHistoryModel {
    constructor() { }
}
if (false) {
    /** @type {?} */
    AlertHistoryModel.prototype.date;
    /** @type {?} */
    AlertHistoryModel.prototype.title;
    /** @type {?} */
    AlertHistoryModel.prototype.message;
    /** @type {?} */
    AlertHistoryModel.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxAlertService {
    /**
     * @param {?} toastrService
     */
    constructor(toastrService) {
        this.toastrService = toastrService;
        this.historic = new Array();
    }
    /**
     * @param {?} title
     * @param {?} message
     * @param {?=} type
     * @return {?}
     */
    addToast(title, message, type = 'info' || 'success' || 'wait' || 'error' || 'warning') {
        this.add(title, message, type);
    }
    /**
     * @param {?} title
     * @param {?} message
     * @param {?=} type
     * @return {?}
     */
    add(title, message, type = 'info' || 'success' || 'wait' || 'error' || 'warning') {
        /** @type {?} */
        let typeAlert;
        if (type === null || type === 'info') {
            typeAlert = AlertType.info;
            this.toastrService.info(message);
        }
        else if (type === 'success') {
            typeAlert = AlertType.success;
            this.toastrService.success(message);
        }
        else if (type === 'wait') {
            typeAlert = AlertType.wait;
            this.toastrService.warning(message);
        }
        else if (type === 'error') {
            typeAlert = AlertType.error;
            this.toastrService.error(message);
        }
        else if (type === 'warning') {
            typeAlert = AlertType.warning;
            this.toastrService.warning(message);
        }
        this.addHistory(typeAlert, message, title);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    success(message) {
        this.addHistory(AlertType.success, message, null);
        return this.toastrService.success(message);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    error(message) {
        this.addHistory(AlertType.error, message, null);
        return this.toastrService.error(message);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    warning(message) {
        this.addHistory(AlertType.warning, message, null);
        return this.toastrService.warning(message);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    info(message) {
        this.addHistory(AlertType.info, message, null);
        return this.toastrService.info(message);
    }
    /**
     * @param {?} type
     * @param {?} message
     * @param {?} titleMessage
     * @return {?}
     */
    addHistory(type, message, titleMessage) {
        if (message) {
            /** @type {?} */
            const hist = new AlertHistoryModel();
            hist.type = type;
            hist.title = titleMessage;
            hist.message = message;
            hist.date = new Date();
            this.historic.push(hist);
        }
    }
    /**
     * @return {?}
     */
    getHistory() {
        return this.historic;
    }
}
MxAlertService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MxAlertService.ctorParameters = () => [
    { type: ToastrService }
];
/** @nocollapse */ MxAlertService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MxAlertService_Factory() { return new MxAlertService(ɵɵinject(ToastrService)); }, token: MxAlertService, providedIn: "root" });
if (false) {
    /** @type {?} */
    MxAlertService.prototype.historic;
    /**
     * @type {?}
     * @private
     */
    MxAlertService.prototype.toastrService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Environment {
}
Environment.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ Environment.ngInjectableDef = ɵɵdefineInjectable({ factory: function Environment_Factory() { return new Environment(); }, token: Environment, providedIn: "root" });
if (false) {
    /** @type {?} */
    Environment.prototype.baseBackEnd;
    /** @type {?} */
    Environment.prototype.baseApi;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxBaseRestService {
    /**
     * @param {?} http
     * @param {?} environment
     */
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
        this.baseUrl = this.environment.baseBackEnd;
        this.baseApi = this.environment.baseApi;
    }
    /**
     * @param {?} entity
     * @return {?}
     */
    getUrl(entity) {
        return this.baseUrl + this.baseApi + entity;
    }
    /**
     * @param {?} entidade
     * @return {?}
     */
    totalEntity(entidade) {
        /** @type {?} */
        const url = this.getUrl(entidade) + '/totalEntity';
        return this.http.get(url).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} parametros
     * @param {?=} headers
     * @return {?}
     */
    listAll(entidade, parametros, headers) {
        /** @type {?} */
        const url = this.getUrl(entidade) + parametros;
        /** @type {?} */
        let httpOptions = {};
        if (!isNullOrUndefined(headers)) {
            httpOptions = Object.assign({ headers: new HttpHeaders(headers) });
        }
        return this.http.get(url, httpOptions).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} parametros
     * @param {?} headers
     * @return {?}
     */
    listAllHeader(entidade, parametros, headers) {
        /** @type {?} */
        const url = this.getUrl(entidade) + '/getterFilter' + parametros;
        /** @type {?} */
        const httpOptions = {
            headers: new HttpHeaders({
                filter: JSON.stringify(headers)
            })
        };
        return this.http.get(url, httpOptions).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} metodo
     * @param {?} parametros
     * @return {?}
     */
    getter(entidade, metodo, parametros) {
        /** @type {?} */
        const url = this.getUrl(entidade) + ((metodo || '').toString().length > 0 ? '/' + metodo : '') + parametros;
        return this.http.get(url).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} parametros
     * @return {?}
     */
    find(entidade, parametros) {
        /** @type {?} */
        const url = this.getUrl(entidade) + '/find' + parametros;
        return this.http.get(url).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} parametros
     * @param {?=} options
     * @return {?}
     */
    delete(entidade, parametros, options) {
        /** @type {?} */
        const param = (parametros || '').toString();
        /** @type {?} */
        const url = this.getUrl(entidade) + (param.startsWith('/') || param.startsWith('?') ? '' : '/?id=') + param;
        return this.http.delete(url, options);
    }
    /**
     * @param {?} entidade
     * @param {?} objeto
     * @return {?}
     */
    salvar(entidade, objeto) {
        /** @type {?} */
        const url = this.getUrl(entidade) + '/salvar';
        return this.http.post(url, objeto).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} metodo
     * @param {?} objeto
     * @return {?}
     */
    post(entidade, metodo, objeto) {
        /** @type {?} */
        const url = this.getUrl(entidade) + ((metodo || '').toString().length > 0 ? '/' + metodo : '');
        return this.http.post(url, objeto).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
    /**
     * @param {?} entidade
     * @param {?} metodo
     * @param {?} objeto
     * @param {?} parametros
     * @return {?}
     */
    put(entidade, metodo, objeto, parametros) {
        /** @type {?} */
        const url = this.getUrl(entidade) + ((metodo || '').toString().length > 0 ? '/' + metodo : '') + parametros;
        return this.http.put(url, objeto).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res)));
    }
}
MxBaseRestService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MxBaseRestService.ctorParameters = () => [
    { type: HttpClient },
    { type: Environment }
];
/** @nocollapse */ MxBaseRestService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MxBaseRestService_Factory() { return new MxBaseRestService(ɵɵinject(HttpClient), ɵɵinject(Environment)); }, token: MxBaseRestService, providedIn: "root" });
if (false) {
    /** @type {?} */
    MxBaseRestService.prototype.baseUrl;
    /** @type {?} */
    MxBaseRestService.prototype.baseApi;
    /**
     * @type {?}
     * @private
     */
    MxBaseRestService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    MxBaseRestService.prototype.environment;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxMaxysLovComponent {
    /**
     * @param {?} bsModalRef
     * @param {?} restService
     * @param {?} alertService
     */
    constructor(bsModalRef, restService, alertService) {
        this.bsModalRef = bsModalRef;
        this.restService = restService;
        this.alertService = alertService;
        this.registros = [];
        this.selected = [];
        this.list = [];
        this.callBack = null;
        this.mxQuery = '';
        this.fieldSearch = '';
        this.isLoading = true;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.iptField.nativeElement.focus();
            if (this.fieldSearch !== '') {
                this.buscarRegistros();
            }
            else {
                this.isLoading = false;
            }
        }), 300);
    }
    /**
     * @return {?}
     */
    close() {
        this.bsModalRef.hide();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    select(index) {
        if (this.callBack) {
            this.callBack(this.registros[index]);
        }
        this.bsModalRef.hide();
    }
    /**
     * @return {?}
     */
    selectClose() {
        /** @type {?} */
        const result = [];
        for (const idx of this.selected) {
            result.push(this.registros[idx]);
        }
        if (this.callBack) {
            this.callBack(result);
        }
        this.bsModalRef.hide();
    }
    /**
     * @return {?}
     */
    buscarRegistros() {
        if (this.mxQuery) {
            /** @type {?} */
            let $sql = 'SELECT * FROM ( ' + this.mxQuery + ' ) ';
            $sql += ' WHERE ROWNUM <= 20 ';
            if ((this.columns.length > 0) && this.fieldSearch) {
                $sql += ' AND (';
                this.columns.map((/**
                 * @param {?} val
                 * @param {?} idx
                 * @return {?}
                 */
                (val, idx) => {
                    if (idx > 0) {
                        $sql += ' OR ';
                    }
                    $sql += `${val.name} LIKE '%${this.fieldSearch.toUpperCase()}%'`;
                }));
                $sql += ')';
            }
            this.isLoading = true;
            this.restService.post('operation', 'execute', {
                sqlInstruction: $sql,
                operationType: "SELECT_FULL",
                first: 0,
                maxResults: 50
            }
            /*
            "sqlInstruction" : "SELECT ITEMCOMPRA.CD_EMPRESA, ITEMCOMPRA.NR_LOTECOMPRA, ITEMCOMPRA.NR_ITEMCOMPRA, ITEMCOMPRA.CD_ITEM,ITEMCOMPRA.CD_MOVIMENTACAO,ITEMCOMPRA.QT_PREVISTA FROM ITEMCOMPRA WHERE ITEMCOMPRA.CD_EMPRESA = 84 AND ITEMCOMPRA.NR_LOTECOMPRA is null",
            "operationType":"SELECT_FULL",
            "first": 0,
            "maxResults": 50
            */
            ).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.registros = data;
                this.isLoading = false;
            }), (/**
             * @return {?}
             */
            () => { this.isLoading = false; }));
        }
        else {
            this.alertService.warning('Consulta SQL não informada');
        }
    }
}
MxMaxysLovComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-maxys-lov',
                template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" id=\"modal-basic-title\">{{ title }}</h4>\n  <button type=\"button btn-sm\" class=\"close\" aria-label=\"Close\" (click)=\"close()\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"modal-body\" style=\"padding: 0 0.3rem 0 0.3rem !important\">\n  <div class=\"loading_box\" *ngIf=\"isLoading\"><i class=\"fas fa-spinner fa-pulse\"></i></div>\n  <div class=\"wrap\">\n    <table class=\"table table-hover table-sm\" aria-describedby=\"table\">\n      <thead>\n        <tr>\n          <th colspan=\"100%\">\n            <input type=\"text\" class=\"form-control my-2\" placeholder=\"Localizar ...\" #iptField\n              [(ngModel)]=\"fieldSearch\" (keyup.enter)=\"buscarRegistros()\" />\n          </th>\n        </tr>\n        <tr style=\"font-weight: bold\">\n          <th id=\"{{ c.title }}\" *ngFor=\"let c of columns\">\n            {{ c.title | translate }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let reg of registros; let idx = index\" (click)=\"select(idx)\">\n          <td *ngFor=\"let c of columns\">\n            {{ reg[c.name] }}\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n<div class=\"modal-footer text-right\">\n  <button class=\"btn btn-info\" (click)=\"selectClose()\">Selecionar</button>\n</div>\n",
                styles: [".wrap{min-height:150px;position:relative;max-height:400px;overflow-y:auto}.wrap table{box-shadow:0 4px 5px rgba(0,0,0,.15)}.wrap table tbody tr{cursor:pointer;font-weight:700}.modal-body .loading_box{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.4);z-index:999}.modal-body .loading_box i{color:#fff;position:absolute;top:50%;left:50%;font-size:3rem;margin-left:-50px;margin-top:-25px}"]
            }] }
];
/** @nocollapse */
MxMaxysLovComponent.ctorParameters = () => [
    { type: BsModalRef },
    { type: MxBaseRestService },
    { type: MxAlertService }
];
MxMaxysLovComponent.propDecorators = {
    iptField: [{ type: ViewChild, args: ['iptField', { read: ElementRef, static: true },] }]
};
if (false) {
    /** @type {?} */
    MxMaxysLovComponent.prototype.iptField;
    /** @type {?} */
    MxMaxysLovComponent.prototype.title;
    /** @type {?} */
    MxMaxysLovComponent.prototype.registros;
    /** @type {?} */
    MxMaxysLovComponent.prototype.modalService;
    /** @type {?} */
    MxMaxysLovComponent.prototype.selected;
    /** @type {?} */
    MxMaxysLovComponent.prototype.list;
    /** @type {?} */
    MxMaxysLovComponent.prototype.callBack;
    /** @type {?} */
    MxMaxysLovComponent.prototype.columns;
    /** @type {?} */
    MxMaxysLovComponent.prototype.mxQuery;
    /** @type {?} */
    MxMaxysLovComponent.prototype.fieldSearch;
    /** @type {?} */
    MxMaxysLovComponent.prototype.isLoading;
    /**
     * @type {?}
     * @private
     */
    MxMaxysLovComponent.prototype.bsModalRef;
    /**
     * @type {?}
     * @private
     */
    MxMaxysLovComponent.prototype.restService;
    /**
     * @type {?}
     * @private
     */
    MxMaxysLovComponent.prototype.alertService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxModalLovMaxysService {
    /**
     * @param {?} modalService
     */
    constructor(modalService) {
        this.modalService = modalService;
        this.returnSelectedSource = new Subject();
        this.returnSelected$ = this.returnSelectedSource.asObservable();
    }
    /**
     * @param {?} modelLov
     * @param {?} startSearch
     * @param {?=} callBackFinal
     * @return {?}
     */
    openLov(modelLov, startSearch, callBackFinal) {
        if (modelLov.query) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const add = new ModalOptions();
                add.class = 'modal-lg';
                add.backdrop = true;
                add.initialState = {
                    columns: modelLov.columnsModalLov,
                    title: 'Lista de valores',
                    fieldSearch: startSearch,
                    mxQuery: modelLov.query,
                    callBack: (/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        if (modelLov.callback) {
                            modelLov.callback(data, callBackFinal);
                        }
                    }),
                };
                this.modalService.show(MxMaxysLovComponent, add);
                this.modalService.checkScrollbar();
            }), 100);
        }
        else {
            console.log('Não foi possível abrir Lov pois não foi informado consulta mxQuery.');
        }
        return true;
    }
}
MxModalLovMaxysService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MxModalLovMaxysService.ctorParameters = () => [
    { type: BsModalService }
];
/** @nocollapse */ MxModalLovMaxysService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MxModalLovMaxysService_Factory() { return new MxModalLovMaxysService(ɵɵinject(BsModalService)); }, token: MxModalLovMaxysService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    MxModalLovMaxysService.prototype.returnSelectedSource;
    /** @type {?} */
    MxModalLovMaxysService.prototype.returnSelected$;
    /**
     * @type {?}
     * @private
     */
    MxModalLovMaxysService.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxModalLovComponent {
    /**
     * @param {?} bsModalRef
     */
    constructor(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.mxLevel = 1;
        this.registros = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        console.log('init modallov');
        console.log('level ' + this.mxLevel);
        if (this.addFunction) {
            this.showBtNew = true;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onNew(event) {
        if (this.addFunction) {
            this.close();
            this.addFunction(event);
        }
    }
    /**
     * @return {?}
     */
    close() {
        //  this.bsModalRef.hide();
        console.log('close level ' + this.mxLevel);
        this.modalService.hide(this.mxLevel);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    select(event) {
        console.log('select');
        this.modalService.hide(this.mxLevel);
        // this.bsModalRef.hide();
        if (this.return) {
            this.return.emit(event);
        }
        if (this.callBack) {
            this.callBack(event);
        }
    }
}
MxModalLovComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-mx-modal-lov',
                template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" id=\"modal-basic-title\">{{title}}</h4>\n  <button type=\"button btn-sm\" class=\"close\" aria-label=\"Close\" (click)=\"close()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <mx-data-table-paginator [mxColumns]=\"columns\" [mxEntidade]=\"mxEntidade\" [mxGetCount]=\"mxGetCount\" [mxGetList]=\"mxGetList\" [btSelectIcon]=true  [showBtNew]=\"showBtNew\"\n    (mxOnSelect)=\"select($event)\" [mxIsActionBack]=\"true\" (mxOnBack)=\"close()\" classContainer=\"container-fluid\" (mxOnClick)=\"select($event)\" ></mx-data-table-paginator>\n</div>\n<div class=\"modal-footer text-right\">\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MxModalLovComponent.ctorParameters = () => [
    { type: BsModalRef }
];
if (false) {
    /** @type {?} */
    MxModalLovComponent.prototype.title;
    /** @type {?} */
    MxModalLovComponent.prototype.mxEntidade;
    /** @type {?} */
    MxModalLovComponent.prototype.mxSelect;
    /** @type {?} */
    MxModalLovComponent.prototype.mxColumns;
    /** @type {?} */
    MxModalLovComponent.prototype.mxGetCount;
    /** @type {?} */
    MxModalLovComponent.prototype.mxGetList;
    /** @type {?} */
    MxModalLovComponent.prototype.mxLevel;
    /** @type {?} */
    MxModalLovComponent.prototype.columns;
    /** @type {?} */
    MxModalLovComponent.prototype.registros;
    /** @type {?} */
    MxModalLovComponent.prototype.modalService;
    /** @type {?} */
    MxModalLovComponent.prototype.showBtNew;
    /** @type {?} */
    MxModalLovComponent.prototype.return;
    /** @type {?} */
    MxModalLovComponent.prototype.addFunction;
    /** @type {?} */
    MxModalLovComponent.prototype.callBack;
    /**
     * @type {?}
     * @private
     */
    MxModalLovComponent.prototype.bsModalRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxModalConfirmComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    close() {
        this.modalService.hide(1);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    select(event) {
        this.modalService.hide(1);
        if (this.return) {
            this.return.emit(event);
        }
        if (this.callBack) {
            this.callBack(event);
        }
    }
}
MxModalConfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-modal-confirm',
                template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" id=\"modal-basic-title\">{{title}}</h4>\n</div>\n<div class=\"modal-body\">\n  <label>{{msg}}</label>\n</div>\n<div class=\"modal-footer\" style=\"justify-content: center\">\n  <button class=\"btn btn-success\" (click)=\"select(true)\">\n      {{'Sim' | translate}}\n      <i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i>\n  </button>\n  <button class=\"btn btn-danger\" (click)=\"select(false)\">\n      {{'N\u00E3o' | translate}}\n      <i class=\"fa fa-trash\" aria-hidden=\"true\"></i>\n  </button>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MxModalConfirmComponent.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    MxModalConfirmComponent.prototype.title;
    /** @type {?} */
    MxModalConfirmComponent.prototype.msg;
    /** @type {?} */
    MxModalConfirmComponent.prototype.modalService;
    /** @type {?} */
    MxModalConfirmComponent.prototype.return;
    /** @type {?} */
    MxModalConfirmComponent.prototype.callBack;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxModalListComponent {
    constructor() {
        this.registros = [];
        this.selected = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    close() {
        this.modalService.hide(1);
    }
    /**
     * @param {?} index
     * @return {?}
     */
    select(index) {
        console.log('select');
        if (this.selectMultiple) {
            if (this.selected.includes(index)) {
                this.selected.splice(this.selected.indexOf(index), 1);
            }
            else {
                this.selected.push(index);
            }
        }
        else {
            this.modalService.hide(1);
            if (this.return) {
                this.return.emit(this.registros[index]);
            }
            if (this.callBack) {
                this.callBack(this.registros[index]);
            }
        }
    }
    /**
     * @param {?} all
     * @return {?}
     */
    selectAll(all) {
        console.log('selectAll');
        if (all.checked) {
            this.selected = [];
            for (let i = 0; i < this.registros.length; i++) {
                this.selected.push(i);
            }
        }
        else {
            this.selected = [];
        }
    }
    /**
     * @return {?}
     */
    selectClose() {
        console.log('selectClose');
        /** @type {?} */
        const result = [];
        for (const idx of this.selected) {
            result.push(this.registros[idx]);
        }
        this.modalService.hide(1);
        if (this.return) {
            this.return.emit(result);
        }
        if (this.callBack) {
            this.callBack(result);
        }
    }
}
MxModalListComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-modal-list',
                template: "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title\" id=\"modal-basic-title\">{{title}}</h4>\r\n  <button type=\"button btn-sm\" class=\"close\" aria-label=\"Close\" (click)=\"close()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div class=\"modal-body\" style=\"padding: 0 0.3rem 0 0.3rem !important;\">\r\n  <table class=\"table table-bordered table-sm m-0\" aria-describedby=\"table\">\r\n    <thead>\r\n      <tr style=\"font-weight: bold;\">\r\n        <th id=\"selectAll\" *ngIf=\"selectMultiple\" class=\"text-center\">\r\n            <input type=\"checkbox\" #sec (click)=\"selectAll(sec)\" >\r\n        </th>\r\n        <th id=\"{{c.title}}\" *ngFor=\"let c of columns\">\r\n          {{c.title | translate}}\r\n        </th>\r\n      </tr>\r\n    </thead>\r\n    <tbody>\r\n      <tr  *ngFor=\"let reg of registros; let idx = index \" (click)=\"select(idx)\">\r\n        <td class=\"text-center\" *ngIf=\"selectMultiple\">\r\n            <input type=\"checkbox\" checked *ngIf=\"selected.includes(idx)\" >\r\n            <input type=\"checkbox\" *ngIf=\"!selected.includes(idx)\" >\r\n        </td>\r\n        <td *ngFor=\"let c of columns\">\r\n          <label  style=\"font-weight: initial;\">{{reg[c.name]}}</label>\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"modal-footer text-right\">\r\n  <button class=\"btn btn-info\" (click)=\"selectClose()\" >Selecionar</button>\r\n</div>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MxModalListComponent.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    MxModalListComponent.prototype.title;
    /** @type {?} */
    MxModalListComponent.prototype.columns;
    /** @type {?} */
    MxModalListComponent.prototype.registros;
    /** @type {?} */
    MxModalListComponent.prototype.modalService;
    /** @type {?} */
    MxModalListComponent.prototype.selectMultiple;
    /** @type {?} */
    MxModalListComponent.prototype.selected;
    /** @type {?} */
    MxModalListComponent.prototype.return;
    /** @type {?} */
    MxModalListComponent.prototype.callBack;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxModalInfoComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    close() {
        this.modalService.hide(1);
    }
}
MxModalInfoComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-modal-info',
                template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" id=\"modal-basic-title\">{{title}}</h4>\n</div>\n<div class=\"modal-body\">\n  <label>{{msg}}</label>\n</div>\n<div class=\"modal-footer\" style=\"justify-content: center\">\n  <button class=\"btn btn-info\" (click)=\"close()\">\n      {{'Ok' | translate}}\n  </button>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MxModalInfoComponent.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    MxModalInfoComponent.prototype.title;
    /** @type {?} */
    MxModalInfoComponent.prototype.msg;
    /** @type {?} */
    MxModalInfoComponent.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxModalService {
    /**
     * @param {?} modalService
     * @param {?} modalServiceList
     */
    constructor(modalService, modalServiceList) {
        this.modalService = modalService;
        this.modalServiceList = modalServiceList;
        this.openList = false;
    }
    /**
     * @param {?} component
     * @param {?} data
     * @param {?} callBack
     * @param {?=} classModal
     * @return {?}
     */
    show(component, data, callBack, classModal = 'modal-lg') {
        /** @type {?} */
        const add = new ModalOptions();
        add.class = classModal;
        add.initialState = {
            data,
            callBack,
            modalService: this.modalService,
            show: true,
            ignoreBackdropClick: true,
            keyboad: false
        };
        this.modalService.show(component, add);
    }
    /**
     * @param {?} param
     * @param {?} call
     * @return {?}
     */
    showLovParam(param, call) {
        /** @type {?} */
        const add = new ModalOptions();
        add.class = 'modal-lg';
        add.initialState = {
            title: param.mxTitle,
            mxEntidade: param.mxEntidade,
            columns: param.mxColumns,
            mxGetCount: param.mxGetCount,
            mxGetList: param.mxGetList,
            addFunction: param.mxAddFunction,
            callBack: call,
            modalService: this.modalService,
            show: true,
            ignoreBackdropClick: true,
            keyboad: false,
            mxLevel: param.mxLevel
        };
        console.log('show');
        this.bsModalRef = this.modalService.show(MxModalLovComponent, add);
    }
    /**
     * @param {?} mxEntidade
     * @param {?} columns
     * @param {?} mxGetCount
     * @param {?} mxGetList
     * @param {?} call
     * @param {?=} addFunction
     * @return {?}
     */
    showLov(mxEntidade, columns, mxGetCount, mxGetList, call, addFunction = null) {
        /** @type {?} */
        const add = new ModalOptions();
        add.class = 'modal-lg';
        add.initialState = {
            mxEntidade,
            columns,
            mxGetCount,
            mxGetList,
            addFunction,
            callBack: call,
            modalService: this.modalService,
            show: true,
            ignoreBackdropClick: true,
            keyboad: false
        };
        console.log('show');
        this.bsModalRef = this.modalService.show(MxModalLovComponent, add);
    }
    /**
     * @param {?} title
     * @param {?} msg
     * @param {?} call
     * @return {?}
     */
    showConfirm(title, msg, call) {
        /** @type {?} */
        const add = new ModalOptions();
        add.class = 'modal-sm';
        add.initialState = {
            title,
            msg,
            callBack: call,
            modalService: this.modalService,
            show: true,
        };
        this.modalService.show(MxModalConfirmComponent, add);
    }
    /**
     * @param {?} title
     * @param {?} columns
     * @param {?} list
     * @param {?=} selectMultiple
     * @param {?=} call
     * @return {?}
     */
    showLovList(title, columns, list, selectMultiple = false, call) {
        /** @type {?} */
        const add = new ModalOptions();
        add.class = 'modal-lg';
        add.initialState = {
            title,
            columns,
            registros: list,
            selectMultiple,
            callBack: call,
            modalService: this.modalServiceList,
            show: true
        };
        //  TODO resolver
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.modalServiceList.show(MxModalListComponent, add);
            this.modalService.checkScrollbar();
        }), 750);
    }
    /**
     * @param {?} title
     * @param {?} msg
     * @return {?}
     */
    showInfo(title, msg) {
        /** @type {?} */
        const add = new ModalOptions();
        add.class = 'modal-sm';
        add.initialState = {
            title,
            msg,
            modalService: this.modalService,
            show: true,
        };
        this.modalService.show(MxModalInfoComponent, add);
    }
}
MxModalService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MxModalService.ctorParameters = () => [
    { type: BsModalService },
    { type: BsModalService }
];
/** @nocollapse */ MxModalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MxModalService_Factory() { return new MxModalService(ɵɵinject(BsModalService), ɵɵinject(BsModalService)); }, token: MxModalService, providedIn: "root" });
if (false) {
    /** @type {?} */
    MxModalService.prototype.bsModalRef;
    /** @type {?} */
    MxModalService.prototype.openList;
    /**
     * @type {?}
     * @private
     */
    MxModalService.prototype.modalService;
    /**
     * @type {?}
     * @private
     */
    MxModalService.prototype.modalServiceList;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputTextComponent {
    /**
     * @param {?} brMask
     */
    constructor(brMask) {
        this.brMask = brMask;
        this.mask = {};
        this.mxModelChange = new EventEmitter();
        this.mxPlaceholder = '';
        this.mxPrependIcon = '';
        this.mxAppendIcon = '';
        this.mxType = 'text'; //   text, cpfcnpj, telefone, cep, string, number, currency, decimal, data
        //   text, cpfcnpj, telefone, cep, string, number, currency, decimal, data
        this.mxDivClass = '';
        this.mxReadonly = false;
        this.mxMaxLength = false;
        this.mxTabindex = 0;
        this.mxRequired = false;
        this.mxChange = new EventEmitter();
        this.mxBlur = new EventEmitter();
        this.mxFocus = new EventEmitter();
        this.mxClick = new EventEmitter();
        this.mxKeyPress = new EventEmitter();
        this.mxKeyDown = new EventEmitter();
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        if (this.mxType !== 'text' && val) { //  && !this._mxModel
            this._mxModel = this.format(val);
        }
        else {
            this._mxModel = val;
        }
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.mxType === 'cpfcnpj') {
            this.mask = { person: true };
        }
        else if (this.mxType === 'cep') {
            this.mask = { mask: '00.000-000', len: 10 };
        }
        else if (this.mxType === 'telefone') {
            this.mask = { phone: true };
        }
        else if (this.mxType === 'number') {
            this.mask = { type: 'num', thousand: '.', numberAndTousand: true };
        }
        else if (this.mxType === 'currency') {
            this.mask = { money: true, decimal: 2, thousand: '.' };
        }
        else if (this.mxType === 'decimal') {
            this.mask = { decimal: 2 };
        }
        else if (this.mxType === 'date') {
            this.mask = { mask: '00/00/0000', len: 10 };
        }
    }
    /**
     * @param {?} val
     * @return {?}
     */
    format(val) {
        /** @type {?} */
        const m = new BrMaskModel();
        if (this.mxType === 'cpfcnpj') {
            m.person = true;
        }
        else if (this.mxType === 'cep') {
            m.mask = '00.000-000';
            m.len = 10;
        }
        else if (this.mxType === 'telefone') {
            m.phone = true;
        }
        else if (this.mxType === 'number') {
            m.type = 'num';
            m.thousand = '.';
            m.numberAndTousand = true;
        }
        else if (this.mxType === 'currency') {
            m.money = true;
            m.thousand = '.';
        }
        else if (this.mxType === 'decimal') {
            m.decimal = 2;
        }
        else if (this.mxType === 'date') {
            m.mask = '00/00/0000';
            m.len = 10;
        }
        /** @type {?} */
        const formated = this.brMask.writeCreateValue(val, m);
        return formated;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.mxModel) {
            if ((!changes.mxModel.previousValue) && (this.mxType === 'number') && (this._mxModel)) {
                this._mxModel = this.transformMilhar(this._mxModel);
            }
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyPress(event) {
        if (this.mxKeyPress) {
            this.mxKeyPress.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChange(event) {
        if (this.mxType !== 'text') {
            this.mxModel = event.target.value;
        }
        if (this.mxChange) {
            this.mxChange.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onBlur(event) {
        if (this.mxBlur) {
            this.mxBlur.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onFocus(event) {
        if (this.mxFocus) {
            this.mxFocus.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (this.mxClick) {
            this.mxClick.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        if (this.mxKeyDown) {
            this.mxKeyDown.emit(event);
        }
    }
    /**
     * @param {?} str
     * @return {?}
     */
    transformMilhar(str) {
        return ((Math.abs(Number(str))).toLocaleString('en')).split(',').join('.');
    }
}
MxInputTextComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-text',
                template: "<div class=\" form-group\" [ngClass]=\"mxDivClass\">\r\n  <label *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\">{{mxLabel | translate}}\r\n    <ng-container *ngIf=\"mxRequired\" >\r\n      <span class=\"required\">*</span>\r\n    </ng-container>\r\n  </label>\r\n  <div class=\"input-group\" #imask>\r\n    <div *ngIf=\"mxPrependIcon\" class=\"input-group-prepend\"><span class=\"input-group-text\">{{mxPrependIcon}}</span></div>\r\n    <input *ngIf=\"mxType === 'text' || mxType === 'password'\" type=\"{{(mxType === 'password' ? 'password' : 'text')}}\" class=\"form-control input-sm\" [readonly]=\"mxReadonly\" [(ngModel)]=\"mxModel\"\r\n      (change)=\"onChange($event)\" (blur)=\"onBlur($event)\" (focus)=\"onFocus($event)\" (click)=\"onClick($event)\" [(placeholder)]=\"mxPlaceholder\"\r\n      (keydown)=\"onKeyDown($event)\" [required]=\"mxRequired ? 'required': ''\"\r\n      (keypress)=\"onKeyPress($event)\" [ngClass]=\"mxInputClass\" [maxlength]=\"mxMaxLength\" [tabindex]=\"mxTabindex\" />\r\n\r\n      <input *ngIf=\"mxType !== 'text' && mxType !== 'password'\" type=\"text\" class=\"form-control input-sm\" [readonly]=\"mxReadonly\" [(ngModel)]=\"mxModel\"\r\n      (change)=\"onChange($event)\" (blur)=\"onBlur($event)\" (focus)=\"onFocus($event)\" (click)=\"onClick($event)\" [(placeholder)]=\"mxPlaceholder\"\r\n      (keypress)=\"onKeyPress($event)\" [ngClass]=\"mxInputClass\" [brmasker]=\"mask\" [maxlength]=\"mxMaxLength\" [tabindex]=\"mxTabindex\"\r\n      [required]=\"mxRequired ? 'required': ''\" />\r\n    <div *ngIf=\"mxAppendIcon\" class=\"input-group-append\"><span class=\"input-group-text\">{{mxAppendIcon}}</span></div>\r\n  </div>\r\n  <small [ngClass]=\"mxHelpClass\" *ngIf=\"mxHelp\" class=\"form-text text-muted\">{{mxHelp}}</small>\r\n</div>\r\n",
                styles: [".uppercase input.form-control{text-transform:uppercase!important}"]
            }] }
];
/** @nocollapse */
MxInputTextComponent.ctorParameters = () => [
    { type: BrMaskDirective }
];
MxInputTextComponent.propDecorators = {
    imask: [{ type: ViewChild, args: ['imask', { read: ElementRef, static: true },] }],
    mxModel: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxPlaceholder: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxPrependIcon: [{ type: Input }],
    mxAppendIcon: [{ type: Input }],
    mxType: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxReadonly: [{ type: Input }],
    mxMaxLength: [{ type: Input }],
    mxTabindex: [{ type: Input }],
    mxRequired: [{ type: Input }],
    mxChange: [{ type: Output }],
    mxBlur: [{ type: Output }],
    mxFocus: [{ type: Output }],
    mxClick: [{ type: Output }],
    mxKeyPress: [{ type: Output }],
    mxKeyDown: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxInputTextComponent.prototype.imask;
    /** @type {?} */
    MxInputTextComponent.prototype._mxModel;
    /** @type {?} */
    MxInputTextComponent.prototype.mask;
    /** @type {?} */
    MxInputTextComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputTextComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputTextComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputTextComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputTextComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputTextComponent.prototype.mxPlaceholder;
    /** @type {?} */
    MxInputTextComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputTextComponent.prototype.mxPrependIcon;
    /** @type {?} */
    MxInputTextComponent.prototype.mxAppendIcon;
    /** @type {?} */
    MxInputTextComponent.prototype.mxType;
    /** @type {?} */
    MxInputTextComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputTextComponent.prototype.mxReadonly;
    /** @type {?} */
    MxInputTextComponent.prototype.mxMaxLength;
    /** @type {?} */
    MxInputTextComponent.prototype.mxTabindex;
    /** @type {?} */
    MxInputTextComponent.prototype.mxRequired;
    /** @type {?} */
    MxInputTextComponent.prototype.mxChange;
    /** @type {?} */
    MxInputTextComponent.prototype.mxBlur;
    /** @type {?} */
    MxInputTextComponent.prototype.mxFocus;
    /** @type {?} */
    MxInputTextComponent.prototype.mxClick;
    /** @type {?} */
    MxInputTextComponent.prototype.mxKeyPress;
    /** @type {?} */
    MxInputTextComponent.prototype.mxKeyDown;
    /**
     * @type {?}
     * @private
     */
    MxInputTextComponent.prototype.brMask;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputDateComponent {
    /**
     * @param {?} localeService
     */
    constructor(localeService) {
        this.localeService = localeService;
        this.mxModelChange = new EventEmitter();
        this.mxOnDateSelect = new EventEmitter();
        this.mxPlaceHolder = '';
        this.mxMaxys = false;
        this.mxInputHeight = 0;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.localeService.use('pt-br');
        this.mxDateCustomClasses = [{ date: new Date(), classes: ['today-selected'] }];
        if (!this._mxModel) {
            this._mxModel = null;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDateSelect(event) {
        if (this.mxOnDateSelect) {
            this.mxOnDateSelect.emit(event);
        }
    }
    /**
     * @return {?}
     */
    inputClick() {
        if (!this.mxDisabled) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.iptElement.nativeElement.click();
            }), 100);
        }
    }
    /**
     * @param {?} event
     * @param {?} el
     * @return {?}
     */
    OnKeyDown(event, el) {
        // console.log( 'keydown' );
        // console.log( event );
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
            // Allow: Ctrl+C
            (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
            // Allow: Ctrl+V
            (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
            // Allow: Ctrl+X
            (event.keyCode === 88 && (event.ctrlKey || event.metaKey)) ||
            // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57))
            && (event.keyCode < 96 || event.keyCode > 105)) {
            event.preventDefault();
        }
    }
    /**
     * @param {?} event
     * @param {?} el
     * @return {?}
     */
    OnKeyUp(event, el) {
        // console.log( 'keyPress' );
        // console.log( el.value );
        // const totalTexto = event.target.value.length;
        /** @type {?} */
        let startInput = event.target.selectionStart;
        // posição cursor
        /** @type {?} */
        let endInput = event.target.selectionEnd;
        if (el) {
            el.value = this.formatMaskDate(el);
            if ((el.value.length === 4) || (el.value.length === 7)) {
                startInput++;
                endInput++;
            }
            event.target.selectionStart = startInput;
            event.target.selectionEnd = endInput;
        }
    }
    /**
     * @param {?} el
     * @return {?}
     */
    formatMaskDate(el) {
        /** @type {?} */
        let value = el.value;
        if (value === 'Invalid date') {
            value = '';
        }
        value = value.split('/').join('');
        /** @type {?} */
        const v = value.replace(/\s/g, '').slice(0, 10);
        if (v.length >= 5) {
            return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
        }
        else if (v.length >= 3) {
            return `${v.slice(0, 2)}/${v.slice(2)}`;
        }
        return v;
    }
    /**
     * @param {?} el
     * @return {?}
     */
    OnFocus(el) {
        // console.log( 'Onfocus' );
        if (el.value === 'Invalid date') {
            el.value = '';
        }
    }
}
MxInputDateComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-date',
                template: "<div class=\"form-group {{ mxDivClass }} {{ (mxMaxys) ? 'form-maxys' : '' }}\">\n    <label *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\" >{{mxLabel}}</label>\n    <div class=\"input-group\">\n      <div *ngIf=\"mxPrependIcon\" class=\"input-group-prepend\"><span class=\"input-group-text\"><i class=\"{{mxPrependIcon}}\"></i></span></div>\n      <input #iptElement type=\"text\" [(placeholder)]=\"mxPlaceHolder\" class=\"form-control\" [attr.disabled]=\"mxDisabled ? 'disabled' : null\"\n        bsDatepicker [bsConfig]=\"{adaptivePosition: true, isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }\" [dateCustomClasses]=\"mxDateCustomClasses\"\n        [(ngModel)]=\"mxModel\" [ngClass]=\"mxInputClass\" maxlength=\"10\" [ngStyle]=\"(mxInputHeight > 0) && {'height': mxInputHeight + 'px'}\"\n        (keyup)=\"OnKeyUp($event, iptElement)\" (keydown)=\"OnKeyDown($event, iptElement)\" (focus)=\"OnFocus(iptElement)\" >\n      <div *ngIf=\"mxAppendIcon\" class=\"input-group-append\"><span class=\"input-group-text\" (click)=\"inputClick()\"><i class=\"{{mxAppendIcon}}\"></i></span></div>\n    </div>\n    <small id=\"idHelper\" [ngClass]=\"mxHelpClass\" *ngIf=\"mxLabel\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>",
                styles: [".form-maxys .input-group-text{padding:0 4px;font-size:12px}.form-maxys input{font-size:13px;letter-spacing:-1px}"]
            }] }
];
/** @nocollapse */
MxInputDateComponent.ctorParameters = () => [
    { type: BsLocaleService }
];
MxInputDateComponent.propDecorators = {
    mxModel: [{ type: Input }],
    iptElement: [{ type: ViewChild, args: ['iptElement', { read: ElementRef, static: true },] }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxOnDateSelect: [{ type: Output }],
    mxPlaceHolder: [{ type: Input }],
    mxPrependIcon: [{ type: Input }],
    mxAppendIcon: [{ type: Input }],
    mxDisabled: [{ type: Input }],
    mxMaxys: [{ type: Input }],
    mxInputHeight: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxInputDateComponent.prototype._mxModel;
    /** @type {?} */
    MxInputDateComponent.prototype.iptElement;
    /** @type {?} */
    MxInputDateComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputDateComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputDateComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputDateComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputDateComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputDateComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputDateComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputDateComponent.prototype.mxOnDateSelect;
    /** @type {?} */
    MxInputDateComponent.prototype.mxPlaceHolder;
    /** @type {?} */
    MxInputDateComponent.prototype.mxPrependIcon;
    /** @type {?} */
    MxInputDateComponent.prototype.mxAppendIcon;
    /** @type {?} */
    MxInputDateComponent.prototype.mxDisabled;
    /** @type {?} */
    MxInputDateComponent.prototype.mxMaxys;
    /** @type {?} */
    MxInputDateComponent.prototype.mxInputHeight;
    /** @type {?} */
    MxInputDateComponent.prototype.mxDateCustomClasses;
    /**
     * @type {?}
     * @private
     */
    MxInputDateComponent.prototype.localeService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxSelectOneComponent {
    constructor() {
        this.mxModelChange = new EventEmitter();
        this.mxValueProperty = null;
        this.mxDisabled = false;
        this.mxChange = new EventEmitter();
        this.mxFocus = new EventEmitter();
        this.mxBlur = new EventEmitter();
        this.mxClick = new EventEmitter();
        this.mxKeyPress = new EventEmitter();
        this.mxCompare = this.compareEnum;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
    /**
     * @param {?} c1
     * @param {?} c2
     * @return {?}
     */
    compareEnum(c1, c2) {
        if (c1 && c2) {
            if (this.mxKey) {
                return c1[this.mxKey] === c2[this.mxKey];
            }
            else {
                return JSON.stringify(c1) === JSON.stringify(c2);
            }
        }
        else {
            return c1 === c2;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChange(event) {
        if (this.mxChange) {
            this.mxChange.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onFocus(event) {
        if (this.mxFocus) {
            this.mxFocus.emit(event);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onBlur(event) {
        if (this.mxBlur) {
            this.mxBlur.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (this.mxClick) {
            this.mxClick.emit(event.target.value);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getValue(value) {
        return (this.mxValueProperty ? value[this.mxValueProperty] : value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getLabel(value) {
        return (this.mxValue ? value[this.mxValue] : value);
    }
}
MxSelectOneComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-select-one',
                template: "<div class=\" form-group\" [ngClass]=\"mxDivClass\">\n    <label for=\"id\" *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\" >{{mxLabel}}</label>\n    <select id=\"tipo\" #mxInputElement *ngIf=\"!mxValueProperty\" [compareWith]=\"mxCompare\" class=\"form-control\"\n         [(ngModel)]=\"mxModel\"\n         [ngClass]=\"mxSelectClass\"\n         (change)=\"onChange($event)\"\n         (blur)=\"onBlur($event)\"\n         (click)=\"onClick($event)\"\n         (focus)=\"onFocus($event)\"\n         [attr.disabled]=\"mxDisabled ? 'disabled' : null\">\n        <option *ngFor=\"let t of mxList\" [ngValue]=\"t\">{{t[mxValue]}} <span *ngIf=\"mxValue2\"> - {{t[mxValue2]}}</span> </option>\n    </select>\n    <select id=\"tipo\" #mxInputElement *ngIf=\"mxValueProperty\" class=\"form-control\"\n         [(ngModel)]=\"mxModel\"\n         [ngClass]=\"mxSelectClass\"\n         (change)=\"onChange($event)\"\n         (blur)=\"onBlur($event)\"\n         (click)=\"onClick($event)\"\n         (focus)=\"onFocus($event)\"\n         [attr.disabled]=\"mxDisabled ? 'disabled' : null\">\n        <option *ngFor=\"let t of mxList\" [ngValue]=\"t[mxValueProperty]\">{{t[mxValue]}}<span *ngIf=\"mxValue2\"> - {{t[mxValue2]}}</span></option>\n    </select>\n    <small id=\"idHelper\" [ngClass]=\"mxHelpClass\" *ngIf=\"mxHelp\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MxSelectOneComponent.ctorParameters = () => [];
MxSelectOneComponent.propDecorators = {
    mxInputElement: [{ type: ViewChild, args: ['mxInputElement', { read: ElementRef, static: false },] }],
    mxModel: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxDivClass: [{ type: Input }],
    mxKey: [{ type: Input }],
    mxValue: [{ type: Input }],
    mxValue2: [{ type: Input }],
    mxValueProperty: [{ type: Input }],
    mxList: [{ type: Input }],
    mxSelectClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDisabled: [{ type: Input }],
    mxChange: [{ type: Output }],
    mxFocus: [{ type: Output }],
    mxBlur: [{ type: Output }],
    mxClick: [{ type: Output }],
    mxKeyPress: [{ type: Output }],
    mxCompare: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxSelectOneComponent.prototype.mxInputElement;
    /** @type {?} */
    MxSelectOneComponent.prototype._mxModel;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxModelChange;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxDivClass;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxKey;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxValue;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxValue2;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxValueProperty;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxList;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxSelectClass;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxHelp;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxLabel;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxDisabled;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxChange;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxFocus;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxBlur;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxClick;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxKeyPress;
    /** @type {?} */
    MxSelectOneComponent.prototype.mxCompare;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputDateRangeComponent {
    /**
     * @param {?} localeService
     */
    constructor(localeService) {
        this.localeService = localeService;
        this.mxModelChange = new EventEmitter();
        this.mxPlaceHolder = '';
        this.mxOnDateSelect = new EventEmitter();
        this.mxPlaceHolder = 'Datepicker';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.localeService.use('pt-br');
    }
    /**
     * @param {?} event
     * @param {?} el
     * @return {?}
     */
    OnKeyDown(event, el) {
        // console.log( 'keydown' );
        // console.log( event.keyCode );
        if ([46, 8, 9, 27, 13, 110, 190, 32, 109, 173].indexOf(event.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
            // Allow: Ctrl+C
            (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
            // Allow: Ctrl+V
            (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
            // Allow: Ctrl+X
            (event.keyCode === 88 && (event.ctrlKey || event.metaKey)) ||
            // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57))
            && (event.keyCode < 96 || event.keyCode > 105)) {
            event.preventDefault();
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDateSelect(event) {
        if (this.mxOnDateSelect) {
            this.mxOnDateSelect.emit(event);
        }
    }
    /**
     * @return {?}
     */
    inputClick() {
        if (!this.mxDisabled) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.iptElement.nativeElement.click();
            }), 100);
        }
    }
}
MxInputDateRangeComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-date-range',
                template: "<div class=\" form-group\" [ngClass]=\"mxDivClass\">\n  <label for=\"id\" *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\" >{{mxLabel}}</label>\n  <div class=\"input-group\">\n    <input #iptElement type=\"text\" class=\"form-control\" [ngClass]=\"mxInputClass\" [attr.disabled]=\"mxDisabled ? 'disabled' : null\"\n      bsDaterangepicker [bsConfig]=\"{adaptivePosition: true, isAnimated: true}\"\n      [(ngModel)]=\"mxModel\" [(placeholder)]=\"mxPlaceHolder\" (bsValueChange)=\"onDateSelect($event)\"  (keydown)=\"OnKeyDown($event, iptElement)\">\n      <div *ngIf=\"mxAppendIcon\" class=\"input-group-append\"><span class=\"input-group-text\" (click)=\"inputClick()\"><i class=\"{{mxAppendIcon}}\"></i></span></div>\n  </div>\n  <small id=\"idHelper\" [ngClass]=\"mxHelpClass\" *ngIf=\"mxHelp\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>\n",
                styles: [".mb-025rem{margin-bottom:.25rem}"]
            }] }
];
/** @nocollapse */
MxInputDateRangeComponent.ctorParameters = () => [
    { type: BsLocaleService }
];
MxInputDateRangeComponent.propDecorators = {
    mxModel: [{ type: Input }],
    iptElement: [{ type: ViewChild, args: ['iptElement', { read: ElementRef, static: true },] }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxPlaceHolder: [{ type: Input }],
    mxAppendIcon: [{ type: Input }],
    mxDisabled: [{ type: Input }],
    mxOnDateSelect: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxInputDateRangeComponent.prototype._mxModel;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.iptElement;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxPlaceHolder;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxAppendIcon;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxDisabled;
    /** @type {?} */
    MxInputDateRangeComponent.prototype.mxOnDateSelect;
    /**
     * @type {?}
     * @private
     */
    MxInputDateRangeComponent.prototype.localeService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputCheckBoxComponent {
    constructor() {
        this.mxModelChange = new EventEmitter();
        this.mxDivClass = '';
        this.mxTextTrue = '';
        this.mxTextFalse = '';
        this.mxReadonly = false;
        this.mxChange = new EventEmitter();
        this.mxClick = new EventEmitter();
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) { }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (this.mxClick) {
            this.mxClick.emit(event.target.value);
        }
    }
    /**
     * @return {?}
     */
    switch() {
        this.mxModel = !this.mxModel;
        if (this.mxChange) {
            this.mxChange.emit(this.mxModel);
        }
        if (this.mxClick) {
            this.mxClick.emit(this.mxModel);
        }
    }
}
MxInputCheckBoxComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-checkbox',
                template: "<div class=\"form-group\" [ngClass]=\"mxDivClass\">\n  <label for=\"id\" *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\" >{{mxLabel}}</label>\n  <div (click)=\"switch()\" class=\"switch\" [ngClass]=\"{ 'checked': mxModel }\">\n    <input type=\"checkbox\" class=\"switch-input\" [value]=\"mxModel\" [attr.checked]=\"mxModel\" >\n    <span class=\"switch-label\" [attr.data-on]=\"mxTextTrue\" [attr.data-off]=\"mxTextFalse\"></span>\n    <span class=\"switch-handle\"></span>\n  </div>\n  <!--  <input type=\"checkbox\"\n        class=\"form-check-input\"\n        id=\"id\"\n        [(ngModel)]=\"mxModel\"\n        placeholder=\"{{mxLabel}}\"\n        [readonly]=\"mxReadonly\"\n        [(ngModel)]=\"mxModel\"\n        (change)=\"onChange($event)\"\n        (blur)=\"onBlur($event)\"\n        (click)=\"onClick($event)\"\n        [(placeholder)]=\"mxLabel\"\n        (keypress)=\"onKeyPress($event)\"\n        [ngClass]=\"mxInputClass\"\n        >\n  <label for=\"id\" style=\"font-weight: bold; padding-top: 0.45rem;\"  *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\" >{{mxLabel}}</label>\n  -->\n\n</div>\n",
                styles: [".form-group{margin-bottom:0}.switch{position:relative;display:inline-block;vertical-align:top;width:100%;height:10px;cursor:pointer;overflow:visible;margin-top:7px}.switch:focus-within{outline:Highlight solid 2px}.switch-input{position:absolute;top:0;left:0;opacity:0}.switch-label{position:relative;display:block;height:inherit;font-size:16px;font-weight:400;text-transform:uppercase;background:#ccc;border-radius:20px;-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out;color:#2d2d2d}.switch-label::after,.switch-label::before{position:absolute;top:50%;margin-top:-.5em;line-height:1;-webkit-transition:inherit;transition:inherit}.switch-label::before{content:attr(data-off);right:11px;color:#fff}.switch-label::after{content:attr(data-on);left:11px;color:#fff;opacity:0}.switch-handle{position:absolute;top:50%;left:0;width:18px;height:18px;background:#fff;border-radius:10px;box-shadow:1px 1px 5px #2d2d2d;-webkit-transition:left .15s ease-out;transition:left .15s ease-out;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.checked .switch-label{background:#5799d3;box-shadow:inset 0 1px 2px rgba(255,255,255,.5),inset 0 0 3px rgba(0,0,0,.15)}.checked .switch-label::before{opacity:0}.checked .switch-label::after{opacity:1}.checked .switch-handle{left:calc(100% - 18px);box-shadow:-1px 1px 5px rgba(45,45,45,.41)}"]
            }] }
];
/** @nocollapse */
MxInputCheckBoxComponent.ctorParameters = () => [];
MxInputCheckBoxComponent.propDecorators = {
    mxModel: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxTextTrue: [{ type: Input }],
    mxTextFalse: [{ type: Input }],
    mxReadonly: [{ type: Input }],
    mxChange: [{ type: Output }],
    mxClick: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxInputCheckBoxComponent.prototype._mxModel;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxTextTrue;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxTextFalse;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxReadonly;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxChange;
    /** @type {?} */
    MxInputCheckBoxComponent.prototype.mxClick;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ParamLovModal {
    constructor() {
        this.mxLevel = 1;
    }
}
if (false) {
    /** @type {?} */
    ParamLovModal.prototype.mxEntidade;
    /** @type {?} */
    ParamLovModal.prototype.mxColumns;
    /** @type {?} */
    ParamLovModal.prototype.mxGetCount;
    /** @type {?} */
    ParamLovModal.prototype.mxGetList;
    /** @type {?} */
    ParamLovModal.prototype.mxTitle;
    /** @type {?} */
    ParamLovModal.prototype.mxAddFunction;
    /** @type {?} */
    ParamLovModal.prototype.mxLevel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputLovComponent {
    /**
     * @param {?} restService
     * @param {?} mxModalService
     * @param {?} translate
     */
    constructor(restService, mxModalService, translate) {
        this.restService = restService;
        this.mxModalService = mxModalService;
        this.translate = translate;
        this.mxKeyChange = new EventEmitter();
        this.mxDescriptionChange = new EventEmitter();
        this.mxBtnSearchClass = 'btn-info';
        this.mxRequired = false;
        // nivel da modal
        this.mxSelect = new EventEmitter();
        this.mxOnClick = new EventEmitter();
        this.mxOnBlur = new EventEmitter();
        this.mxOnFocus = new EventEmitter();
        this.modelChanged = new Subject();
        this.modelBlured = new Subject();
        this.keySelected = -1;
        this.booSelected = false;
        this.objSelected = null;
        this.registros = [];
        this.sugestaoAtivo = false;
        this.textCarregando = 'Carregando';
        this.arrDsCampo = [];
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.booExistKey = this.hasOwnProperty('_mxKey');
        }), 300);
        translate.get(this.textCarregando).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        (res) => {
            this.textCarregando = res;
        }));
        this.booExistKey = false;
        this.keySelected = -1;
        this.mxForceOnSelect = true;
        this.mxInputClass = 'text-center';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxKey(val) {
        this.mxKeyChange.emit(val);
        this._mxKey = val;
    }
    /**
     * @return {?}
     */
    get mxKey() {
        return this._mxKey;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxDescription(val) {
        this.mxDescriptionChange.emit(val);
        this._mxDescription = val;
    }
    /**
     * @return {?}
     */
    get mxDescription() {
        return this._mxDescription;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.mxFieldsView && this.mxFieldsView !== '') {
            this.arrDsCampo = this.mxFieldsView.split(',');
        }
        this.registros = [];
        this.modelChanged.pipe(debounceTime(500))
            .subscribe((/**
         * @param {?} strSearch
         * @return {?}
         */
        (strSearch) => {
            if ((strSearch) && (this.mxCdBusca || this.mxDsBusca)) {
                this.objSelected = null;
                this.booSelected = false;
                this.buscaRegistros(strSearch.target.value);
            }
        }));
        this.modelBlured.pipe(debounceTime(500))
            .subscribe((/**
         * @param {?} boo
         * @return {?}
         */
        (boo) => { this.toogleSugestao(boo); }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.modelChanged) {
            this.modelChanged.unsubscribe();
        }
        if (this.modelBlured) {
            this.modelBlured.unsubscribe();
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        // console.log( (changes.mxKey ? 'Key: ' + changes.mxKey.currentValue : '-' )  + ' ' +
        //     (changes.mxDescription ? 'Desc: ' + changes.mxDescription.currentValue : '-' ) );
        if (this.hasOwnProperty('_mxKey')) {
            if ((changes.mxKey && changes.mxKey.currentValue) && (changes.mxDescription && changes.mxDescription.currentValue)) {
                this.booSelected = true;
            }
            else {
                // this.booSelected = false;
            }
        }
        else if (changes.mxDescription && changes.mxDescription.currentValue) {
            this.booSelected = true;
        }
        else {
            // this.booSelected = false;
        }
    }
    /**
     * @return {?}
     */
    open() {
        // console.log( this.mxKey );
        /** @type {?} */
        const param = new ParamLovModal();
        param.mxEntidade = this.mxEntidade;
        param.mxColumns = this.mxColumns;
        param.mxGetCount = this.mxGetCount;
        param.mxGetList = this.mxGetList;
        param.mxTitle = this.mxTitle ? this.mxTitle : this.mxLabel;
        param.mxLevel = this.mxLevel ? Number(this.mxLevel) : 1;
        param.mxAddFunction = null;
        this.mxModalService.showLovParam(param, (/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            this.mxSelect.emit(data);
            this.booSelected = true;
            this.objSelected = data;
        }));
    }
    /**
     * @param {?} $event
     * @param {?} tipo
     * @return {?}
     */
    onTab($event, tipo) {
        // console.log('onTab');
        $event.preventDefault();
        $event.stopPropagation();
        this.onKeyInput($event, tipo);
    }
    /**
     * @param {?} $event
     * @param {?} tipoBusca
     * @return {?}
     */
    onKeyInput($event, tipoBusca) {
        // console.log( '-- onKeyInput ' + $event.type + ' code: ' + $event.code );
        // console.log( $event );
        if ((['Enter', 'NumpadEnter', 'Tab', 'ArrowUp', 'ArrowDown'].indexOf($event.code) >= 0)) {
            $event.preventDefault();
            if (this.keySelected >= 0) {
                this.onClick(this.registros[this.keySelected], false, $event);
            }
            else {
                this.onClick(null, false, $event);
            }
        }
        else {
            this.tipoBusca = tipoBusca;
            this.modelChanged.next($event);
        }
    }
    /**
     * @param {?} $event
     * @param {?} tipoBusca
     * @return {?}
     */
    onKeyUpAction($event, tipoBusca) {
        $event.preventDefault();
        // console.log( '-- onKeyUpAction ' + $event.type + ' code: ' + $event.code  );
        // console.log( $event.target.value );
        // console.log(  $event );
        if ($event.code === 'ArrowUp') {
            this.changeIndexSelected(-1);
        }
        else if ($event.code === 'ArrowDown') {
            this.changeIndexSelected(+1);
        }
        setTimeout((/**
         * @return {?}
         */
        () => {
            if ((['ArrowUp', 'ArrowDown'].indexOf($event.code) >= 0)) {
                /** @type {?} */
                const totalTexto = $event.target.value.length;
                $event.target.selectionStart = totalTexto;
                $event.target.selectionEnd = totalTexto;
            }
        }));
    }
    /**
     * @param {?} object
     * @param {?=} booSugestaoAberto
     * @param {?=} $event
     * @return {?}
     */
    onClick(object, booSugestaoAberto = false, $event) {
        // console.log( '-- onClick' );
        // console.log( $event );
        // console.log( 'booSugestaoAberto ' + booSugestaoAberto );
        this.modelBlured.next(booSugestaoAberto);
        // this.sugestaoAtivo = booSugestaoAberto;
        /** @type {?} */
        let copy = null;
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (object) {
                copy = JSON.parse(JSON.stringify(object));
                this.booSelected = true;
                this.objSelected = copy;
                // console.log( copy );
                if (this.mxOnClick.observers.length > 0) {
                    this.mxOnClick.emit(copy);
                }
                else {
                    this.mxSelect.emit(copy);
                }
            }
            else if (this.mxForceOnSelect && !this.booSelected) {
                if (this.mxOnClick.observers.length > 0) {
                    this.mxOnClick.emit({});
                }
                else {
                    this.mxSelect.emit({});
                }
                this.booSelected = false;
                this.objSelected = null;
            }
            // Muda o Foco do campo
            /** @type {?} */
            let nextInput = null;
            if ($event && (['Enter', 'NumpadEnter', 'Tab'].indexOf($event.code) >= 0)) {
                if ($event.target.id === 'mxKey') {
                    if (object) {
                        nextInput = $event.target.closest('.form-group').parentElement.nextElementSibling;
                    }
                    else {
                        nextInput = $event.target.nextElementSibling;
                    }
                }
                else {
                    nextInput = $event.target.closest('.form-group').parentElement.nextElementSibling;
                }
                // console.log( 'nextInput' );
                // console.log( nextInput );
                if (nextInput) {
                    if ((!nextInput.attributes.type) || ((['select', 'text', 'textarea']).indexOf(nextInput.attributes.type.value) < 0)) {
                        nextInput = nextInput.querySelector('select, input, textarea');
                    }
                    nextInput.focus();
                }
                else {
                    $event.target.blur();
                }
                // console.log('On blur 2');
                // this.onBlur();
            }
        }), 100);
    }
    /**
     * @return {?}
     */
    onFocus() {
        this.limpaComponente();
        this.modelBlured.next(true);
        if (this.mxOnFocus.observers.length > 0) {
            this.mxOnFocus.emit(true);
        }
    }
    /**
     * @param {?=} $event
     * @return {?}
     */
    onBlur($event) {
        this.modelBlured.next(false);
        if (this.mxOnBlur.observers.length > 0) {
            this.mxOnBlur.emit((this.objSelected ? this.objSelected : this.mxDescription));
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    changeIndexSelected(value) {
        /** @type {?} */
        const actual = this.keySelected;
        this.keySelected += value;
        if (this.keySelected <= 0) {
            this.keySelected = 0;
        }
        else if (this.keySelected >= this.registros.length - 1) {
            this.keySelected = this.registros.length - 1;
        }
        if ((actual !== this.keySelected) && // Se mudou a posição
            (this.registros.length > 0) &&
            (this.registros[this.keySelected]) && // Se existe objeto nessa chave
            (this.registros[this.keySelected][this.mxCdBusca] !== this.textCarregando + '...')) { // Não for carregando
            // Rolagem do box
            setTimeout((/**
             * @return {?}
             */
            () => {
                if (this.listHtml) {
                    /** @type {?} */
                    const liActive = this.listHtml.nativeElement.querySelector('li.active');
                    if (liActive) {
                        this.listHtml.nativeElement.scrollTop = liActive.offsetTop;
                    }
                }
            }), 100);
        }
    }
    /**
     * @param {?} show
     * @return {?}
     */
    toogleSugestao(show) {
        this.sugestaoAtivo = show;
        // console.log('toogleSugestao true ' + show);
        // console.log( this.mxForceOnSelect + ' ' + !this.booSelected );
        if (this.mxForceOnSelect && !this.booSelected) {
            this.limpaComponente(true);
        }
    }
    /**
     * @param {?} search
     * @return {?}
     */
    buscaRegistros(search) {
        // console.log( this.mxDescription );
        this.keySelected = -1;
        if (search.length > 0) {
            // console.log( 'buscaRegistros: ' + search );
            /** @type {?} */
            let filter = (this.mxGetList.indexOf('?') !== -1 ? '&' : '?') +
                'pageCurrent=1&pageSize=5&orderDir=ASC';
            if (this.mxDsBusca && (this.tipoBusca === 'dsBusca')) {
                filter += '&orderBy=' + this.mxDsBusca + '&' + this.mxDsBusca + '=' + search;
            }
            else if (this.mxCdBusca && (this.tipoBusca === 'cdBusca')) {
                filter += '&orderBy=' + this.mxCdBusca + '&' + this.mxCdBusca + '=' + search;
            }
            /** @type {?} */
            const objAux = {};
            objAux[this.mxDsBusca] = this.textCarregando + '...';
            if (this.mxCdBusca) {
                objAux[this.mxCdBusca] = '';
            }
            this.registros = [objAux];
            this.requestActive = this.restService
                .getter(this.mxEntidade, this.mxGetList, filter)
                .subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.registros = data;
                if (data.length > 0) {
                    this.changeIndexSelected(+1);
                }
            }));
        }
        else if (this.mxForceOnSelect) {
            this.limpaComponente();
            this.booSelected = false;
        }
        else {
        }
    }
    /**
     * @param {?=} full
     * @return {?}
     */
    limpaComponente(full = false) {
        // console.log('limpaComponente full=' + full);
        this.registros = [];
        this.keySelected = -1;
        if (full) {
            this.mxKey = '';
            this.mxDescription = '';
        }
    }
    /**
     * @param {?} objeto
     * @return {?}
     */
    formatarTexto(objeto) {
        if (this.mxDsView) {
            /** @type {?} */
            const args = this.arrDsCampo;
            return this.mxDsView.replace(/{(\d+)}/g, (/**
             * @param {?} match
             * @param {?} num
             * @return {?}
             */
            (match, num) => {
                return typeof args[num] !== 'undefined'
                    ? objeto[args[num]]
                    : match;
            }));
        }
        else {
            return objeto[this.mxDsBusca];
        }
    }
}
MxInputLovComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-lov',
                template: "<div class=\"form-group  position-relative\" [ngClass]=\"mxDivClass\">\n  <label *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\">{{mxLabel}}\n    <ng-container *ngIf=\"mxRequired\" >\n      <span class=\"required\">*</span>\n    </ng-container>\n  </label>\n  <div class=\"input-group input-sm\">\n    <input type=\"text\" *ngIf=\"booExistKey\" [ngClass]=\"mxInputClass\" class=\"form-control col-3\" [readonly]=\"mxReadonly\" tabindex=\"{{ (mxReadonly) ? -1 : mxTabindex }}\"\n        [(ngModel)]=\"mxKey\" id=\"mxKey\" (focus)=\"onFocus()\" (blur)=\"onBlur($event)\"\n        (keydown.tab)=\"onTab($event, (mxCdBusca ? 'cdBusca' : 'dsBusca') ); false\"\n        (keydown.enter)=\"onTab($event, (mxCdBusca ? 'cdBusca' : 'dsBusca') ); false\"\n        (input)=\"onKeyInput($event, (mxCdBusca ? 'cdBusca' : 'dsBusca') )\"\n        (keyup)=\"onKeyUpAction($event, (mxCdBusca ? 'cdBusca' : 'dsBusca') )\">\n\n      <input type=\"text\" #mxInputElement [ngClass]=\"'form-control '+ (booExistKey ? 'col-9' : 'col-12 ' + mxInputClass)\" [readonly]=\"mxReadonly\" tabindex=\"{{ (mxReadonly) ? -1 : mxTabindex }}\"\n        [(ngModel)]=\"mxDescription\" (focus)=\"onFocus()\" (blur)=\"onBlur($event)\"  #dsBusca\n        (keydown.tab)=\"onTab($event, 'dsBusca'); false\"\n        (keydown.enter)=\"onTab($event, 'dsBusca'); false\"\n        (input)=\"onKeyInput($event, 'dsBusca')\"\n        (keyup)=\"onKeyUpAction($event, 'dsBusca')\">\n    <div class=\"input-group-append\">\n      <button class=\"btn {{mxBtnSearchClass}}\" (click)=\"open()\" title=\"Buscar registros\" [disabled]=\"mxDisabled\" >\n        <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n  </div>\n  <div [ngClass]=\"{'lista_opcoes': true, 'open': sugestaoAtivo && registros.length>0}\" #listHtml>\n    <ul class=\"list-unstyled\">\n      <li *ngFor=\"let item of registros; let idx = index\" [ngClass]=\"{'active': idx==keySelected}\">\n        <a class=\"btn btn-default d-block\" (click)=\"onClick(item, false, dsBusca)\">{{ ((mxCdBusca && item[mxCdBusca] !== 'undefined') ? item[mxCdBusca] + ' - ' : '') }}{{ formatarTexto(item) }}</a>\n      </li>\n    </ul>\n  </div>\n  <small id=\"idHelper\" [ngClass]=\"mxHelpClass\" *ngIf=\"mxHelp\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>\n",
                styles: [".lista_opcoes{display:none;position:absolute;top:50px;width:100%;height:150px;background-color:#fff;border:1px solid #ccc;overflow-y:auto;border-top:0;z-index:10000}.lista_opcoes.open{display:block}.lista_opcoes ul li a{display:block;border-radius:0;text-align:left}.lista_opcoes ul li a:hover,.lista_opcoes ul li.active a{background-color:#5799d3;color:#fff}"]
            }] }
];
/** @nocollapse */
MxInputLovComponent.ctorParameters = () => [
    { type: MxBaseRestService },
    { type: MxModalService },
    { type: TranslateService }
];
MxInputLovComponent.propDecorators = {
    listHtml: [{ type: ViewChild, args: ['listHtml', { read: ElementRef, static: true },] }],
    mxInputElement: [{ type: ViewChild, args: ['mxInputElement', { read: ElementRef, static: false },] }],
    mxKey: [{ type: Input }],
    mxKeyChange: [{ type: Output }],
    mxDescription: [{ type: Input }],
    mxDescriptionChange: [{ type: Output }],
    mxEntidade: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxTitle: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxColumns: [{ type: Input }],
    mxGetCount: [{ type: Input }],
    mxGetList: [{ type: Input }],
    mxReadonly: [{ type: Input }],
    mxDisabled: [{ type: Input }],
    mxBtnSearchClass: [{ type: Input }],
    mxTabindex: [{ type: Input }],
    mxCdBusca: [{ type: Input }],
    mxDsBusca: [{ type: Input }],
    mxForceOnSelect: [{ type: Input }],
    mxInputClass: [{ type: Input }],
    mxRequired: [{ type: Input }],
    mxLevel: [{ type: Input }],
    mxSelect: [{ type: Output }],
    mxOnClick: [{ type: Output }],
    mxOnBlur: [{ type: Output }],
    mxOnFocus: [{ type: Output }],
    mxDsView: [{ type: Input }],
    mxFieldsView: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxInputLovComponent.prototype.listHtml;
    /** @type {?} */
    MxInputLovComponent.prototype.mxInputElement;
    /** @type {?} */
    MxInputLovComponent.prototype._mxKey;
    /** @type {?} */
    MxInputLovComponent.prototype.booExistKey;
    /** @type {?} */
    MxInputLovComponent.prototype.mxKeyChange;
    /** @type {?} */
    MxInputLovComponent.prototype._mxDescription;
    /** @type {?} */
    MxInputLovComponent.prototype.mxDescriptionChange;
    /** @type {?} */
    MxInputLovComponent.prototype.mxEntidade;
    /** @type {?} */
    MxInputLovComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputLovComponent.prototype.mxTitle;
    /** @type {?} */
    MxInputLovComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputLovComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputLovComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputLovComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputLovComponent.prototype.mxColumns;
    /** @type {?} */
    MxInputLovComponent.prototype.mxGetCount;
    /** @type {?} */
    MxInputLovComponent.prototype.mxGetList;
    /** @type {?} */
    MxInputLovComponent.prototype.mxReadonly;
    /** @type {?} */
    MxInputLovComponent.prototype.mxDisabled;
    /** @type {?} */
    MxInputLovComponent.prototype.mxBtnSearchClass;
    /** @type {?} */
    MxInputLovComponent.prototype.mxTabindex;
    /** @type {?} */
    MxInputLovComponent.prototype.mxCdBusca;
    /** @type {?} */
    MxInputLovComponent.prototype.mxDsBusca;
    /** @type {?} */
    MxInputLovComponent.prototype.mxForceOnSelect;
    /** @type {?} */
    MxInputLovComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputLovComponent.prototype.mxRequired;
    /** @type {?} */
    MxInputLovComponent.prototype.mxLevel;
    /** @type {?} */
    MxInputLovComponent.prototype.mxSelect;
    /** @type {?} */
    MxInputLovComponent.prototype.mxOnClick;
    /** @type {?} */
    MxInputLovComponent.prototype.mxOnBlur;
    /** @type {?} */
    MxInputLovComponent.prototype.mxOnFocus;
    /** @type {?} */
    MxInputLovComponent.prototype.modelChanged;
    /** @type {?} */
    MxInputLovComponent.prototype.modelBlured;
    /** @type {?} */
    MxInputLovComponent.prototype.keySelected;
    /** @type {?} */
    MxInputLovComponent.prototype.booSelected;
    /** @type {?} */
    MxInputLovComponent.prototype.objSelected;
    /** @type {?} */
    MxInputLovComponent.prototype.registros;
    /** @type {?} */
    MxInputLovComponent.prototype.sugestaoAtivo;
    /** @type {?} */
    MxInputLovComponent.prototype.textCarregando;
    /** @type {?} */
    MxInputLovComponent.prototype.tipoBusca;
    /** @type {?} */
    MxInputLovComponent.prototype.requestActive;
    /** @type {?} */
    MxInputLovComponent.prototype.mxDsView;
    /** @type {?} */
    MxInputLovComponent.prototype.mxFieldsView;
    /** @type {?} */
    MxInputLovComponent.prototype.arrDsCampo;
    /**
     * @type {?}
     * @private
     */
    MxInputLovComponent.prototype.restService;
    /**
     * @type {?}
     * @private
     */
    MxInputLovComponent.prototype.mxModalService;
    /** @type {?} */
    MxInputLovComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxSelectDualListComponent {
    constructor() {
        this.mxModelChange = new EventEmitter();
        this.mxKey = 'id';
        this.mxHeight = 100;
        this.format = {
            add: 'Adicionar', remove: 'Remover', all: 'Todos', none: 'Nenhum',
            direction: DualListComponent.LTR, draggable: true, locale: 'pt-br', filter: false
        };
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
MxSelectDualListComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-select-dual-list',
                template: "<div>\n  <h4>{{mxTitle}}</h4>\n  <dual-list [source]=\"mxList\" [key]=\"mxKey\" [display]=\"mxDisplay\" [(destination)]=\"mxModel\" [format]=\"format\" [height]=\"mxHeight\"></dual-list>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MxSelectDualListComponent.ctorParameters = () => [];
MxSelectDualListComponent.propDecorators = {
    mxModel: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxTitle: [{ type: Input }],
    mxList: [{ type: Input }],
    mxDisplay: [{ type: Input }],
    mxKey: [{ type: Input }],
    mxHeight: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxSelectDualListComponent.prototype._mxModel;
    /** @type {?} */
    MxSelectDualListComponent.prototype.mxModelChange;
    /** @type {?} */
    MxSelectDualListComponent.prototype.mxTitle;
    /** @type {?} */
    MxSelectDualListComponent.prototype.mxList;
    /** @type {?} */
    MxSelectDualListComponent.prototype.mxDisplay;
    /** @type {?} */
    MxSelectDualListComponent.prototype.mxKey;
    /** @type {?} */
    MxSelectDualListComponent.prototype.mxHeight;
    /** @type {?} */
    MxSelectDualListComponent.prototype.format;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const ColumnTypes = {
    BOOLEAN: 0, INTEGER: 1, STRING: 2, DATE: 3, DATETIME: 4, CURRENCY: 5, DOUBLE: 6, COMPLEX: 7, MILHAR: 8, MOEDA: 9, CUSTOM: 10, ENUM: 11,
};
ColumnTypes[ColumnTypes.BOOLEAN] = 'BOOLEAN';
ColumnTypes[ColumnTypes.INTEGER] = 'INTEGER';
ColumnTypes[ColumnTypes.STRING] = 'STRING';
ColumnTypes[ColumnTypes.DATE] = 'DATE';
ColumnTypes[ColumnTypes.DATETIME] = 'DATETIME';
ColumnTypes[ColumnTypes.CURRENCY] = 'CURRENCY';
ColumnTypes[ColumnTypes.DOUBLE] = 'DOUBLE';
ColumnTypes[ColumnTypes.COMPLEX] = 'COMPLEX';
ColumnTypes[ColumnTypes.MILHAR] = 'MILHAR';
ColumnTypes[ColumnTypes.MOEDA] = 'MOEDA';
ColumnTypes[ColumnTypes.CUSTOM] = 'CUSTOM';
ColumnTypes[ColumnTypes.ENUM] = 'ENUM';
class ColumnModel {
    /**
     * @param {?=} $title
     * @param {?=} $name
     */
    constructor($title, $name) {
        this.type = ColumnTypes.STRING;
        this.title = $title || '';
        this.name = $name || '';
    }
}
if (false) {
    /** @type {?} */
    ColumnModel.prototype.title;
    /** @type {?} */
    ColumnModel.prototype.name;
    /** @type {?} */
    ColumnModel.prototype.style;
    /** @type {?} */
    ColumnModel.prototype.customFields;
    /** @type {?} */
    ColumnModel.prototype.filter;
    /** @type {?} */
    ColumnModel.prototype.columnSelect;
    /** @type {?} */
    ColumnModel.prototype.orderDir;
    /** @type {?} */
    ColumnModel.prototype.type;
    /** @type {?} */
    ColumnModel.prototype.enumValues;
    /** @type {?} */
    ColumnModel.prototype.transformCustomValue;
}
/**
 * @record
 */
function IdNumberAndDescription() { }
if (false) {
    /** @type {?} */
    IdNumberAndDescription.prototype.id;
    /** @type {?} */
    IdNumberAndDescription.prototype.description;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
defineLocale('pt-br', ptBrLocale);
class MxDataTablePaginatorComponent {
    /**
     * @param {?} restService
     * @param {?} alert
     * @param {?} localeService
     */
    constructor(restService, alert, localeService) {
        this.restService = restService;
        this.alert = alert;
        this.localeService = localeService;
        this.mxPageSize = 15;
        this.showBtEdit = true;
        this.classContainer = 'container-fluid';
        this.mxClassTable = 'table table-bordered table-sm m-0';
        this.mxRefresh = new EventEmitter();
        this.mxOnSelect = new EventEmitter();
        this.mxOnNew = new EventEmitter();
        this.mxOnDelete = new EventEmitter();
        this.mxOnClick = new EventEmitter();
        this.mxShowFilter = true;
        this.mxIsActionBack = false;
        this.mxOnBack = new EventEmitter();
        this.registros = [];
        this.pagSelect = 1;
        this.total = 0;
        this.totPag = 0;
        this.loading = false;
        this.colType = ColumnTypes;
        this.isOpen = false;
        this.localeService.use('pt-br');
        this.btSelectIcon = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // if (!this.mxOrderBy) {
        //   const col = this.mxColumns[0];
        //   col.orderDir = 'desc';
        //   this.mxOrderBy = this.mxColumns[0];
        // }
        if (this.mxRefresh) {
            this.mxRefresh.subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.filter();
            }));
        }
        this.filter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.mxRefresh.unsubscribe();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.mxEntidade && changes.mxEntidade.previousValue) {
            this.ngOnInit();
        }
    }
    /**
     * @return {?}
     */
    next() {
        this.go(Number(this.pagSelect) + 1);
    }
    /**
     * @return {?}
     */
    previous() {
        this.go(Number(this.pagSelect) - 1);
    }
    /**
     * @param {?} page
     * @return {?}
     */
    go(page) {
        this.pagSelect = page;
        this.filter();
    }
    /**
     * @param {?} path
     * @param {?} obj
     * @return {?}
     */
    resolve(path, obj) {
        /** @type {?} */
        let objRetorno = '';
        if (path.indexOf('+') > -1) {
            /** @type {?} */
            const arr = path.split('+');
            arr.forEach((/**
             * @param {?} elem
             * @return {?}
             */
            elem => {
                if (elem.indexOf('.') > -1) {
                    objRetorno += (objRetorno !== '' ? ' ' : '') + elem.split('.').reduce((/**
                     * @param {?} prev
                     * @param {?} curr
                     * @return {?}
                     */
                    (prev, curr) => {
                        return (prev && prev.hasOwnProperty(curr)) ? prev[curr] : '';
                    }), obj);
                }
                else {
                    objRetorno += (objRetorno !== '' ? ' ' : '') + obj[elem];
                }
            }));
        }
        else {
            if (path.indexOf('.') > -1) {
                objRetorno += path.split('.').reduce((/**
                 * @param {?} prev
                 * @param {?} curr
                 * @return {?}
                 */
                (prev, curr) => {
                    return (prev && prev.hasOwnProperty(curr)) ? prev[curr] : '';
                }), obj);
            }
            else {
                objRetorno += obj[path];
            }
        }
        return objRetorno;
    }
    /**
     * @param {?} str
     * @return {?}
     */
    transformMilhar(str) {
        return ((Math.abs(Number(str))).toLocaleString('en')).split(',').join('.');
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    filterDate(evt) {
        this.filter();
    }
    /**
     * @return {?}
     */
    filter() {
        if (!this.mxColumns) {
            console.error('As colunas devem ser informadas!');
            return;
        }
        /** @type {?} */
        let filters = '';
        for (const c of this.mxColumns) {
            if (c.filter && c.type !== ColumnTypes.DATE) {
                filters += c.name + '=' + c.filter + '&';
            }
            else if (c.filter && c.type === ColumnTypes.DATE) {
                filters += c.name + '=' + new Date(c.filter[0]).getTime() + ',' + new Date(c.filter[1]).getTime() + '&';
            }
        }
        if (this.mxGetCount) {
            this.loading = true;
            this.restService
                .getter(this.mxEntidade, this.mxGetCount, (this.mxGetCount.indexOf('?') !== -1 ? '&' : '?') + filters)
                .subscribe((/**
             * @param {?} dataCount
             * @return {?}
             */
            dataCount => {
                this.total = dataCount;
                if (this.total === 0) {
                    this.loading = false;
                    this.pagSelect = 1;
                    this.registros = [];
                    if (this.mxTotais && this.actionTotais) {
                        for (const elem of this.mxTotais) {
                            elem.value = '';
                        }
                    }
                    return;
                }
                /** @type {?} */
                const filter = (this.mxGetList.indexOf('?') !== -1 ? '&' : '?') +
                    'pageCurrent=' +
                    this.pagSelect +
                    '&pageSize=' +
                    this.mxPageSize +
                    ((this.mxOrderBy) ?
                        '&orderBy=' + this.mxOrderBy.name +
                            '&orderDir=' + ((this.mxOrderBy.orderDir) ? this.mxOrderBy.orderDir : 'ASC') : '') +
                    '&' + filters;
                this.restService
                    .getter(this.mxEntidade, this.mxGetList, filter)
                    .subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                data => {
                    this.registros = data;
                    this.loading = false;
                    this.setaFoco();
                    if (this.mxTotais && this.actionTotais) {
                        this.restService
                            .getter(this.mxEntidade, this.actionTotais, filter)
                            .subscribe((/**
                         * @param {?} dtTot
                         * @return {?}
                         */
                        dtTot => {
                            for (const elem of this.mxTotais) {
                                elem.value = dtTot[elem.name];
                            }
                        }));
                    }
                }));
            }));
        }
        else {
            this.loading = true;
            /** @type {?} */
            const filter = (this.mxGetList.indexOf('?') !== -1 ? '&' : '?') +
                'pageCurrent=' + this.pagSelect + '&pageSize=' + this.mxPageSize +
                ((this.mxOrderBy) ?
                    '&orderBy=' + this.mxOrderBy.name +
                        '&orderDir=' + ((this.mxOrderBy.orderDir) ? this.mxOrderBy.orderDir : 'ASC') : '') +
                '&' + filters;
            this.restService
                .getter(this.mxEntidade, this.mxGetList, filter)
                .subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.registros = data;
                this.total = this.registros.length;
                this.setaFoco();
                if (this.mxTotais && this.actionTotais) {
                    this.restService
                        .getter(this.mxEntidade, this.actionTotais, filter)
                        .subscribe((/**
                     * @param {?} dtTot
                     * @return {?}
                     */
                    dtTot => {
                        for (const elem of this.mxTotais) {
                            elem.value = dtTot[elem.name];
                        }
                    }));
                }
                this.loading = false;
            }));
        }
    }
    /**
     * @return {?}
     */
    setaFoco() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (this.tableElm) {
                /** @type {?} */
                const elFocus = this.tableElm.nativeElement.querySelector('input.focus_element');
                if (elFocus) {
                    elFocus.focus();
                }
            }
        }), 500);
    }
    /**
     * @param {?} registro
     * @return {?}
     */
    select(registro) {
        this.mxOnSelect.emit(registro);
    }
    /**
     * @param {?} reg
     * @return {?}
     */
    remove(reg) {
        if (!this.mxOnDelete) {
            if (confirm('Remover o Registro?')) {
                this.restService.delete(this.mxEntidade, reg.id).subscribe((/**
                 * @param {?} val
                 * @return {?}
                 */
                val => {
                    this.alert.add('success', 'Removido com Sucesso', 'success');
                }));
            }
        }
        else {
            this.mxOnDelete.emit(reg);
        }
    }
    /**
     * @return {?}
     */
    novo() {
        this.mxOnNew.emit('');
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isBoolean(value) {
        if (value && (value.toString() === 'true' || value.toString() === 'false')) {
            return true;
        }
        if (typeof (value) === 'boolean') {
            return true;
        }
        return false;
    }
    /**
     * @param {?} col
     * @return {?}
     */
    setOrderDir(col) {
        this.mxOrderBy = col;
        if ('asc' === this.mxOrderBy.orderDir) {
            this.mxOrderBy.orderDir = 'desc';
        }
        else {
            this.mxOrderBy.orderDir = 'asc';
        }
        this.filter();
    }
    /**
     * @param {?} event
     * @param {?} idx
     * @return {?}
     */
    onValueChange(event, idx) {
        if (event && event[0] && event[1]) {
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (this.mxOnClick && (this.mxOnClick.observers.length > 0)) {
            this.mxOnClick.emit(event);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClickBack(event) {
        if (this.mxIsActionBack && this.mxOnBack && this.mxOnBack.observers.length > 0) {
            this.mxOnBack.emit(event);
        }
        else {
            window.history.go(-1);
        }
    }
    /**
     * @return {?}
     */
    linhaSelect() {
        if (this.mxOnClick && (this.mxOnClick.observers.length > 0)) {
            return true;
        }
        return false;
    }
}
MxDataTablePaginatorComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-data-table-paginator',
                template: "<div [ngClass]=\"classContainer\">\n  <div *ngIf=\"loading\" class=\"row mb-3 text-center\" style=\"height: calc(100vh - 250px); overflow: auto\">\n    <span>\n      <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n      {{'Carregando' | translate }}</span>\n  </div>\n  <div *ngIf=\"!loading\" [ngClass]=\"{'row mb-3':true, 'table_mini': mxIsActionBack, 'table_full': !mxIsActionBack}\">\n    <table *ngIf=\"!loading\" aria-describedby=\"table\" [class]=\"mxClassTable\" #tableElm>\n      <thead>\n        <tr style=\"font-weight: bold;\">\n          <th id=\"{{c.title}}\" *ngFor=\"let c of mxColumns; let idx = index\" style=\"cursor: pointer;\"\n            class=\"text-center\">\n            <span (click)=\"setOrderDir(c)\" class=\"d-block\">\n              {{c.title |translate }}\n              <i *ngIf=\"mxOrderBy && mxOrderBy.name===c.name\" class=\"float-right fa\"\n                [ngClass]=\"{'fa-sort-desc':mxOrderBy.orderDir ==='desc','fa-sort-asc':mxOrderBy.orderDir==='asc'}\"></i>\n            </span>\n            <ng-container *ngIf=\"mxShowFilter === true\">\n              <input *ngIf=\" c.type && c.type !== colType.DATE && c.type !== colType.BOOLEAN\" [(ngModel)]=\"c.filter\"\n                (change)=\"filter()\" [ngClass]=\"{'form-control input-sm': true, 'focus_element': idx===0}\"\n                style=\"height: 18px; font-size: 0.8rem;\">\n              <input type=\"checkbox\" *ngIf=\" c.type && c.type === colType.BOOLEAN\" [(ngModel)]=\"c.filter\"\n                (change)=\"filter()\" />\n              <input [attr.id]=\"c.name\" class=\"form-control input-sm\" *ngIf=\" c.type && c.type === colType.DATE\"\n                style=\"height: 18px; font-size: 0.8rem;\" bsDaterangepicker\n                [bsConfig]=\"{adaptivePosition: true, isAnimated: true}\" [(ngModel)]=\"c.filter\" />\n            </ng-container>\n          </th>\n          <th id=\"thBtnaction\" class=\"text-center\" *ngIf=\"showBtEdit || showBtNew || showBtRemove\">\n            <span class=\"d-inline-block\">\n              <button (click)=\"filter()\" class=\"btn btn-primary btn-sm btn-xs mr-1\">\n                <em class=\"fa  fa-refresh\" aria-hidden=\"true\"></em> </button>\n              <button (click)=\"novo()\" class=\"btn btn-success btn-sm  btn-xs\" *ngIf=\"showBtNew\">\n                <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n              </button>\n            </span>\n            <span>\n\n            </span>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let reg of registros; let idx = index\" class=\"linha\">\n          <!-- [ngClass]=\"{'linhaClick': linhaSelect(), 'text-center': isBoolean(reg[c.name]), c.style}\" -->\n          <td *ngFor=\"let c of mxColumns\" (click)=\"onClick(reg)\"\n            class=\"{{ (linhaSelect() ? ' linhaClick ' : '') + (isBoolean(reg[c.name]) ? ' text-center ' : (c.style ? c.style : '')) }}\">\n            <span *ngIf=\"!c.type && !isBoolean(reg[c.name])\">\n              {{reg[c.name]}}\n            </span>\n            <span *ngIf=\"isBoolean(reg[c.name])\">\n              <img *ngIf=\"reg[c.name] === true\" alt=\"\" src=\"assets/true.png\">\n              <img *ngIf=\"reg[c.name] === false\" alt=\"\" src=\"assets/false.png\">\n            </span>\n            <span *ngIf=\"!isBoolean(reg[c.name]) && c.type !== colType.COMPLEX\">\n              <label *ngIf=\"c.type === colType.CURRENCY\">{{resolve(c.name, reg) | currency: 'BRL'}}</label>\n              <label *ngIf=\"c.type === colType.INTEGER\">{{resolve(c.name, reg) | number: '0'}}</label>\n              <label *ngIf=\"c.type === colType.DOUBLE\">{{resolve(c.name, reg) | number: '2'}}</label>\n              <!-- <label *ngIf=\"c.type === colType.INTEGER\">{{resolve(c.name, reg) | number}}</label> -->\n              <label *ngIf=\"c.type === colType.DATE\">{{resolve(c.name, reg) | date: 'dd/MM/yyyy'}}</label>\n              <label *ngIf=\"c.type === colType.DATETIME\">{{resolve(c.name, reg) | date: 'dd/MM/yyyy HH:mm:ss'}}</label>\n              <label *ngIf=\"c.type === colType.STRING\">{{resolve(c.name, reg)}}</label>\n              <label *ngIf=\"c.type === colType.MILHAR\">{{transformMilhar(resolve(c.name, reg))}}</label>\n              <label *ngIf=\"c.type === colType.MOEDA\">{{resolve(c.name, reg) | number : '1.2-2'}}</label>\n            </span>\n          </td>\n          <td class=\"text-center action_buttons\" *ngIf=\"showBtEdit  || showBtNew  || showBtRemove\">\n            <div class=\"d-block\">\n              <button (click)=\"select(reg)\" style=\"line-height: 0 !important\" class=\"btn btn-primary btn-sm mr-1\"\n                title=\"Edit\" *ngIf=\"showBtEdit\">\n                <em class=\"fa\" [ngClass]=\"{'fa-check': btSelectIcon===true , 'fa-edit': btSelectIcon===false}\"></em>\n              </button>\n              <button (click)=\"remove(reg)\" style=\"line-height: 0 !important\" *ngIf=\"!btSelectIcon && showBtRemove\"\n                title=\"Remove\" class=\"btn btn-danger btn-sm\">\n                <em class=\"fa fa-trash\"></em>\n              </button>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n      <tfoot *ngIf=\"mxTotais\">\n        <tr>\n          <td *ngFor=\"let c of mxColumns\">\n            <ng-container *ngFor=\"let reg of mxTotais; let idx = index\">\n              <span class=\"badge\"\n                [ngClass]=\"{'badge-danger': reg.value < 0, 'badge-success': reg.value > 0, 'badge-secondary': reg.value === 0}\"\n                *ngIf=\"c.name===reg.name\">{{reg.value | currency: 'BRL'}}</span>\n            </ng-container>\n          </td>\n        </tr>\n      </tfoot>\n    </table>\n  </div>\n  <footer id=\"sticky-footer\" class=\"py-1  \" style=\"padding: 0\">\n    <div class=\"row flex space-between align-items-center\">\n      <div class=\"col-md-2\">\n        <h6 class=\"m-0\"><span class=\"badge badge-info\">Total:</span> {{total}} </h6>\n      </div>\n      <div class=\"col-md-8\">\n        <pagination *ngIf=\"mxGetCount\" [totalItems]=\"total\" (ngModel)=\"pagSelect\" (pageChanged)=\"go($event.page)\"\n          [maxSize]=\"5\" class=\"mt-1 mb-1\" (numPages)=\"totPag\" [boundaryLinks]=\"true\" [itemsPerPage]=\"mxPageSize\"\n          [rotate]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\">\n        </pagination>\n      </div>\n      <div class=\"col-md-2 text-right\">\n        <a class=\"btn btn-outline-info btn-sm\" (click)=\"onClickBack($event)\">\n          <em class=\"fa fa-undo mr-2\"></em>\n          {{ 'Voltar' | translate}}\n        </a>\n      </div>\n    </div>\n  </footer>\n</div>",
                styles: [".footer{text-align:center;width:100%;background-color:#e9ecef}.total{float:left;font-size:1em;font-weight:700}.linha:hover{background-color:#d3d3d3}.linhaClick{cursor:pointer}pagination>ul{margin-bottom:.25rem!important}.table_mini{height:calc(100vh - 250px);overflow:auto}.table_full{height:auto;min-height:300px;padding:15px 8px;background-color:#e6e6f0;color:#000}.table td,.table th{min-width:60px;white-space:nowrap}"]
            }] }
];
/** @nocollapse */
MxDataTablePaginatorComponent.ctorParameters = () => [
    { type: MxBaseRestService },
    { type: MxAlertService },
    { type: BsLocaleService }
];
MxDataTablePaginatorComponent.propDecorators = {
    tableElm: [{ type: ViewChild, args: ['tableElm', { read: ElementRef, static: false },] }],
    mxEntidade: [{ type: Input }],
    mxGetCount: [{ type: Input }],
    mxGetList: [{ type: Input }],
    actionTotais: [{ type: Input }],
    mxColumns: [{ type: Input }],
    mxTotais: [{ type: Input }],
    mxPageSize: [{ type: Input }],
    mxOrderBy: [{ type: Input }],
    btSelectIcon: [{ type: Input }],
    showBtRemove: [{ type: Input }],
    showBtNew: [{ type: Input }],
    showBtEdit: [{ type: Input }],
    classContainer: [{ type: Input }],
    mxClassTable: [{ type: Input }],
    mxRefresh: [{ type: Input }],
    mxOnSelect: [{ type: Output }],
    mxOnNew: [{ type: Output }],
    mxOnDelete: [{ type: Output }],
    mxOnClick: [{ type: Output }],
    mxShowFilter: [{ type: Input }],
    mxIsActionBack: [{ type: Input }],
    mxOnBack: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.tableElm;
    /**
     * @type {?}
     * @private
     */
    MxDataTablePaginatorComponent.prototype.mxEntidade;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxGetCount;
    /**
     * @type {?}
     * @private
     */
    MxDataTablePaginatorComponent.prototype.mxGetList;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.actionTotais;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxColumns;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxTotais;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxPageSize;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxOrderBy;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.btSelectIcon;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.showBtRemove;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.showBtNew;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.showBtEdit;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.classContainer;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxClassTable;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxRefresh;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxOnSelect;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxOnNew;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxOnDelete;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxOnClick;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxShowFilter;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxIsActionBack;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.mxOnBack;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.registros;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.pagSelect;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.total;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.totPag;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.loading;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.colType;
    /** @type {?} */
    MxDataTablePaginatorComponent.prototype.isOpen;
    /**
     * @type {?}
     * @private
     */
    MxDataTablePaginatorComponent.prototype.restService;
    /**
     * @type {?}
     * @private
     */
    MxDataTablePaginatorComponent.prototype.alert;
    /**
     * @type {?}
     * @private
     */
    MxDataTablePaginatorComponent.prototype.localeService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function routerTransition() {
    return noTransition();
}
/**
 * @return {?}
 */
function noTransition() {
    return trigger('routerTransition', []);
}
/**
 * @return {?}
 */
function slideToRight() {
    return trigger('routerTransition', [
        state('void', style({})),
        state('*', style({})),
        transition(':enter', [
            style({ transform: 'translateX(-100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
        ])
    ]);
}
/**
 * @return {?}
 */
function slideToLeft() {
    return trigger('routerTransition', [
        state('void', style({})),
        state('*', style({})),
        transition(':enter', [
            style({ transform: 'translateX(100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
        ])
    ]);
}
/**
 * @return {?}
 */
function slideToBottom() {
    return trigger('routerTransition', [
        state('void', style({})),
        state('*', style({})),
        transition(':enter', [
            style({ transform: 'translateY(-100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateY(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' }))
        ])
    ]);
}
/**
 * @return {?}
 */
function slideToTop() {
    return trigger('routerTransition', [
        state('void', style({})),
        state('*', style({})),
        transition(':enter', [
            style({ transform: 'translateY(100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateY(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(-100%)' }))
        ])
    ]);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxDataTableComponent {
    /**
     * @param {?} restService
     * @param {?} route
     * @param {?} router
     */
    constructor(restService, route, router) {
        this.restService = restService;
        this.route = route;
        this.router = router;
        this.pageSize = 15;
        this.colType = ColumnTypes;
        this.orderBy = 'id';
        this.showBtnAdd = true;
        this.loading = false;
        this.registers = [];
        this.pagSelect = 1;
        this.total = 0;
        this.totPag = 0;
        this.subListClosed = true;
        this.showFilter = true;
        this.selected = -1;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.columns || !this.resource) {
            throw new TypeError('Properties \'columns\' and \'resource\' are required');
        }
        if (this.subListName && this.subListName.length > 0) {
            /** @type {?} */
            const col = new ColumnModel();
            col.name = 'toggler';
            col.style = ['text-center', 'custWidth'];
            col.type = ColumnTypes.COMPLEX;
            this.columns.unshift(col);
        }
        this.subsQParam = this.route.queryParams.subscribe((/**
         * @param {?} queryParams
         * @return {?}
         */
        (queryParams) => {
            this.pagSelect =
                queryParams.pagSelect == null ? 1 : queryParams.pagSelect;
            this.pageSize =
                queryParams.pageSize == null ? this.pageSize : queryParams.pageSize;
            this.orderBy = queryParams.orderBy == null ? 'id' : queryParams.orderBy;
            this.filter();
        }));
    }
    /**
     * @return {?}
     */
    next() {
        this.go(Number(this.pagSelect) + 1);
    }
    /**
     * @return {?}
     */
    previous() {
        this.go(Number(this.pagSelect) - 1);
    }
    /**
     * @param {?} page
     * @return {?}
     */
    go(page) {
        this.router.navigate(['/', this.resource], {
            queryParams: {
                pagSelect: page,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            }
        });
    }
    /**
     * @return {?}
     */
    filter() {
        /** @type {?} */
        let found = false;
        for (const col of this.columns) {
            if (col.columnSelect === this.orderBy || col.name === this.orderBy) {
                found = true;
                break;
            }
        }
        if (!found) {
            for (const col of this.columns) {
                if (col.columnSelect) {
                    this.orderBy = col.columnSelect;
                    break;
                }
                else if (col.name) {
                    this.orderBy = col.name;
                    break;
                }
            }
        }
        this.loading = true;
        /** @type {?} */
        const filters = [];
        for (const c of this.columns) {
            if (c.filter) {
                filters.push({
                    filtro: c.filter,
                    condicao: 'AND',
                    operacao: 'like',
                    campo: c.columnSelect ? c.columnSelect : c.name
                });
            }
        }
        /** @type {?} */
        const filter = '?pageCurrent=' +
            this.pagSelect +
            '&pageSize=' +
            this.pageSize +
            '&orderBy=' +
            this.orderBy +
            '&' +
            filters;
        this.restService
            .getter(this.resource, this.action, filter)
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        result => {
            this.registers = result.data;
            this.total = result.total;
            this.loading = false;
            this.registers.forEach((/**
             * @param {?} element
             * @return {?}
             */
            element => {
                if (this.subListName) {
                    this.subList = element[this.subListName];
                }
            }));
        }));
    }
    /**
     * @param {?} id
     * @return {?}
     */
    select(id) {
        this.router.navigate(['/add', this.resource, id]);
    }
    /**
     * @return {?}
     */
    add() {
        this.router.navigate(['/add', this.resource, 0]);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subsQParam.unsubscribe();
        this.registers = [];
        this.columns = [];
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isBoolean(value) {
        if (value !== null &&
            value !== undefined &&
            (value === true || value === false)) {
            return true;
        }
        return false;
    }
    /**
     * @param {?} col
     * @param {?} reg
     * @return {?}
     */
    checkToggler(col, reg) {
        if (col.name === 'toggler' &&
            col.type === this.colType.COMPLEX &&
            reg[this.subListName] &&
            reg[this.subListName].length > 0) {
            return true;
        }
        return false;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    getBtClass(val) {
        return !val ? 'fa fa-arrow-circle-down' : 'fa fa-arrow-circle-right';
    }
    /**
     * @param {?} index
     * @return {?}
     */
    composeSubList(index) {
        if (index === this.selected) {
            this.selected = -1;
            return;
        }
        this.selected = index;
    }
}
MxDataTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-data-table',
                template: "<div *ngIf=\"loading\"  class=\"row mb-3\" style=\"height: calc(100vh - 205px); overflow: auto\">\n  <span>\n  <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n  {{'Carregando'}}</span>\n</div>\n<div *ngIf=\"!loading\" class=\"row mb-3\" style=\"height: calc(100vh - 205px); overflow: auto\">\n  <table *ngIf=\"!loading\" class=\"table table-bordered table-striped table-hover table-sm m-0\" aria-describedby=\"table\">\n      <thead>\n          <tr style=\"font-weight: bold;\">\n              <th id=\"{{c.title}}\" *ngFor=\"let c of columns\" [ngClass]=\"c.style\">\n                  {{c.title}}\n                  <br/>\n                  <input *ngIf=\"(!c.type && c.type !==  colType.BOOLEAN) && showFilter\" [(ngModel)]=\"c.filter\" class=\"form-control input-sm\" style=\"height: 18px; font-size: 0.8rem;\" (change)=\"filter()\">\n                  <input type=\"checkbox\" *ngIf=\"c.type ===  colType.BOOLEAN && showFilter\" [(ngModel)]=\"c.filter\" (change)=\"filter()\"/>\n              </th>\n              <th id=\"thBtnAdd\" class=\"text-center\" style=\"width:  4%\" *ngIf=\"showBtnAdd\">\n                  <button (click)=\"add()\" class=\"btn btn-success btn-xs\">\n                      <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                  </button>\n              </th>\n          </tr>\n      </thead>\n      <tbody *ngFor=\"let reg of registers; let i = index\" >\n          <tr style=\"font-size: 0.7rem; font-weight: bold;cursor: pointer;\" (click)=\"itemSelected=reg\" [ngClass]=\"{'active' : true}\">\n              <td *ngFor=\"let c of columns\" [ngClass]=\"c.style\" >\n\n                  <span *ngIf=\"checkToggler(c, reg)\">\n                      <button (click)=\"subListClosed = !subListClosed;composeSubList(i);\" style=\"line-height: 0 !important; cursor: pointer;\" class=\"btn\" title=\"SubList\">\n                          <i aria-hidden=\"true\" [ngClass]=\"getBtClass(subListClosed)\"></i>\n                      </button>\n                  </span>\n\n                    <span *ngIf=\"isBoolean(reg[c.name])\">\n                      <img *ngIf=\"reg[c.name] === true\" alt=\"\" src=\"assets/true.png\">\n                      <img *ngIf=\"reg[c.name] === false\" alt=\"\" src=\"assets/false.png\">\n                    </span>\n                    <span *ngIf=\"!isBoolean(reg[c.name]) && c.type !== colType.COMPLEX\">\n                        <label *ngIf=\"c.type === colType.CURRENCY\">{{reg[c.name] | currency}}</label>\n                        <label *ngIf=\"c.type === colType.INTEGER\">{{reg[c.name] | number: '0'}}</label>\n                        <label *ngIf=\"c.type === colType.DOUBLE\">{{reg[c.name] | number: '2'}}</label>\n                        <label *ngIf=\"c.type === colType.INTEGER\">{{reg[c.name] | number}}</label>\n                        <label *ngIf=\"c.type === colType.DATE\">{{reg[c.name] | date: 'dd/MM/yyyy'}}</label>\n                        <label *ngIf=\"c.type === colType.STRING\">{{reg[c.name]}}</label>\n                    </span>\n              </td>\n\n              <td class=\"text-center\" *ngIf=\"showBtnAdd\">\n                  <button (click)=\"select(reg.id)\" style=\"line-height: 0 !important\"\n                      class=\"btn btn-primary btn-xs\">\n                      <em class=\"fa fa-edit\"></em>\n                  </button>\n              </td>\n        </tr>\n        <tr *ngIf=\"selected === i\" >\n             <td [attr.colspan]=\"columns.length\">\n                  <table class=\"table table-bordered table-striped table-hover table-sm m-0\" aria-describedby=\"table\">\n                    <thead>\n                        <tr style=\"font-weight: bold;\" *ngIf=\"subListTitle\" class=\"text-center\">\n                            <th id=\"{{subListTitle}}\" [attr.colspan]=\"colsSubList.length\">\n                                {{subListTitle}}\n                                <br/>\n                            </th>\n                        </tr>\n                        <tr style=\"font-weight: bold;\">\n                            <th id=\"{{cs.title}}\" *ngFor=\"let cs of colsSubList\" [ngClass]=\"cs.style\">\n                                {{cs.title}}\n                                <br/>\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody *ngFor=\"let regSub of reg.modules;\" >\n                        <tr style=\"font-size: 0.7rem; font-weight: bold;\">\n                            <td *ngFor=\"let cs of colsSubList\" [ngClass]=\"cs.style\" >\n                                  <span *ngIf=\"isBoolean(reg[cs.name])\">\n                                    <img *ngIf=\"regSub[cs.name] === true\" alt=\"\" src=\"assets/true.png\">\n                                    <img *ngIf=\"regSub[cs.name] === false\" alt=\"\" src=\"assets/false.png\">\n                                  </span>\n                                  <span *ngIf=\"!isBoolean(regSub[cs.name]) && cs.type !== colType.COMPLEX\">\n                                      <label *ngIf=\"cs.type === colType.CURRENCY\">{{regSub[cs.name] | currency}}</label>\n                                      <label *ngIf=\"cs.type === colType.INTEGER\">{{regSub[cs.name] | number: '0'}}</label>\n                                      <label *ngIf=\"cs.type === colType.DOUBLE\">{{regSub[cs.name] | number: '2'}}</label>\n                                      <label *ngIf=\"cs.type === colType.INTEGER\">{{regSub[cs.name] | number}}</label>\n                                      <label *ngIf=\"cs.type === colType.DATE\">{{regSub[cs.name] | date: 'dd/MM/yyyy'}}</label>\n                                      <label *ngIf=\"cs.type === colType.STRING\">{{regSub[cs.name]}}</label>\n                                  </span>\n                            </td>\n                      </tr>\n                    </tbody>\n                </table>\n             </td>\n         </tr>\n      </tbody>\n  </table>\n</div>\n<footer id=\"sticky-footer\" class=\"py-1  \" style=\"padding: 0\">\n  <div class=\" row flex space-between\">\n      <div class=\"col-md-2\">\n          Resultados: {{total}}\n      </div>\n      <div class=\"col-md-8 \" >\n          <pagination *ngIf=\"showFilter\" [totalItems]=\"total\" (ngModel)=\"pagSelect\" (pageChanged)=\"go($event.page)\" [maxSize]=\"5\"\n              (numPages)=\"totPag\" [boundaryLinks]=\"true\" [itemsPerPage]=\"pageSize\" [rotate]=\"true\">\n          </pagination>\n      </div>\n      <div class=\"col-md-2 text-right\">\n          <a href=\"javascript:window.history.go(-1)\" class=\"btn btn-danger btn-sm\">\n              <em class=\"fa fa-undo\"></em>\n              Voltar\n          </a>\n      </div>\n  </div>\n</footer>\n\n\n",
                animations: [routerTransition()],
                styles: [".custWidth{width:4%!important}"]
            }] }
];
/** @nocollapse */
MxDataTableComponent.ctorParameters = () => [
    { type: MxBaseRestService },
    { type: ActivatedRoute },
    { type: Router }
];
MxDataTableComponent.propDecorators = {
    pageSize: [{ type: Input }],
    showBtnAdd: [{ type: Input }],
    action: [{ type: Input }],
    resource: [{ type: Input }],
    registers: [{ type: Input }],
    columns: [{ type: Input }],
    subListName: [{ type: Input }],
    showFilter: [{ type: Input }],
    colsSubList: [{ type: Input }],
    subListTitle: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxDataTableComponent.prototype.pageSize;
    /** @type {?} */
    MxDataTableComponent.prototype.colType;
    /** @type {?} */
    MxDataTableComponent.prototype.orderBy;
    /** @type {?} */
    MxDataTableComponent.prototype.showBtnAdd;
    /** @type {?} */
    MxDataTableComponent.prototype.action;
    /** @type {?} */
    MxDataTableComponent.prototype.resource;
    /** @type {?} */
    MxDataTableComponent.prototype.subList;
    /** @type {?} */
    MxDataTableComponent.prototype.loading;
    /** @type {?} */
    MxDataTableComponent.prototype.subsQParam;
    /** @type {?} */
    MxDataTableComponent.prototype.registers;
    /** @type {?} */
    MxDataTableComponent.prototype.columns;
    /** @type {?} */
    MxDataTableComponent.prototype.pagSelect;
    /** @type {?} */
    MxDataTableComponent.prototype.total;
    /** @type {?} */
    MxDataTableComponent.prototype.totPag;
    /** @type {?} */
    MxDataTableComponent.prototype.subListClosed;
    /** @type {?} */
    MxDataTableComponent.prototype.subListName;
    /** @type {?} */
    MxDataTableComponent.prototype.showFilter;
    /** @type {?} */
    MxDataTableComponent.prototype.colsSubList;
    /** @type {?} */
    MxDataTableComponent.prototype.subListTitle;
    /** @type {?} */
    MxDataTableComponent.prototype.itemSelected;
    /** @type {?} */
    MxDataTableComponent.prototype.selected;
    /**
     * @type {?}
     * @private
     */
    MxDataTableComponent.prototype.restService;
    /**
     * @type {?}
     * @private
     */
    MxDataTableComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    MxDataTableComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxDataTableListComponent {
    /**
     * @param {?} restService
     */
    constructor(restService) {
        this.restService = restService;
        this.mxGetList = '';
        this.mxPageSize = 15;
        this.mxActionsEnable = [ActionDataList.NEW, ActionDataList.SELECT];
        this.mxRequestFiltersMongoDb = false;
        this.mxIconAdiction = 'fa-edit';
        this.mxOnSelect = new EventEmitter();
        this.mxOnNew = new EventEmitter();
        this.mxOnAdiction = new EventEmitter();
        this.ColumnTypes = ColumnTypes;
        this.ActionDataList = ActionDataList;
        this.isLoading = true;
        this.showLoading = true;
        this.onLoadRequest = new EventEmitter();
        // pageSize = 15;
        this.filtros = [];
        this.registros = [];
        this.pagSelect = 1;
        this.total = 0;
        this.totPag = 0;
        this.operacoes = [{
                value: 'like',
                descricao: 'Contém',
                types: [ColumnTypes.STRING]
            }, {
                value: '=',
                descricao: 'Igual',
                types: [ColumnTypes.STRING, ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY,
                    ColumnTypes.DATE, ColumnTypes.DATETIME, ColumnTypes.BOOLEAN, ColumnTypes.CUSTOM, ColumnTypes.ENUM]
            }, {
                value: '!=',
                descricao: 'Diferente',
                types: [ColumnTypes.STRING, ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY,
                    ColumnTypes.DATE, ColumnTypes.DATETIME]
            }, {
                value: 'likeInit',
                descricao: 'Inicia',
                types: [ColumnTypes.STRING]
            }, {
                value: 'likeEnd',
                descricao: 'Termina',
                types: [ColumnTypes.STRING]
            }, {
                value: '>',
                descricao: 'Maior',
                types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
            }, {
                value: '>=',
                descricao: 'Maior Igual',
                types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
            }, {
                value: '<',
                descricao: 'Menor',
                types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
            }, {
                value: '<=',
                descricao: 'Menor igual',
                types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
            }];
        this.typesCenter = [ColumnTypes.DATE, ColumnTypes.DATETIME, ColumnTypes.INTEGER, ColumnTypes.BOOLEAN];
        this.typesRight = [ColumnTypes.CURRENCY, ColumnTypes.DOUBLE];
        this.onLoadRequest.pipe(debounceTime(500)).subscribe((/**
         * @return {?}
         */
        () => {
            if (this.isLoading) {
                this.showLoading = true;
            }
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if ((this.filtros || []).length === 0) {
            this.initialize();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.filtros = null;
        this.registros = [];
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.mxEntidade) {
            this.reloadAll();
        }
    }
    /**
     * @return {?}
     */
    reloadAll() {
        this.showLoading = true;
        this.initialize();
    }
    /**
     * @private
     * @return {?}
     */
    initialize() {
        this.filtros = null;
        this.registros = [];
        this.addFiltro();
        this.filterRequest();
    }
    /**
     * @param {?} page
     * @return {?}
     */
    go(page) {
        this.pagSelect = page;
        this.filterRequest();
    }
    /**
     * @param {?} collumn
     * @return {?}
     */
    selectOrderBy(collumn) {
        if (this.mxOrderBy === collumn) {
            this.mxOrderBy.orderDir = (this.mxOrderBy.orderDir === '1' ? '-1' : '1');
        }
        else {
            this.mxOrderBy = collumn;
            this.mxOrderBy.orderDir = '1';
        }
        this.filter();
    }
    /**
     * @return {?}
     */
    addFiltro() {
        if (!this.filtros) {
            this.filtros = [];
        }
        /** @type {?} */
        const f = {};
        f.operacao = this.operacoes[this.mxColumns[0].type === ColumnTypes.STRING ? 0 : 1];
        if (isNullOrUndefined(this.mxOrderBy)) {
            this.mxOrderBy = this.mxColumns[0];
        }
        f.collumn = this.mxColumns[0];
        f.value = '';
        this.filtros.push(f);
    }
    /**
     * @param {?} index
     * @return {?}
     */
    changeCampo(index) {
        this.filtros[index].operacao = {};
        for (const operacao of this.operacoes) {
            if (operacao.types.indexOf(this.filtros[index].collumn.type) > -1) {
                this.filtros[index].operacao = operacao;
                break;
            }
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    delFiltro(index) {
        this.filtros.splice(index, 1);
    }
    /**
     * @return {?}
     */
    filter() {
        this.pagSelect = 1;
        this.filterRequest();
    }
    /**
     * @return {?}
     */
    filterRequest() {
        this.isLoading = true;
        this.onLoadRequest.emit();
        try {
            /** @type {?} */
            let first = 0;
            if (this.pagSelect > 1) {
                first = ((this.pagSelect * this.mxPageSize) - this.mxPageSize);
            }
            /** @type {?} */
            const filter = `?offset=${first}&limit=${this.mxPageSize}&sort=${this.mxOrderBy.name}:${Number(this.mxOrderBy.orderDir)}`;
            /** @type {?} */
            const filters = this.mountFilters();
            /** @type {?} */
            let headers = null;
            if (filters.length > 0) {
                if (this.mxRequestFiltersMongoDb) {
                    headers = { filter: JSON.stringify({ $and: filters }) };
                }
                else {
                    headers = { filter: JSON.stringify(filters) };
                }
            }
            this.restService.listAll(this.mxEntidade + (this.mxGetList || ''), filter, headers).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => {
                this.registros = (data && data.docs ? data.docs : []);
                if (data.docs.length === 0 && data.total > 0) {
                    this.pagSelect = 1;
                    this.filterRequest();
                    return;
                }
                this.total = data.total;
            }), (/**
             * @return {?}
             */
            () => {
                // error
            }), (/**
             * @return {?}
             */
            () => {
                this.isLoading = false;
                this.showLoading = false;
            }));
        }
        catch (error) {
            this.isLoading = false;
            this.showLoading = false;
        }
    }
    /**
     * @private
     * @return {?}
     */
    mountFilters() {
        /** @type {?} */
        const filters = new Array();
        for (const f of this.filtros) {
            /** @type {?} */
            let filtroStr = null;
            if (f.collumn.type === ColumnTypes.ENUM) {
                if (f.filtro > -1) {
                    filtroStr = f.filtro;
                }
            }
            else if ((f.filtro || '').toString().trim().length > 0 || f.filtro === true || f.filtro === false) {
                if ([ColumnTypes.DATE, ColumnTypes.DATETIME].indexOf(f.collumn.type) > -1 && this.isDate(f.filtro)) {
                    f.filtro.setHours(0, 0, 0);
                    filtroStr = this.mxRequestFiltersMongoDb ? `ISODate("${f.filtro.toISOString()}")` : f.filtro.getTime();
                }
                else if ([ColumnTypes.INTEGER, ColumnTypes.CURRENCY].indexOf(f.collumn.type) > -1) {
                    filtroStr = Number(f.filtro);
                }
                else if (f.collumn.type === ColumnTypes.BOOLEAN) {
                    filtroStr = Boolean(f.filtro);
                }
                else if (ColumnTypes.DOUBLE === f.collumn.type) {
                    filtroStr = f.filtro;
                }
                else {
                    filtroStr = (f.filtro || '').trim();
                }
            }
            if (!isNullOrUndefined(filtroStr)) {
                /** @type {?} */
                let filter;
                if (this.mxRequestFiltersMongoDb) {
                    /** @type {?} */
                    const c = f.collumn.name;
                    /** @type {?} */
                    const operacao = f.operacao;
                    filter = JSON.parse(`{ "${c}": null }`);
                    if (operacao.value === '=') {
                        filter[c] = filtroStr;
                    }
                    else if (operacao.value === '!=') {
                        filter[c] = { $ne: filtroStr };
                    }
                    else if (operacao.value === 'like') {
                        filter[c] = { $regex: `.*${filtroStr}.*`, $options: 'i' };
                    }
                    else if (operacao.value === 'likeInit') {
                        filter[c] = { $regex: `${filtroStr}.*`, $options: 'i' };
                    }
                    else if (operacao.value === 'likeEnd') {
                        filter[c] = { $regex: `.*${filtroStr}`, $options: 'i' };
                    }
                    else if (operacao.value === '>') {
                        filter[c] = { $gt: filtroStr };
                    }
                    else if (operacao.value === '>=') {
                        filter[c] = { $gte: filtroStr };
                    }
                    else if (operacao.value === '<') {
                        filter[c] = { $lt: filtroStr };
                    }
                    else if (operacao.value === '<=') {
                        filter[c] = { $lte: filtroStr };
                    }
                }
                else {
                    filter = {
                        column: f.collumn.name,
                        operation: f.operacao.value,
                        value: filtroStr
                    };
                }
                filters.push(filter);
            }
        }
        return filters;
    }
    /**
     * @param {?} registro
     * @return {?}
     */
    onSelect(registro) {
        this.mxOnSelect.emit(registro);
    }
    /**
     * @return {?}
     */
    onNew() {
        this.mxOnNew.emit();
    }
    /**
     * @param {?} registro
     * @return {?}
     */
    onAdiction(registro) {
        this.mxOnAdiction.emit(registro);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    isBoolean(val) {
        return (typeof val === 'boolean') && !this.isDate(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    isString(val) {
        return (typeof val === 'string') && !this.isDate(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    isNumber(val) {
        return (typeof val === 'number') && !this.isDate(val);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    isDate(val) {
        /** @type {?} */
        const da = Date.parse(val);
        return (da && (new Date(da) || Date.parse(da.toString())));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    isDefined(value) {
        return !isNullOrUndefined(value);
    }
    /**
     * @param {?} c
     * @return {?}
     */
    getColumnTextAlign(c) {
        /** @type {?} */
        let align = null;
        if (c.style) {
            if (c.style.indexOf('center') > -1) {
                align = 'center';
            }
            else if (c.style.indexOf('right') > -1) {
                align = 'right';
            }
            else if (c.style.indexOf('left') > -1) {
                align = 'left';
            }
        }
        return align || (this.typesCenter.indexOf(c.type) > -1 ? 'center' : this.typesRight.indexOf(c.type) > -1 ? 'right' : 'left');
    }
    /**
     * @param {?} c
     * @return {?}
     */
    getColumnWidth(c) {
        /** @type {?} */
        let width = null;
        if (c.style) {
            width = c.style.find((/**
             * @param {?} s
             * @return {?}
             */
            s => s.indexOf('%') > -1));
        }
        return width || 'fit-content';
    }
    /**
     * @param {?} filtro
     * @return {?}
     */
    getOperacoes(filtro) {
        return this.operacoes.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.types.indexOf(filtro.collumn.type) > -1));
    }
    /**
     * @return {?}
     */
    isOnNew() {
        return this.mxOnNew.observers.length > 0 && (this.mxActionsEnable || []).indexOf(ActionDataList.NEW) > -1;
    }
    /**
     * @return {?}
     */
    isOnAdiction() {
        return this.mxOnAdiction.observers.length > 0 && (this.mxActionsEnable || []).indexOf(ActionDataList.ADICTION) > -1;
    }
    /**
     * @return {?}
     */
    isOnSelect() {
        return this.mxOnSelect.observers.length > 0 && (this.mxActionsEnable || []).indexOf(ActionDataList.SELECT) > -1;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getBooleanString(value) {
        return (value !== null ? value ? 'Sim' : 'Não' : '');
    }
    /**
     * @param {?} path
     * @param {?} obj
     * @return {?}
     */
    resolve(path, obj) {
        if (path.indexOf('.') > -1) {
            return path.split('.').reduce((/**
             * @param {?} prev
             * @param {?} curr
             * @return {?}
             */
            (prev, curr) => (prev && prev.hasOwnProperty(curr)) ? prev[curr] : ''), obj);
        }
        else {
            return obj[path];
        }
    }
    /**
     * @param {?} data
     * @param {?} checkRegistro
     * @return {?}
     */
    mxNotifyItemChange(data, checkRegistro) {
        /** @type {?} */
        const idxOld = this.registros.findIndex((/**
         * @param {?} value
         * @return {?}
         */
        value => checkRegistro(value)));
        if (idxOld > -1) {
            this.registros.splice(idxOld, 1, data);
        }
        else {
            this.registros.splice(idxOld, 0, data);
        }
    }
    /**
     * @param {?} checkRegistro
     * @return {?}
     */
    mxNotifyItemDelete(checkRegistro) {
        /** @type {?} */
        const idxOld = this.registros.findIndex((/**
         * @param {?} value
         * @return {?}
         */
        value => checkRegistro(value)));
        if (idxOld > -1) {
            this.registros.splice(idxOld, 1);
        }
    }
}
MxDataTableListComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-data-table-list',
                template: "<div style=\"height: 100%; padding-bottom: 40px;\">\n\n  <!-- Filtros -->\n  <div class=\"form-inline mb-1 row\" *ngFor=\"let f of filtros; index as i;\" [attr.data-index]=\"i\">\n\n    <div class=\"form-group col-md-2 col-sm-6\">\n      <select class=\"form-control\" [(ngModel)]=\"f.collumn\" (change)=\"changeCampo(i)\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let r of mxColumns\" [ngValue]=\"r\">\n          {{r.title | translate}}\n        </option>\n      </select>\n    </div>\n    <div class=\"form-group col-md-2 col-sm-6\">\n      <select class=\"form-control\" [(ngModel)]=\"f.operacao\" [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let r of getOperacoes(f)\" [ngValue]=\"r\">\n          {{r.descricao}}\n        </option>\n      </select>\n    </div>\n\n    <div class=\"form-group col-md-6 col-sm-9\">\n      <!-- Campo filtro para DATE -->\n      <input type=\"text\" *ngIf=\"[ColumnTypes.DATE, ColumnTypes.DATETIME].indexOf(f.collumn.type) > -1\"\n        (keyup.enter)=\"filter()\" [(ngModel)]=\"f.filtro\" class=\"form-control\" placeholder=\"{{'search' | translate}}\"\n        bsDatepicker [bsConfig]=\"{adaptivePosition: true, isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }\" />\n      <!-- Campo filtro para BOOLEAN -->\n      <select class=\"form-control\" *ngIf=\"f.collumn.type === ColumnTypes.BOOLEAN\" [(ngModel)]=\"f.filtro\"\n        (keyup.enter)=\"filter()\">\n        <option *ngFor=\" let i of [null, true, false]\" [ngValue]=\"i\">\n          {{getBooleanString(i)}}\n        </option>\n      </select>\n\n      <!-- Campo filtro para ENUM com o array de valores maior que 0 -->\n      <select class=\"form-control\" *ngIf=\"f.collumn.type === ColumnTypes.ENUM && f.collumn.enumValues.length > 0\"\n        [(ngModel)]=\"f.filtro\" (keyup.enter)=\"filter()\">\n        <option *ngFor=\" let i of f.collumn.enumValues\" [ngValue]=\"i.id\">\n          {{i.description}}\n        </option>\n      </select>\n      <!-- Campo filtro para ENUM com o array de valores igual a 0 -->\n      <input type=\"text\" *ngIf=\"f.collumn.type === ColumnTypes.ENUM && f.collumn.enumValues.length === 0\"\n        (keyup.enter)=\"filter()\" [(ngModel)]=\"f.filtro\" class=\"form-control\" placeholder=\"{{'search' | translate}}\"\n        size=\"80\" />\n\n      <!-- Campo para filtro tipo DOUBLE -->\n      <input type=\"text\" *ngIf=\"[ColumnTypes.DOUBLE].indexOf(f.collumn.type) > -1\" (keyup.enter)=\"filter()\"\n        [(ngModel)]=\"f.filtro\" class=\"form-control\" placeholder=\"{{'search' | translate}}\" size=\"80\" />\n      <!-- Campo filtro para demais TYPES -->\n      <input type=\"text\"\n        *ngIf=\"[ColumnTypes.DATE, ColumnTypes.DATETIME, ColumnTypes.BOOLEAN, ColumnTypes.DOUBLE, ColumnTypes.ENUM].indexOf(f.collumn.type) < 0\"\n        (keyup.enter)=\"filter()\" [(ngModel)]=\"f.filtro\" class=\"form-control\" placeholder=\"{{'search' | translate}}\"\n        size=\"80\" />\n    </div>\n\n    <div class=\"col-md-2 col-sm-3\">\n      <button type=\"button\" (click)=\"delFiltro(i)\" class=\"btn btn-warning btn-sm mr-2\" *ngIf=\"filtros.length != 1\">\n        <span class=\"fa fa-remove\"></span>\n      </button>\n      <button type=\"button\" (click)=\"addFiltro()\" class=\"btn btn-success btn-sm mr-2\" *ngIf=\"i === (filtros.length -1)\">\n        <span class=\"fa fa-plus\"></span>\n      </button>\n      <button type=\"button\" (click)=\"filter()\" class=\"btn btn-info btn-sm mr-2 hidden-xs\"\n        *ngIf=\"filtros.length === (i + 1)\">\n        <span class=\"fa fa-refresh\"></span>\n        {{'refresh' | translate}}\n      </button>\n    </div>\n  </div>\n\n  <table @fade class=\"table table-bordered table-striped m-0 text-left\">\n    <thead>\n      <tr>\n        <th *ngFor=\"let c of mxColumns\" (click)=\"selectOrderBy(c)\" [style.width]=\"getColumnWidth(c)\"\n          [style.text-align]=\"getColumnTextAlign(c)\">\n          {{c.title | translate}}\n          <span *ngIf=\"c.name === mxOrderBy?.name\">\n            <i class=\"fa\" [ngClass]=\"{'fa-sort-up': mxOrderBy.orderDir === '-1',\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  'fa-sort-down': mxOrderBy.orderDir === '1'}\">\n            </i>\n          </span>\n        </th>\n        <th class=\"column-actions\" *ngIf=\"isOnAdiction()\">\n          <!-- <a *ngIf=\"isOnAdiction()\" (click)=\"onNew()\" style=\"width: 100%; height: 40px; line-height: 37px;\"\n\t\t\t\t\t\tclass=\"btn btn-success btn-sm\">\n\t\t\t\t\t\t<i class=\"fa fa-lg fa-plus\"></i>\n\t\t\t\t\t</a> -->\n        </th>\n        <th class=\"column-actions\" *ngIf=\"isOnNew() || isOnSelect() \">\n          <a *ngIf=\"isOnNew()\" (click)=\"onNew()\" style=\"width: 100%; height: 40px; line-height: 37px;\"\n            class=\"btn btn-success btn-sm\">\n            <i class=\"fa fa-lg fa-plus\"></i>\n          </a>\n        </th>\n      </tr>\n    </thead>\n    <tbody class=\"fade-in fade-in-left\">\n      <tr *ngFor=\"let reg of registros\">\n        <td *ngFor=\"let c of mxColumns\" [style.text-align]=\"getColumnTextAlign(c)\">\n          <span *ngIf=\"!isDefined(c.type)\">{{reg[c.name]}}</span>\n          <span *ngIf=\"isBoolean(reg[c.name])\">\n            <img *ngIf=\"reg[c.name] === true\" alt=\"Sim\" src=\"assets/true.png\">\n            <img *ngIf=\"reg[c.name] === false\" alt=\"N\u00E3o\" src=\"assets/false.png\">\n          </span>\n          <span *ngIf=\"!isBoolean(reg[c.name]) && isDefined(c.type) && c.type !== ColumnTypes.COMPLEX\">\n            <span *ngIf=\"c.type === ColumnTypes.CURRENCY\">{{resolve(c.name, reg) | currency : 'BRL'}}</span>\n            <span *ngIf=\"c.type === ColumnTypes.INTEGER\">{{resolve(c.name, reg) | number}}</span>\n            <span *ngIf=\"c.type === ColumnTypes.DOUBLE\">{{resolve(c.name, reg) | number : '0.2'}}</span>\n            <span *ngIf=\"c.type === ColumnTypes.DATE\">{{resolve(c.name, reg) | date : 'dd/MM/yyyy'}}</span>\n            <span *ngIf=\"c.type === ColumnTypes.DATETIME\">{{resolve(c.name, reg) | date : 'dd/MM/yyyy hh:mm:ss'}}</span>\n            <span *ngIf=\"c.type === ColumnTypes.STRING\">{{resolve(c.name, reg)}}</span>\n          </span>\n          <span *ngIf=\"c.type === ColumnTypes.CUSTOM || c.type === ColumnTypes.ENUM\">\n            {{c.transformCustomValue(reg)}}\n          </span>\n        </td>\n        <td class=\"column-actions\" *ngIf=\"isOnAdiction()\">\n          <a (click)=\"onAdiction(reg)\" class=\"btn btn-adiction btn-sm width-100-percent\">\n            <i class=\"fa fa-lg\" [ngClass]=\"mxIconAdiction\"></i>\n          </a>\n        </td>\n        <td class=\"column-actions\" *ngIf=\"isOnSelect()\">\n          <a (click)=\"onSelect(reg)\" class=\"btn btn-max btn-sm width-100-percent\">\n            <i class=\"fa fa-lg fa-edit\"></i>\n          </a>\n        </td>\n      </tr>\n      <tr *ngIf=\"showLoading\" class=\"fade-in fade-in-left\">\n        <td [attr.colspan]=\"(mxColumns.length + (isOnNew() || isOnSelect() ? 1 : 0))\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\">\n            <defs>\n              <filter id=\"gooey\">\n                <feGaussianBlur in=\"SourceGraphic\" stdDeviation=\"10\" result=\"blur\"></feGaussianBlur>\n                <feColorMatrix in=\"blur\" mode=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7\"\n                  result=\"goo\">\n                </feColorMatrix>\n                <feBlend in=\"SourceGraphic\" in2=\"goo\"></feBlend>\n              </filter>\n            </defs>\n          </svg>\n          <div class=\"blob blob-0\"></div>\n          <div class=\"blob blob-1\"></div>\n          <div class=\"blob blob-2\"></div>\n          <div class=\"blob blob-3\"></div>\n          <div class=\"blob blob-4\"></div>\n          <div class=\"blob blob-5\"></div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n  <div class=\"form-inline row col-md-12 page-footer\">\n    <div class=\"col-md-3\">\n      <label *ngIf=\"total>0\" style=\"margin-top: 0; margin-bottom: 1rem;\">{{total}} Registros</label>\n      <label *ngIf=\"total===0\" style=\"font-weight: 600\"> Nenhum Registro encontrado</label>\n    </div>\n    <div class=\"col-md-5\">\n      <pagination [totalItems]=\"total\" (ngModel)=\"pagSelect\" (pageChanged)=\"go($event.page)\" [maxSize]=\"5\"\n        [boundaryLinks]=\"true\" [itemsPerPage]=\"mxPageSize\" [rotate]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\n        firstText=\"&laquo;\" lastText=\"&raquo;\">\n      </pagination>\n    </div>\n    <div class=\"form-inline col-md-3\">\n      <label style=\"font-weight: 600\"> Total por p\u00E1gina: </label>\n      <select style=\"margin-left: 10px\" class=\"custom-select imput-sm\" [(ngModel)]=\"mxPageSize\" (change)=\"filter()\">\n        <option *ngFor=\"let i of [10,15,20,40,80]\" [ngValue]=\"i\">{{i}}</option>\n      </select>\n    </div>\n  </div>\n</div>\n",
                animations: [
                    trigger('fade', [
                        state('void', style({ opacity: 0 })),
                        transition('void => *', [
                            style({ opacity: 0 }),
                            animate('300ms', style({ opacity: 1 }))
                        ]),
                        transition('* => void', [
                            style({ opacity: 1 }),
                            animate('100ms', style({ opacity: 0 }))
                        ])
                    ])
                ],
                styles: ["table i{color:#fff}.form-control{width:100%}.page-footer{background:#445e77;position:fixed;bottom:0;height:43px;padding-top:3px;color:#fff;font-weight:600;text-align:left}.page-footer label,.page-footer select{margin-top:0;margin-bottom:1rem}.table-bordered thead th{background:#445e77;color:#fff}.table-bordered thead{border-radius:25px}.table-bordered{border:none!important;overflow:auto;height:inherit}.table>tbody>tr>td{vertical-align:middle;padding:2px 8px}table tr td:first-child::after{content:\"\";display:inline-block;min-height:1.56rem;vertical-align:middle}.column-actions{width:60px;text-align:center!important;padding:0!important}tbody tr:hover{background-color:#bfc5cc!important}.table th:first-child{border-top-left-radius:6px}.table th:last-child{border-top-right-radius:6px}body{line-height:1.3!important;font-size:.8rem!important}.width-100-percent{width:100%}.btn-adiction{color:#445e77;background-image:none;background-color:transparent}.btn-adiction i{color:#445e77}.btn-adiction:hover{color:#5c7e9c;background-color:transparent;border-color:transparent}.btn-adiction.disabled,.btn-adiction:disabled{color:#445e77;background-color:transparent}.btn-adiction:not(:disabled):not(.disabled).active,.btn-adiction:not(:disabled):not(.disabled):active,.show>.btn-adiction.dropdown-toggle{color:#445e77;background-color:transparent;border-color:transparent}.btn-max{color:#fff;background-image:none;background-color:#445e77;box-shadow:0 3px 5px 0 #dee4ea}.btn-max.whithBorder{border-color:#445e77;box-shadow:0 1px 5px #eef0f9}.btn-max:hover{color:#fff;background-color:#5c7e9c;border-color:#5c7e9c}.btn-max.focus,.btn-max:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-max.disabled,.btn-max:disabled{color:#445e77;background-color:transparent}.btn-max:not(:disabled):not(.disabled).active,.btn-max:not(:disabled):not(.disabled):active,.show>.btn-max.dropdown-toggle{color:#fff;background-color:#445e77;border-color:#445e77}.btn-max:not(:disabled):not(.disabled).active:focus,.btn-max:not(:disabled):not(.disabled):active:focus,.show>.btn-max.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.blob{width:2rem;height:2rem;background:rgba(82,108,137,.85);border-radius:50%;position:absolute;left:calc(50% - 1rem);top:calc(50% - 1rem);box-shadow:0 0 1rem rgba(255,255,255,.25)}.blob-2{-webkit-animation:1.5s infinite animate-to-2;animation:1.5s infinite animate-to-2}.blob-3{-webkit-animation:1.5s infinite animate-to-3;animation:1.5s infinite animate-to-3}.blob-1{-webkit-animation:1.5s infinite animate-to-1;animation:1.5s infinite animate-to-1}.blob-4{-webkit-animation:1.5s infinite animate-to-4;animation:1.5s infinite animate-to-4}.blob-0{-webkit-animation:1.5s infinite animate-to-0;animation:1.5s infinite animate-to-0}.blob-5{-webkit-animation:1.5s infinite animate-to-5;animation:1.5s infinite animate-to-5}@-webkit-keyframes animate-to-2{25%,75%{-webkit-transform:translateX(-1.5rem) scale(.75);transform:translateX(-1.5rem) scale(.75)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@keyframes animate-to-2{25%,75%{-webkit-transform:translateX(-1.5rem) scale(.75);transform:translateX(-1.5rem) scale(.75)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@-webkit-keyframes animate-to-3{25%,75%{-webkit-transform:translateX(1.5rem) scale(.75);transform:translateX(1.5rem) scale(.75)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@keyframes animate-to-3{25%,75%{-webkit-transform:translateX(1.5rem) scale(.75);transform:translateX(1.5rem) scale(.75)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@-webkit-keyframes animate-to-1{25%{-webkit-transform:translateX(-1.5rem) scale(.75);transform:translateX(-1.5rem) scale(.75)}50%,75%{-webkit-transform:translateX(-4.5rem) scale(.6);transform:translateX(-4.5rem) scale(.6)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@keyframes animate-to-1{25%{-webkit-transform:translateX(-1.5rem) scale(.75);transform:translateX(-1.5rem) scale(.75)}50%,75%{-webkit-transform:translateX(-4.5rem) scale(.6);transform:translateX(-4.5rem) scale(.6)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@-webkit-keyframes animate-to-4{25%{-webkit-transform:translateX(1.5rem) scale(.75);transform:translateX(1.5rem) scale(.75)}50%,75%{-webkit-transform:translateX(4.5rem) scale(.6);transform:translateX(4.5rem) scale(.6)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@keyframes animate-to-4{25%{-webkit-transform:translateX(1.5rem) scale(.75);transform:translateX(1.5rem) scale(.75)}50%,75%{-webkit-transform:translateX(4.5rem) scale(.6);transform:translateX(4.5rem) scale(.6)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@-webkit-keyframes animate-to-0{25%{-webkit-transform:translateX(-1.5rem) scale(.75);transform:translateX(-1.5rem) scale(.75)}50%{-webkit-transform:translateX(-4.5rem) scale(.6);transform:translateX(-4.5rem) scale(.6)}75%{-webkit-transform:translateX(-7.5rem) scale(.5);transform:translateX(-7.5rem) scale(.5)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@keyframes animate-to-0{25%{-webkit-transform:translateX(-1.5rem) scale(.75);transform:translateX(-1.5rem) scale(.75)}50%{-webkit-transform:translateX(-4.5rem) scale(.6);transform:translateX(-4.5rem) scale(.6)}75%{-webkit-transform:translateX(-7.5rem) scale(.5);transform:translateX(-7.5rem) scale(.5)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@-webkit-keyframes animate-to-5{25%{-webkit-transform:translateX(1.5rem) scale(.75);transform:translateX(1.5rem) scale(.75)}50%{-webkit-transform:translateX(4.5rem) scale(.6);transform:translateX(4.5rem) scale(.6)}75%{-webkit-transform:translateX(7.5rem) scale(.5);transform:translateX(7.5rem) scale(.5)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}@keyframes animate-to-5{25%{-webkit-transform:translateX(1.5rem) scale(.75);transform:translateX(1.5rem) scale(.75)}50%{-webkit-transform:translateX(4.5rem) scale(.6);transform:translateX(4.5rem) scale(.6)}75%{-webkit-transform:translateX(7.5rem) scale(.5);transform:translateX(7.5rem) scale(.5)}95%{-webkit-transform:translateX(0) scale(1);transform:translateX(0) scale(1)}}.fade-in{-webkit-animation:.3s cubic-bezier(.39,.575,.565,1) both fade-in;animation:.3s cubic-bezier(.39,.575,.565,1) both fade-in}@-webkit-keyframes fade-in{0%{opacity:0}100%{opacity:1}}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}@-webkit-keyframes fade-in-left{0%{-webkit-transform:translateX(-7px);transform:translateX(-7px);opacity:.9}100%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}}@keyframes fade-in-left{0%{-webkit-transform:translateX(-7px);transform:translateX(-7px);opacity:.9}100%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}}"]
            }] }
];
/** @nocollapse */
MxDataTableListComponent.ctorParameters = () => [
    { type: MxBaseRestService }
];
MxDataTableListComponent.propDecorators = {
    mxEntidade: [{ type: Input }],
    mxGetList: [{ type: Input }],
    mxColumns: [{ type: Input }],
    mxPageSize: [{ type: Input }],
    mxOrderBy: [{ type: Input }],
    mxActionsEnable: [{ type: Input }],
    mxRequestFiltersMongoDb: [{ type: Input }],
    mxIconAdiction: [{ type: Input }],
    mxOnSelect: [{ type: Output }],
    mxOnNew: [{ type: Output }],
    mxOnAdiction: [{ type: Output }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    MxDataTableListComponent.prototype.mxEntidade;
    /**
     * @type {?}
     * @private
     */
    MxDataTableListComponent.prototype.mxGetList;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxColumns;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxPageSize;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxOrderBy;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxActionsEnable;
    /**
     * @type {?}
     * @private
     */
    MxDataTableListComponent.prototype.mxRequestFiltersMongoDb;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxIconAdiction;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxOnSelect;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxOnNew;
    /** @type {?} */
    MxDataTableListComponent.prototype.mxOnAdiction;
    /** @type {?} */
    MxDataTableListComponent.prototype.ColumnTypes;
    /** @type {?} */
    MxDataTableListComponent.prototype.ActionDataList;
    /** @type {?} */
    MxDataTableListComponent.prototype.isLoading;
    /** @type {?} */
    MxDataTableListComponent.prototype.showLoading;
    /** @type {?} */
    MxDataTableListComponent.prototype.onLoadRequest;
    /** @type {?} */
    MxDataTableListComponent.prototype.filtros;
    /** @type {?} */
    MxDataTableListComponent.prototype.registros;
    /** @type {?} */
    MxDataTableListComponent.prototype.pagSelect;
    /** @type {?} */
    MxDataTableListComponent.prototype.total;
    /** @type {?} */
    MxDataTableListComponent.prototype.totPag;
    /** @type {?} */
    MxDataTableListComponent.prototype.operacoes;
    /**
     * @type {?}
     * @private
     */
    MxDataTableListComponent.prototype.typesCenter;
    /**
     * @type {?}
     * @private
     */
    MxDataTableListComponent.prototype.typesRight;
    /**
     * @type {?}
     * @private
     */
    MxDataTableListComponent.prototype.restService;
}
/** @enum {number} */
const ActionDataList = {
    NEW: 0, SELECT: 1, ADICTION: 2,
};
ActionDataList[ActionDataList.NEW] = 'NEW';
ActionDataList[ActionDataList.SELECT] = 'SELECT';
ActionDataList[ActionDataList.ADICTION] = 'ADICTION';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// ngx-translate - required for AOT compilation
/**
 * @param {?} http
 * @return {?}
 */
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/');
}
class MxLanguageTranslationModule {
    /**
     * @param {?} translate
     */
    constructor(translate) {
        this.translate = translate;
        // Gets Default language from browser if available, otherwise set English ad default
        this.translate.addLangs(['en', 'fr', 'ur', 'es', 'it', 'fa', 'de', 'pt-br']);
        this.translate.setDefaultLang('pt-br');
        /** @type {?} */
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang.match(/en|fr|ur|es|it|fa|de|pt-br/) ? browserLang : 'pt-br');
    }
}
MxLanguageTranslationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: HttpLoaderFactory,
                            deps: [HttpClient]
                        }
                    })
                ],
                exports: [
                    TranslateModule
                ],
            },] }
];
/** @nocollapse */
MxLanguageTranslationModule.ctorParameters = () => [
    { type: TranslateService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    MxLanguageTranslationModule.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class BaseFormField {
    /**
     * @param {?} controlDir
     */
    constructor(controlDir) {
        this.controlDir = controlDir;
        this.mxDisabled = false;
        this.mxPlaceholder = '';
        // giving the possibility to override the default error messages
        this.mxErrorMessages = {};
        this.errorMessages = {
            required: (/**
             * @return {?}
             */
            () => 'Este campo é requerido.'),
            email: (/**
             * @return {?}
             */
            () => 'Por favor, forneça um endereço de email válido.'),
            min: (/**
             * @param {?} params
             * @return {?}
             */
            (params) => `Por favor, forneça um valor maior ou igual a ${params.min}.`),
            minlength: (/**
             * @param {?} params
             * @return {?}
             */
            (params) => `Por favor, forneça ao menos ${params.requiredLength} caracteres.`),
            max: (/**
             * @param {?} params
             * @return {?}
             */
            (params) => `Por favor, forneça um valor menor ou igual a ${params.max}.`),
            maxlength: (/**
             * @param {?} params
             * @return {?}
             */
            (params) => `Por favor, forneça não mais que ${params.requiredLength} caracteres.`),
            pattern: (/**
             * @param {?} params
             * @return {?}
             */
            (params) => `O formato fornecido é inválido. ${params.requiredPattern}.`),
            cpfNotValid: (/**
             * @return {?}
             */
            () => 'O CPF não é válido.'),
            cnpjNotValid: (/**
             * @return {?}
             */
            () => 'O CNPJ não é válido.')
        };
        this.mxChange = new EventEmitter();
        // generate a unique id for each control
        this.id = Math.random().toString(36).substring(2);
        this.isRequired = false;
        // tslint:disable-next-line:variable-name
        this.onChange = (/**
         * @param {?} _value
         * @return {?}
         */
        (_value) => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
        // bind the CVA to our control
        if (controlDir) {
            controlDir.valueAccessor = this;
        }
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (this.controlDir && this.controlDir.control instanceof FormControl) {
            // check if this field is required or not to display a 'required label'
            /** @type {?} */
            const validator = this.controlDir.control.validator &&
                this.controlDir.control.validator(new FormControl(''));
            this.isRequired =
                Boolean(validator && validator.hasOwnProperty('required')) ||
                    Boolean(validator && validator.hasOwnProperty('selectedCount'));
        }
    }
    /**
     * @return {?}
     */
    hasErrors() {
        return (this.controlDir && this.controlDir.control &&
            this.controlDir.control.errors &&
            (this.controlDir.control.dirty || this.controlDir.control.touched))
            || false;
    }
    /**
     * @return {?}
     */
    listOfErrors() {
        if (!this.controlDir) {
            return [];
        }
        else {
            return Object.keys(this.controlDir.control.errors).map((/**
             * @param {?} field
             * @return {?}
             */
            field => this.getMessage(field, this.controlDir.control.errors[field])));
        }
    }
    /**
     * @param {?} type
     * @param {?} params
     * @return {?}
     */
    getMessage(type, params) {
        /** @type {?} */
        const messages = Object.assign({}, this.errorMessages, this.mxErrorMessages);
        return messages[type](params);
    }
    // implementation of `ControlValueAccessor`
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.value = value;
        if (typeof value === 'string') {
            this.text = value;
        }
        this.onChange(this.value);
        this.mxChange.emit(this.value);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} disabled
     * @return {?}
     */
    setDisabledState(disabled) {
        this.mxDisabled = disabled;
    }
}
/** @nocollapse */
BaseFormField.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
BaseFormField.propDecorators = {
    mxLabel: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    mxDisabled: [{ type: Input }],
    mxPlaceholder: [{ type: Input }],
    mxErrorMessages: [{ type: Input }],
    mxChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    BaseFormField.prototype.mxLabel;
    /** @type {?} */
    BaseFormField.prototype.ariaLabel;
    /** @type {?} */
    BaseFormField.prototype.mxDisabled;
    /** @type {?} */
    BaseFormField.prototype.mxPlaceholder;
    /** @type {?} */
    BaseFormField.prototype.mxErrorMessages;
    /**
     * @type {?}
     * @private
     */
    BaseFormField.prototype.errorMessages;
    /** @type {?} */
    BaseFormField.prototype.mxChange;
    /** @type {?} */
    BaseFormField.prototype.id;
    /** @type {?} */
    BaseFormField.prototype.value;
    /** @type {?} */
    BaseFormField.prototype.text;
    /** @type {?} */
    BaseFormField.prototype.isRequired;
    /** @type {?} */
    BaseFormField.prototype.onChange;
    /** @type {?} */
    BaseFormField.prototype.onTouched;
    /** @type {?} */
    BaseFormField.prototype.controlDir;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputFormComponent extends BaseFormField {
    constructor() {
        super(...arguments);
        this.mxType = 'text';
        this.mxValue = undefined;
        this.valueDate = null;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!isNullOrUndefined(this.value)) {
            if (isNumber(this.value)) {
                this.valueDate = new Date(this.value);
            }
            else if (isArray(this.value) && this.value.length === 2 && isNumber(this.value[0])) {
                this.valueDate = [new Date(this.value[0]), new Date(this.value[1])];
            }
            else {
                this.valueDate = this.value;
            }
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    change(event) {
        super.writeValue(event.target.value);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    changeNgModel(event) {
        this.valueDate = event;
        if (isDate(event)) {
            super.writeValue(event.getTime());
        }
        else if (isArray(event)) {
            super.writeValue([event[0].getTime(), event[1].getTime()]);
        }
        else {
            super.writeValue(event);
        }
    }
    /**
     * @return {?}
     */
    getFormatDate() {
        return (this.mxType === 'datetime' ? 'dd/MM/yyy hh:mm:ss' : 'dd/MM/yyyy');
    }
    /**
     * @return {?}
     */
    getFormatDateBs() {
        return (this.mxType === 'datetime' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY');
    }
    /**
     * @return {?}
     */
    isInputDate() {
        return (['date', 'datetime', 'daterange'].indexOf(this.mxType) > -1);
    }
    /**
     * @return {?}
     */
    isInputGroup() {
        return this.isInputDate()
            || ((this.mxInputGroup !== undefined) && (this.mxInputGroup.classIcone !== undefined || this.mxInputGroup.text !== undefined));
    }
}
MxInputFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-form',
                template: "<div [ngClass]=\"{'form-group': mxLabel}\">\r\n  <label *ngIf=\"mxLabel\" class=\"form-control-label\" [ngClass]=\"{'required': isRequired}\">\r\n    {{mxLabel | translate}}\r\n  </label>\r\n\r\n  <div [ngClass]=\"{'input-group': isInputGroup()}\">\r\n\t\t<div *ngIf=\"isInputGroup()\" class=\"input-group-prepend\">\r\n\t\t\t<div class=\"input-group-text\">\r\n\t\t\t\t<span [class]=\"mxInputGroup?.classText\">{{mxInputGroup?.text}}</span>\r\n\t\t\t\t<i *ngIf=\"mxInputGroup?.classIcone\" [class]=\"mxInputGroup?.classIcone\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<i *ngIf=\"isInputDate() && !mxInputGroup?.classIcone\" class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<input *ngIf=\"mxValue === undefined && !isInputDate() && mxType !== 'daterange'\" [type]=\"mxType\"\r\n\t\t\t\t\t [value]=\"value\"\r\n\t\t\t\t\t class=\"form-control input-sm no-input-group\"\r\n\t\t\t\t\t [ngClass]=\"{'is-invalid': hasErrors(), 'no-input-group': !isInputGroup()}\"\r\n\t\t\t\t\t (input)=\"change($event)\"\r\n\t\t\t\t\t [readonly]=\"mxDisabled\"\r\n\t\t\t\t\t [placeholder]=\"mxPlaceholder\" />\r\n\t\t<input *ngIf=\"mxValue === undefined && isInputDate() && mxType !== 'daterange'\" type=\"text\"\r\n\t\t\t\t\t bsDatepicker\r\n\t\t\t\t\t class=\"form-control input-sm\"\r\n\t\t\t\t\t [ngClass]=\"{'is-invalid': hasErrors(), 'no-input-group': !isInputGroup()}\"\r\n\t\t\t\t\t (ngModelChange)=\"changeNgModel($event)\"\r\n\t\t\t\t\t [(ngModel)]=\"valueDate\"\r\n\t\t\t\t\t [bsConfig]=\"{adaptivePosition: true, isAnimated: true, dateInputFormat: getFormatDateBs() }\"\r\n\t\t\t\t\t [readonly]=\"mxDisabled\"\r\n\t\t\t\t\t [disabled]=\"mxDisabled\"\r\n\t\t\t\t\t [placeholder]=\"mxPlaceholder\" />\r\n\t\t<input *ngIf=\"(mxValue === undefined && mxType === 'daterange')\" type=\"text\"\r\n\t\t\t\t\t bsDaterangepicker\r\n\t\t\t\t\t class=\"form-control input-sm\"\r\n\t\t\t\t\t [ngClass]=\"{'is-invalid': hasErrors(), 'no-input-group': !isInputGroup()}\"\r\n\t\t\t\t\t (ngModelChange)=\"changeNgModel($event)\"\r\n\t\t\t\t\t [(ngModel)]=\"valueDate\"\r\n\t\t\t\t\t [bsConfig]=\"{adaptivePosition: true, isAnimated: true, rangeSeparator: ' at\u00E9 ', rangeInputFormat: 'DD/MM/YYYY' }\"\r\n\t\t\t\t\t [readonly]=\"mxDisabled\"\r\n\t\t\t\t\t [disabled]=\"mxDisabled\"\r\n\t\t\t\t\t [placeholder]=\"mxPlaceholder\" />\r\n\t\t<input *ngIf=\"mxValue !== undefined && !isInputDate()\" [type]=\"mxType\"\r\n\t\t\t\t\t [value]=\"mxValue\"\r\n\t\t\t\t\t class=\"form-control input-sm\"\r\n\t\t\t\t\t [ngClass]=\"{'no-input-group': !isInputGroup()}\"\r\n\t\t\t\t\t [readonly]=\"mxDisabled\"\r\n\t\t\t\t\t [placeholder]=\"mxPlaceholder\" />\r\n\t\t<input *ngIf=\"mxValue !== undefined && isInputDate() && mxType !== 'daterange'\" type=\"text\"\r\n\t\t\t\t\t value=\"{{mxValue | date : getFormatDate()}}\"\r\n\t\t\t\t\t class=\"form-control input-sm\"\r\n\t\t\t\t\t [ngClass]=\"{'no-input-group': !isInputGroup()}\"\r\n\t\t\t\t\t [readonly]=\"mxDisabled\"\r\n\t\t\t\t\t [placeholder]=\"mxPlaceholder\" />\r\n\t</div>\r\n\r\n  <small *ngIf=\"hasErrors()\" class=\"text-danger\">\r\n    <span *ngFor=\"let error of listOfErrors() | slice:0:1\">{{error}}</span>\r\n  </small>\r\n</div>",
                styles: [".form-group label{margin-bottom:.25rem;font-weight:700}.form-control-label.required:after{color:red;content:\"*\";position:absolute;margin-left:7px}.no-input-group{width:100%}"]
            }] }
];
MxInputFormComponent.propDecorators = {
    mxType: [{ type: Input }],
    mxValue: [{ type: Input }],
    mxInputGroup: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxInputFormComponent.prototype.mxType;
    /** @type {?} */
    MxInputFormComponent.prototype.mxValue;
    /** @type {?} */
    MxInputFormComponent.prototype.valueDate;
    /** @type {?} */
    MxInputFormComponent.prototype.mxInputGroup;
}
/**
 * @record
 */
function ConfigInputGroup() { }
if (false) {
    /** @type {?} */
    ConfigInputGroup.prototype.classIcone;
    /** @type {?} */
    ConfigInputGroup.prototype.classText;
    /** @type {?} */
    ConfigInputGroup.prototype.text;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxSelectSearchFormComponent extends BaseFormField {
    /**
     * @param {?} controlDir
     * @param {?} restService
     */
    constructor(controlDir, restService) {
        super(controlDir);
        this.controlDir = controlDir;
        this.restService = restService;
        this.mxSearchable = true;
        this.mxMultiple = false;
        this.mxTypeahead = false;
        this.mxClearable = true;
        this.isLoading = false;
        this.typeaheadSubject = new Subject();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    change(event) {
        if (event && (isObject(event) || isArray(event)) && this.mxBindValue) {
            if (isArray(event)) {
                this.writeValue(event.map((/**
                 * @param {?} e
                 * @return {?}
                 */
                e => e[this.mxBindValue])));
            }
            else {
                this.writeValue(event[this.mxBindValue]);
            }
        }
        else {
            this.writeValue(event);
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.configureTypehead();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.typeaheadSubject.unsubscribe();
    }
    /**
     * @private
     * @return {?}
     */
    configureTypehead() {
        /** @type {?} */
        const valuesOld = [];
        if (this.value) {
            valuesOld.push(this.value);
        }
        this.datasAll$ = concat(of(valuesOld), // default items
        this.typeaheadSubject.pipe(debounceTime(500), distinctUntilChanged(), tap((/**
         * @return {?}
         */
        () => this.isLoading = true)), switchMap((/**
         * @param {?} term
         * @return {?}
         */
        term => this.restService.getter(this.mxEntidade, this.mxPathSearch(term), '')
            .pipe(catchError((/**
         * @return {?}
         */
        () => of([]))), // empty list on error
        tap((/**
         * @return {?}
         */
        () => this.isLoading = false)))))));
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getText(item) {
        if (!item) {
            return '';
        }
        if (this.mxBindLabel === undefined || this.mxBindLabel === null) {
            return item.toString();
        }
        else if (typeof this.mxBindLabel === 'string') {
            return item[(/** @type {?} */ (this.mxBindLabel))];
        }
        else if (typeof this.mxBindLabel === 'function') {
            return ((/** @type {?} */ (this.mxBindLabel)))(item);
        }
        else {
            return item.toString();
        }
    }
}
MxSelectSearchFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-select-search-form',
                template: "<div [ngClass]=\"{'form-group': mxLabel}\">\r\n  <label *ngIf=\"mxLabel\" class=\"form-control-label\" [ngClass]=\"{'required': isRequired}\">\r\n    {{mxLabel | translate}}\r\n  </label>\r\n  <div [ngClass]=\"{'input-group': mxInputGroup?.classButton}\">\r\n    <!-- select lista fixa -->\r\n    <ng-select *ngIf=\"!mxTypeahead\"\r\n              [items]=\"mxList\"\r\n              [bindValue]=\"mxBindValue\"\r\n              [placeholder]=\"mxPlaceholder | translate\"\r\n              [ngClass]=\"{'is-invalid': hasErrors(), 'select-action-group': mxInputGroup?.classButton !== null && mxInputGroup?.classButton !== undefined}\"\r\n              [(ngModel)]=\"value\"\r\n              [readonly]=\"mxDisabled\"\r\n              [multiple]=\"mxMultiple\"\r\n              [searchable]=\"mxSearchable\"\r\n              [clearable]=\"mxClearable\"\r\n              [clearSearchOnAdd]=\"true\"\r\n              (change)=\"change($event)\"\r\n              (focus)=\"onTouched()\">\r\n\r\n      <ng-template class=\"ng-value\" ng-label-tmp let-item=\"item\" let-clear=\"clear\">\r\n        <span class=\"ng-value-icon left\" (click)=\"clear(item)\" aria-hidden=\"true\">\u00D7</span>\r\n        <span class=\"ng-value-label\">{{getText(item)}}</span>\r\n      </ng-template>\r\n\r\n      <ng-template ng-multi-label-tmp let-items=\"items\" let-clear=\"clear\">\r\n        <div class=\"ng-value\" *ngFor=\"let item of items\">\r\n          <span class=\"ng-value-icon left\" (click)=\"clear(item)\" aria-hidden=\"true\">\u00D7</span>\r\n          <span class=\"ng-value-label\">{{getText(item)}}</span>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <ng-template ng-option-tmp let-item=\"item\">\r\n        {{getText(item)}}\r\n      </ng-template>\r\n\r\n    </ng-select>\r\n\r\n    <!-- mxTypeahead async -->\r\n    <ng-select *ngIf=\"mxTypeahead\"\r\n              [items]=\"datasAll$ | async\"\r\n              [bindValue]=\"mxBindValue\"\r\n              [hideSelected]=\"true\"\r\n              [loading]=\"isLoading\"\r\n              [typeahead]=\"typeaheadSubject\"\r\n              [typeToSearchText]=\"mxSearchText | translate\"\r\n              [placeholder]=\"mxPlaceholder | translate\"\r\n              [ngClass]=\"{'is-invalid': hasErrors(), 'select-action-group': mxInputGroup?.classButton !== null && mxInputGroup?.classButton !== undefined}\"\r\n              [(ngModel)]=\"value\"\r\n              [readonly]=\"mxDisabled\"\r\n              [multiple]=\"mxMultiple\"\r\n              [searchable]=\"mxSearchable\"\r\n              [clearable]=\"mxClearable\"\r\n              [clearSearchOnAdd]=\"true\"\r\n              [typeaheadMinLength]=\"0\"\r\n              (change)=\"change($event)\"\r\n              (focus)=\"onTouched()\">\r\n\r\n      <ng-template class=\"ng-value\" ng-label-tmp let-item=\"item\" let-clear=\"clear\">\r\n        <span class=\"ng-value-icon left\" (click)=\"clear(item)\" aria-hidden=\"true\">\u00D7</span>\r\n        <span class=\"ng-value-label\">{{getText(item)}}</span>\r\n      </ng-template>\r\n\r\n      <ng-template ng-multi-label-tmp let-items=\"items\" let-clear=\"clear\">\r\n        <div class=\"ng-value\" *ngFor=\"let item of items\">\r\n          <span class=\"ng-value-icon left\" (click)=\"clear(item)\" aria-hidden=\"true\">\u00D7</span>\r\n          <span class=\"ng-value-label\">{{getText(item)}}</span>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <ng-template ng-option-tmp let-item=\"item\">\r\n        {{getText(item)}}\r\n      </ng-template>\r\n\r\n    </ng-select>\r\n\r\n    <div *ngIf=\"mxInputGroup?.classButton\" class=\"input-group-append\">\r\n      <button class=\"btn-action-group {{mxInputGroup?.classButton}}\"\r\n              type=\"button\"\r\n              (click)=\"mxInputGroup?.action()\"\r\n              [tooltip]=\"mxInputGroup?.messageAction | translate\"\r\n              delay=\"300\"\r\n              container=\"body\"\r\n              placement=\"top\">\r\n        <i [class]=\"mxInputGroup?.classIcone\" aria-hidden=\"true\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <small *ngIf=\"hasErrors()\" class=\"text-danger\">\r\n    <span *ngFor=\"let error of listOfErrors() | slice:0:1\">{{error}}</span>\r\n  </small>\r\n</div>",
                styles: [".ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened>.ng-select-container .ng-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.ng-select.ng-select-opened>.ng-select-container .ng-arrow:hover{border-color:transparent transparent #333}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{color:#333;background-color:#fff;border-radius:4px;min-height:36px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}[dir=rtl] .ng-select .ng-select-container .ng-value-container{padding-right:10px;padding-left:0}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#999}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:5px;left:0;padding-left:10px;padding-right:50px}[dir=rtl] .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-right:10px;padding-left:50px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e6e6e6}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:5px;padding-left:7px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-right:7px;padding-left:0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-bottom:5px;background-color:#ebf5ff;border-radius:2px;margin-right:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{margin-right:0;margin-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:0;padding-right:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label{display:inline-block;padding:1px 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d1e8ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #b8dbff}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-left:1px solid #b8dbff;border-right:none}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #b8dbff}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:0;border-right:1px solid #b8dbff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 0 3px 3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 3px 3px 0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{padding-right:3px;padding-left:0}.ng-select .ng-clear-wrapper{color:#999}.ng-select .ng-clear-wrapper:hover .ng-clear{color:#d0021b}.ng-select .ng-spinner-zone{padding:5px 5px 0 0}[dir=rtl] .ng-select .ng-spinner-zone{padding:5px 0 0 5px}.ng-select .ng-arrow-wrapper{width:25px;padding-right:5px}[dir=rtl] .ng-select .ng-arrow-wrapper{padding-left:5px;padding-right:0}.ng-select .ng-arrow-wrapper:hover .ng-arrow{border-top-color:#666}.ng-select .ng-arrow-wrapper .ng-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px 0 rgba(0,0,0,.06);left:0}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{user-select:none;padding:8px 10px;font-weight:500;color:rgba(0,0,0,.54);cursor:pointer}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected.ng-option-marked{background-color:#ebf5ff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:rgba(0,0,0,.87);padding:5px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked{color:#333;background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#f5faff;color:#333}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-right:22px;padding-left:0}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{font-size:80%;font-weight:400;padding-right:5px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-left:5px;padding-right:0}[dir=rtl] .ng-dropdown-panel{direction:rtl;text-align:right}.form-group label{margin-bottom:.25rem;font-weight:700}.form-control-label.required:after{color:red;content:\"*\";position:absolute;margin-left:7px}.no-input-group{width:100%}.ng-select.ng-select-single .ng-select-container{height:34px;height:calc(1.5125rem + 2px)}.ng-select .ng-select-container{min-height:calc(1.7125rem + 3px);border:1px solid #ced4da;font-size:.9rem;line-height:1.5}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:6px}.nsm-content{padding:0!important}ng-select.ng-invalid.ng-touched .ng-select-container{border-color:#dc3545}ng-select.ng-invalid.ng-touched .ng-select-container:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.select-action-group{width:calc(100% - 38px)}.btn-action-group{width:38px}.input-group-append:not(:hover) .btn-outline.btn-info i:not(:hover){color:#17a2b8}.input-group-append:not(:hover) .btn-outline.btn-success i:not(:hover){color:#28a745}.input-group-append:not(:hover) .btn-outline.btn-danger i:not(:hover){color:#dc3545}.input-group-append:not(:hover) .btn-outline.btn-warning i:not(:hover){color:#ffc107}"]
            }] }
];
/** @nocollapse */
MxSelectSearchFormComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
    { type: MxBaseRestService }
];
MxSelectSearchFormComponent.propDecorators = {
    mxList: [{ type: Input }],
    mxBindValue: [{ type: Input }],
    mxBindLabel: [{ type: Input }],
    mxSearchable: [{ type: Input }],
    mxMultiple: [{ type: Input }],
    mxTypeahead: [{ type: Input }],
    mxSearchText: [{ type: Input }],
    mxClearable: [{ type: Input }],
    mxEntidade: [{ type: Input }],
    mxInputGroup: [{ type: Input }],
    mxPathSearch: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxList;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxBindValue;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxBindLabel;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxSearchable;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxMultiple;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxTypeahead;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxSearchText;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxClearable;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxEntidade;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxInputGroup;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.mxPathSearch;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.isLoading;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.datasAll$;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.typeaheadSubject;
    /** @type {?} */
    MxSelectSearchFormComponent.prototype.controlDir;
    /**
     * @type {?}
     * @private
     */
    MxSelectSearchFormComponent.prototype.restService;
}
/**
 * @record
 */
function ConfigSearchInputGroup() { }
if (false) {
    /** @type {?} */
    ConfigSearchInputGroup.prototype.classButton;
    /** @type {?} */
    ConfigSearchInputGroup.prototype.classIcone;
    /** @type {?} */
    ConfigSearchInputGroup.prototype.messageAction;
    /** @type {?} */
    ConfigSearchInputGroup.prototype.action;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxSwithFormComponent extends BaseFormField {
    constructor() {
        super(...arguments);
        this.mxValueTrue = true;
        this.mxValueFalse = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    change(event) {
        this.writeValue(event.target.checked);
    }
    /**
     * @return {?}
     */
    onClick() {
        this.value = (this.value === this.mxValueTrue ? this.mxValueFalse : this.mxValueTrue);
        this.writeValue(this.value);
    }
}
MxSwithFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-switch-form',
                template: "<div [ngClass]=\"{'form-group': mxLabel}\">\r\n  <label *ngIf=\"mxLabel\" class=\"form-control-label\">\r\n    {{mxLabel | translate}}\r\n  </label>\r\n  <div (click)=\"onClick()\" class=\"switch\" [ngClass]=\"{ 'checked': value }\">\r\n    <input type=\"checkbox\" class=\"switch-input\" [attr.checked]=\"value\">\r\n    <span class=\"switch-label\" [attr.data-on]=\"mxTextTrue\" [attr.data-off]=\"mxTextFalse\"></span>\r\n    <span class=\"switch-handle\"></span>\r\n  </div>\r\n</div>",
                styles: [".form-group label{margin-bottom:.25rem;font-weight:700}.form-control-label.required:after{color:red;content:\"*\";position:absolute;margin-left:7px}.no-input-group{width:100%}.switch{position:relative;vertical-align:top;width:60px;height:calc(1.5125rem + 2px);padding:3px;background-color:none;cursor:pointer;overflow:visible}.switch:focus-within{outline:Highlight solid 2px}.switch-input{position:absolute;top:0;left:0;opacity:0}.switch-label{position:relative;display:block;height:inherit;font-size:16px;font-weight:400;-webkit-transition:opacity .35s ease-out;transition:opacity .35s ease-out;color:#2d2d2d}.switch-label::after,.switch-label::before{position:absolute;top:50%;margin-top:-.5em;line-height:1;-webkit-transition:inherit;transition:inherit}.switch-label::before{content:attr(data-off);right:9px;color:#fff}.switch-label::after{content:attr(data-on);left:11px;color:#fff;opacity:0}.switch-handle{position:absolute;top:7px;left:7px;width:18px;height:18px;background:#fff;border-radius:8px;box-shadow:1px 1px 5px #2d2d2d;-webkit-transition:left .35s ease-out;transition:left .35s ease-out}.checked .switch-label{box-shadow:inset 0 1px 2px rgba(255,255,255,.5),inset 0 0 3px rgba(0,0,0,.15);background:#4caf50!important}.checked .switch-label::before{opacity:0}.checked .switch-label::after{opacity:1}.checked .switch-handle{left:36px;box-shadow:-1px 1px 5px rgba(45,45,45,.41)}.switch-label{border-radius:15px;background:#f17171!important}"]
            }] }
];
MxSwithFormComponent.propDecorators = {
    mxTextTrue: [{ type: Input }],
    mxTextFalse: [{ type: Input }],
    mxValueTrue: [{ type: Input }],
    mxValueFalse: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxSwithFormComponent.prototype.mxTextTrue;
    /** @type {?} */
    MxSwithFormComponent.prototype.mxTextFalse;
    /** @type {?} */
    MxSwithFormComponent.prototype.mxValueTrue;
    /** @type {?} */
    MxSwithFormComponent.prototype.mxValueFalse;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxTextAreaFormComponent extends BaseFormField {
    constructor() {
        super(...arguments);
        this.mxType = 'date';
        this.mxValue = undefined;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    change(event) {
        this.writeValue(event.target.value);
    }
    /**
     * @return {?}
     */
    getFormatDate() {
        return (this.mxType === 'date' ? 'DD/MM/YYYY' : 'DD/MM/YYYY hh:mm:ss');
    }
}
MxTextAreaFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-textarea-form',
                template: "<div [ngClass]=\"{'form-group': mxLabel}\">\r\n  <label *ngIf=\"mxLabel\" class=\"form-control-label\" [ngClass]=\"{'required': isRequired}\">\r\n    {{mxLabel | translate}}\r\n  </label>\r\n  <textarea rows=\"3\"\r\n            [value]=\"value\"\r\n            class=\"form-control input-sm\"\r\n            [ngClass]=\"{'is-invalid': hasErrors()}\"\r\n            (input)=\"change($event)\"\r\n            [readonly]=\"mxDisabled\"\r\n            [placeholder]=\"mxPlaceholder\">\r\n  </textarea>\r\n  <small *ngIf=\"hasErrors()\" class=\"text-danger\">\r\n    <span *ngFor=\"let error of listOfErrors() | slice:0:1\">{{error}}</span>\r\n  </small>\r\n</div>",
                styles: [".form-group label{margin-bottom:.25rem;font-weight:700}.form-control-label.required:after{color:red;content:\"*\";position:absolute;margin-left:7px}.no-input-group{width:100%}"]
            }] }
];
MxTextAreaFormComponent.propDecorators = {
    mxType: [{ type: Input }],
    mxValue: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxTextAreaFormComponent.prototype.mxType;
    /** @type {?} */
    MxTextAreaFormComponent.prototype.mxValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxCurrencyFormComponent extends BaseFormField {
    constructor() {
        super(...arguments);
        this.mxPrecision = 2;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    change(event) {
        this.writeValue(event);
    }
}
MxCurrencyFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-currency-form',
                template: "<div [ngClass]=\"{'form-group': mxLabel}\">\r\n  <label *ngIf=\"mxLabel\" class=\"form-control-label\" [ngClass]=\"{'required': isRequired}\">\r\n    {{mxLabel | translate}}\r\n  </label>\r\n  <div [ngClass]=\"{'input-group': (mxInputGroup?.classIcone || mxInputGroup?.text)}\">\r\n    \r\n    <div *ngIf=\"(mxInputGroup?.classIcone || mxInputGroup?.text)\" class=\"input-group-prepend\">\r\n      <div class=\"input-group-text\">\r\n        <span [class]=\"mxInputGroup?.classText\">{{mxInputGroup?.text}}</span>\r\n        <i *ngIf=\"mxInputGroup?.classIcone\" [class]=\"mxInputGroup?.classIcone\" aria-hidden=\"true\"></i>\r\n      </div>\r\n    </div>\r\n\r\n    <input currencyMask\r\n           [options]=\"{ prefix: '', thousands: '.', decimal: ',', precision: mxPrecision }\"\r\n           [(ngModel)]=\"value\"\r\n           class=\"form-control input-sm\"\r\n           [ngClass]=\"{'is-invalid': hasErrors(), 'no-input-group': !(mxInputGroup?.classIcone || mxInputGroup?.text)}\"\r\n           (ngModelChange)=\"change($event)\"\r\n           [readonly]=\"mxDisabled\"\r\n           [placeholder]=\"mxPlaceholder\" />\r\n  </div>\r\n\r\n  <small *ngIf=\"hasErrors()\" class=\"text-danger\">\r\n    <span *ngFor=\"let error of listOfErrors() | slice:0:1\">{{error}}</span>\r\n  </small>\r\n</div>",
                styles: [".form-group label{margin-bottom:.25rem;font-weight:700}.form-control-label.required:after{color:red;content:\"*\";position:absolute;margin-left:7px}.no-input-group{width:100%}"]
            }] }
];
MxCurrencyFormComponent.propDecorators = {
    mxPrecision: [{ type: Input }],
    mxInputGroup: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxCurrencyFormComponent.prototype.mxPrecision;
    /** @type {?} */
    MxCurrencyFormComponent.prototype.mxInputGroup;
}
/**
 * @record
 */
function ConfigCurrenctInputGroup() { }
if (false) {
    /** @type {?} */
    ConfigCurrenctInputGroup.prototype.classIcone;
    /** @type {?} */
    ConfigCurrenctInputGroup.prototype.classText;
    /** @type {?} */
    ConfigCurrenctInputGroup.prototype.text;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputSugestionComponent {
    constructor() {
        this.mask = {};
        this.mxModelChange = new EventEmitter();
        this.mxPlaceholder = '';
        this.mxDivClass = '';
        this.mxReadonly = false;
        this.mxChange = new EventEmitter();
        this.mxBlur = new EventEmitter();
        this.mxClick = new EventEmitter();
        this.mxKeyPress = new EventEmitter();
        this.states = [
            'Alabama',
            'Alaska',
            'Arizona'
        ];
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyPress(event) {
        if (this.mxKeyPress) {
            this.mxKeyPress.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChange(event) {
        this.mxModel = event.target.value;
        if (this.mxChange) {
            this.mxChange.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onBlur(event) {
        if (this.mxBlur) {
            this.mxBlur.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (this.mxClick) {
            this.mxClick.emit(event.target.value);
        }
    }
}
MxInputSugestionComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-sugestion',
                template: "<div class=\" form-group\" [ngClass]=\"mxDivClass\">\n    <label *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\">{{mxLabel}}</label>\n    <input type=\"text\" [(ngModel)]=\"selected\" [typeahead]=\"states\" class=\"form-control input-sm\" [readonly]=\"mxReadonly\" [(ngModel)]=\"mxModel\"\n        (change)=\"onChange($event)\" (blur)=\"onBlur($event)\" (click)=\"onClick($event)\" [(placeholder)]=\"mxPlaceholder\"\n        (keypress)=\"onKeyPress($event)\" [ngClass]=\"mxInputClass\">\n    <small [ngClass]=\"mxHelpClass\" *ngIf=\"mxHelp\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>",
                styles: [""]
            }] }
];
MxInputSugestionComponent.propDecorators = {
    mxModel: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxPlaceholder: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxReadonly: [{ type: Input }],
    mxChange: [{ type: Output }],
    mxBlur: [{ type: Output }],
    mxClick: [{ type: Output }],
    mxKeyPress: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxInputSugestionComponent.prototype._mxModel;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mask;
    /** @type {?} */
    MxInputSugestionComponent.prototype.brMasker;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxPlaceholder;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxReadonly;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxChange;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxBlur;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxClick;
    /** @type {?} */
    MxInputSugestionComponent.prototype.mxKeyPress;
    /** @type {?} */
    MxInputSugestionComponent.prototype.states;
    /** @type {?} */
    MxInputSugestionComponent.prototype.selected;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputTextareaComponent {
    constructor() {
        this.mask = {};
        this.mxModelChange = new EventEmitter();
        this.mxPlaceholder = '';
        this.mxPrependIcon = '';
        this.mxAppendIcon = '';
        this.mxDivClass = '';
        this.mxReadonly = false;
        this.mxMaxLength = false;
        this.mxTabindex = 0;
        this.mxChange = new EventEmitter();
        this.mxBlur = new EventEmitter();
        this.mxClick = new EventEmitter();
        this.mxKeyPress = new EventEmitter();
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyPress(event) {
        if (this.mxKeyPress) {
            this.mxKeyPress.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChange(event) {
        if (this.mxChange) {
            this.mxChange.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onBlur(event) {
        if (this.mxBlur) {
            this.mxBlur.emit(event.target.value);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (this.mxClick) {
            this.mxClick.emit(event.target.value);
        }
    }
}
MxInputTextareaComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-textarea',
                template: "<div class=\" form-group\" [ngClass]=\"mxDivClass\">\n    <label *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\">{{mxLabel}}</label>\n    <div class=\"input-group\">\n        <div *ngIf=\"mxPrependIcon\" class=\"input-group-prepend\"><span class=\"input-group-text\">{{mxPrependIcon}}</span></div>\n\n        <textarea class=\"form-control input-sm\" rows=\"3\"\n            [readonly]=\"mxReadonly\" [(ngModel)]=\"mxModel\" (change)=\"onChange($event)\" (blur)=\"onBlur($event)\"\n            (click)=\"onClick($event)\" [(placeholder)]=\"mxPlaceholder\" (keypress)=\"onKeyPress($event)\"\n            [ngClass]=\"mxInputClass\" [maxlength]=\"mxMaxLength\" [tabindex]=\"mxTabindex\"></textarea>\n\n        <div *ngIf=\"mxAppendIcon\" class=\"input-group-append\"><span class=\"input-group-text\">{{mxAppendIcon}}</span></div>\n    </div>\n    <small [ngClass]=\"mxHelpClass\" *ngIf=\"mxHelp\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>",
                styles: [""]
            }] }
];
/** @nocollapse */
MxInputTextareaComponent.ctorParameters = () => [];
MxInputTextareaComponent.propDecorators = {
    mxModel: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxPlaceholder: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxPrependIcon: [{ type: Input }],
    mxAppendIcon: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxReadonly: [{ type: Input }],
    mxMaxLength: [{ type: Input }],
    mxTabindex: [{ type: Input }],
    mxChange: [{ type: Output }],
    mxBlur: [{ type: Output }],
    mxClick: [{ type: Output }],
    mxKeyPress: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxInputTextareaComponent.prototype._mxModel;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mask;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxPlaceholder;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxPrependIcon;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxAppendIcon;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxReadonly;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxMaxLength;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxTabindex;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxChange;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxBlur;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxClick;
    /** @type {?} */
    MxInputTextareaComponent.prototype.mxKeyPress;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputColorFormComponent extends BaseFormField {
    constructor() {
        super(...arguments);
        this.mxColorMode = 'color';
    }
    /**
     * @param {?} event
     * @return {?}
     */
    change(event) {
        super.writeValue(event.target.value);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    changeNgModel(event) {
        super.writeValue(event);
    }
}
MxInputColorFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-color-form',
                template: "<div [ngClass]=\"{'form-group': mxLabel}\">\r\n  <label *ngIf=\"mxLabel\" class=\"form-control-label\" [ngClass]=\"{'required': isRequired}\">\r\n    {{mxLabel | translate}}\r\n  </label>\r\n\r\n  <div class=\"input-group\">\r\n\t\t<div class=\"input-group-prepend\">\r\n\t\t\t<div class=\"input-group-text\">\r\n\t\t\t\t<i class=\"fa fa-palette\" aria-hidden=\"true\"></i>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<input type=\"text\"\r\n\t\t\t\t\t [(colorPicker)]=\"value\"\r\n\t\t\t\t\t [style.background]=\"value\"\r\n\t\t\t\t\t class=\"form-control input-sm\"\r\n\t\t\t\t\t [cpColorMode]=\"mxColorMode\"\r\n\t\t\t\t\t [ngClass]=\"{'is-invalid': hasErrors()}\"\r\n\t\t\t\t\t (colorPickerChange)=\"changeNgModel($event)\"\r\n\t\t\t\t\t [(ngModel)]=\"value\"\r\n\t\t\t\t\t cpPosition='left'\r\n\t\t\t\t\t [readonly]=\"true\"\r\n\t\t\t\t\t [disabled]=\"mxDisabled\"\r\n\t\t\t\t\t [cpDisableInput]=\"true\"\r\n\t\t\t\t\t [placeholder]=\"mxPlaceholder\" />\r\n\t</div>\r\n  <small *ngIf=\"hasErrors()\" class=\"text-danger\">\r\n    <span *ngFor=\"let error of listOfErrors() | slice:0:1\">{{error}}</span>\r\n  </small>\r\n</div>",
                styles: [".form-group label{margin-bottom:.25rem;font-weight:700}.form-control-label.required:after{color:red;content:\"*\";position:absolute;margin-left:7px}.no-input-group{width:100%}.form-control{border-top-right-radius:.2rem!important;border-bottom-right-radius:.2rem!important}"]
            }] }
];
MxInputColorFormComponent.propDecorators = {
    mxColorMode: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxInputColorFormComponent.prototype.mxColorMode;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxInputTimePickerComponent {
    constructor() {
        this.mxModelChange = new EventEmitter();
        this.mxOnTimeSelect = new EventEmitter();
        this.mxPlaceHolder = '';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxModelChange.emit(val);
        this._mxModel = val;
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this._mxModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.mxAppendIcon = 'far fa-clock';
        this.mxDisabled = false;
        if (!this._mxModel) {
            this._mxModel = null;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onTimeSelect(event) {
        if (this.mxOnTimeSelect) {
            this.mxOnTimeSelect.emit(event);
        }
    }
    /**
     * @return {?}
     */
    inputClick() {
        if (!this.mxDisabled) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.iptElement.nativeElement.click();
            }), 100);
        }
    }
    /**
     * @param {?} $val
     * @return {?}
     */
    validaHora($val) {
        /** @type {?} */
        const regexp = new RegExp('(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]');
        /** @type {?} */
        const booHora = regexp.test($val);
        if (!booHora) {
            this.mxModel = '';
        }
    }
}
MxInputTimePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-input-time-picker',
                template: "<div class=\" form-group\" [ngClass]=\"mxDivClass\">\n    <label *ngIf=\"mxLabel\" [ngClass]=\"mxLabelClass\" >{{mxLabel}}</label>\n    <div class=\"input-group\">\n      <div *ngIf=\"mxPrependIcon\" class=\"input-group-prepend\"><span class=\"input-group-text\"><i class=\"{{mxPrependIcon}}\"></i></span></div>\n      <input  #iptElement type=\"text\" [(placeholder)]=\"mxPlaceHolder\" class=\"form-control\" [attr.disabled]=\"mxDisabled ? 'disabled' : null\"\n        atp-time-picker changeToMinutes=\"true\" [brmasker]=\"{mask: '00:00', type:'num', len:5 }\"\n        (blur)=\"validaHora($event.target.value)\" [(ngModel)]=\"mxModel\" [ngClass]=\"mxInputClass\" >\n      <div *ngIf=\"mxAppendIcon\" class=\"input-group-append\"><span class=\"input-group-text\" (click)=\"inputClick()\"><i class=\"{{mxAppendIcon}}\"></i></span></div>\n    </div>\n    <small id=\"idHelper\" [ngClass]=\"mxHelpClass\" *ngIf=\"mxLabel\" class=\"form-text text-muted\">{{mxHelp}}</small>\n</div>",
                styles: ["#time-picker-wrapper.light #time-picker .time-picker-clock .time-picker-clock-arrow,#time-picker-wrapper.light #time-picker .time-picker-clock .time-picker-clock-arrow span{background:#5cb85c}"]
            }] }
];
/** @nocollapse */
MxInputTimePickerComponent.ctorParameters = () => [];
MxInputTimePickerComponent.propDecorators = {
    mxModel: [{ type: Input }],
    iptElement: [{ type: ViewChild, args: ['iptElement', { read: ElementRef, static: true },] }],
    mxModelChange: [{ type: Output }],
    mxInputClass: [{ type: Input }],
    mxHelp: [{ type: Input }],
    mxHelpClass: [{ type: Input }],
    mxLabel: [{ type: Input }],
    mxLabelClass: [{ type: Input }],
    mxDivClass: [{ type: Input }],
    mxOnTimeSelect: [{ type: Output }],
    mxPlaceHolder: [{ type: Input }],
    mxPrependIcon: [{ type: Input }],
    mxAppendIcon: [{ type: Input }],
    mxDisabled: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MxInputTimePickerComponent.prototype._mxModel;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.iptElement;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxModelChange;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxInputClass;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxHelp;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxHelpClass;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxLabel;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxLabelClass;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxDivClass;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxOnTimeSelect;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxPlaceHolder;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxPrependIcon;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxAppendIcon;
    /** @type {?} */
    MxInputTimePickerComponent.prototype.mxDisabled;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ListCustomInput() { }
class CustomInput {
    /**
     * @param {?=} __0
     */
    constructor({ name = '', visible = true, required = false, readonly = false, cursor = false, columns = [] } = {}) {
        this.name = name;
        this.visible = (visible) ? visible : true;
        this.required = (required) ? visible : false;
        this.readonly = (readonly) ? visible : false;
        this.cursor = (cursor) ? visible : false;
        this.columnsModalLov = columns;
    }
    /**
     * @param {?} oldValues
     * @return {?}
     */
    checkChange(oldValues) {
        /** @type {?} */
        const retorno = [];
        if (oldValues) {
            if (this.required !== oldValues.required) {
                retorno.push('required');
            }
            if (this.visible !== oldValues.visible) {
                retorno.push('visible');
            }
            if (this.readonly !== oldValues.readonly) {
                retorno.push('readonly');
            }
            if (this.cursor !== oldValues.cursor) {
                retorno.push('cursor');
            }
        }
        return retorno;
    }
    /**
     * @param {?} oldValues
     * @return {?}
     */
    updateOldValue(oldValues) {
        if (oldValues) {
            if (this.required !== oldValues.required) {
                oldValues.required = this.required;
            }
            if (this.visible !== oldValues.visible) {
                oldValues.visible = this.visible;
            }
            if (this.readonly !== oldValues.readonly) {
                oldValues.readonly = this.readonly;
            }
            if (this.cursor !== oldValues.cursor) {
                oldValues.cursor = this.cursor;
            }
        }
        return oldValues;
    }
}
if (false) {
    /** @type {?} */
    CustomInput.prototype.name;
    /** @type {?} */
    CustomInput.prototype.required;
    /** @type {?} */
    CustomInput.prototype.visible;
    /** @type {?} */
    CustomInput.prototype.readonly;
    /** @type {?} */
    CustomInput.prototype.cursor;
    /** @type {?} */
    CustomInput.prototype.columnsModalLov;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxMaxysInputLovComponent {
    /**
     * @param {?} restService
     * @param {?} modalService
     */
    constructor(restService, modalService) {
        this.restService = restService;
        this.modalService = modalService;
        this.mxModelChange = new EventEmitter();
        this.mxCustomInputChange = new EventEmitter();
        this.mxSelected = new EventEmitter();
        this.Mxchange = new EventEmitter();
        this.Mxblur = new EventEmitter();
        this.Mxfocus = new EventEmitter();
        this.Mxclick = new EventEmitter();
        this.Mxkeypress = new EventEmitter();
        this.Mxkeydown = new EventEmitter();
        this.listaRegistros = [];
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxIptModel = val;
        this.mxModelChange.emit(val);
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this.mxIptModel;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxCustomInput(val) {
        this.mxCustomInputAux = val;
        this.mxCustomInputChange.emit(val);
    }
    /**
     * @return {?}
     */
    get mxCustomInput() {
        return this.mxCustomInputAux;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (!this.mxCustomInput) {
                this.mxCustomInput = new CustomInput();
            }
        }), 100);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onChange($event) {
        if (this.Mxchange) {
            this.Mxchange.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onBlur($event) {
        if (this.Mxblur) {
            this.Mxblur.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onFocus($event) {
        if (this.Mxfocus) {
            this.Mxclick.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        if (this.Mxclick) {
            this.Mxclick.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onKeyPress($event) {
        if (this.Mxkeypress) {
            this.Mxkeypress.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onKeyDown($event) {
        if ($event.code === 'F9') {
            this.openLov();
        }
        if (this.Mxkeydown) {
            this.Mxkeydown.emit($event);
        }
    }
    /**
     * @return {?}
     */
    openLov() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const add = new ModalOptions();
            add.class = 'modal-lg';
            add.backdrop = true;
            add.initialState = {
                columns: this.mxCustomInput.columnsModalLov,
                title: 'Empresas',
                fieldSearch: this.mxModel,
                mxQuery: this.mxQuery,
                mxCustomInput: this.mxCustomInput,
                callBack: (/**
                 * @param {?} data
                 * @return {?}
                 */
                (data) => {
                    if (data && this.mxSelected) {
                        this.mxSelected.emit(data);
                    }
                }),
            };
            this.modalService.show(MxMaxysLovComponent, add);
            this.modalService.checkScrollbar();
        }), 750);
    }
    /**
     * @return {?}
     */
    buscarRegistros() {
        if (this.mxModel) {
            this.restService
                .post('executa_query', 'find', { query: this.mxQuery, search: this.mxModel })
                .subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                this.listaRegistros = data;
            }));
        }
    }
}
MxMaxysInputLovComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-maxys-input-lov',
                template: "<mx-maxys-input *ngIf=\"mxCustomInput\" [(mxModel)]=\"mxModel\" [(mxCustomInput)]=\"mxCustomInput\"\n    (mxChange)=\"onChange($event)\" (mxBlur)=\"onBlur($event)\" (mxFocus)=\"onFocus($event)\" \n    (mxClick)=\"onClick($event)\" (mxKeyPress)=\"onKeyPress($event)\" (mxKeyDown)=\"onKeyDown($event)\"\n></mx-maxys-input>",
                styles: [".form-group{width:100%;height:100%}.form-group input.form-control{width:100%;height:100%;display:block}"]
            }] }
];
/** @nocollapse */
MxMaxysInputLovComponent.ctorParameters = () => [
    { type: MxBaseRestService },
    { type: BsModalService }
];
MxMaxysInputLovComponent.propDecorators = {
    mxModelChange: [{ type: Output }],
    mxModel: [{ type: Input }],
    mxCustomInputChange: [{ type: Output }],
    mxCustomInput: [{ type: Input }],
    mxQuery: [{ type: Input }],
    mxSelected: [{ type: Output }],
    Mxchange: [{ type: Output }],
    Mxblur: [{ type: Output }],
    Mxfocus: [{ type: Output }],
    Mxclick: [{ type: Output }],
    Mxkeypress: [{ type: Output }],
    Mxkeydown: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.mxModelChange;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.mxIptModel;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.mxCustomInputChange;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.mxCustomInputAux;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.mxQuery;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.mxSelected;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.Mxchange;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.Mxblur;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.Mxfocus;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.Mxclick;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.Mxkeypress;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.Mxkeydown;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.requestActive;
    /** @type {?} */
    MxMaxysInputLovComponent.prototype.listaRegistros;
    /**
     * @type {?}
     * @private
     */
    MxMaxysInputLovComponent.prototype.restService;
    /**
     * @type {?}
     * @private
     */
    MxMaxysInputLovComponent.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LovModel {
    /**
     * @param {?=} __0
     */
    constructor({ name = '', query = '', columns = [], callback = null } = {}) {
        this.name = name;
        this.query = query;
        this.columnsModalLov = columns;
        this.callback = callback;
    }
}
if (false) {
    /** @type {?} */
    LovModel.prototype.name;
    /** @type {?} */
    LovModel.prototype.query;
    /** @type {?} */
    LovModel.prototype.callback;
    /** @type {?} */
    LovModel.prototype.columnsModalLov;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxMaxysInputComponent {
    /**
     * @param {?} changeRef
     * @param {?} lovService
     */
    constructor(changeRef, lovService) {
        this.changeRef = changeRef;
        this.lovService = lovService;
        this.mxCustomInputChange = new EventEmitter();
        this.mxModelChange = new EventEmitter();
        // @Input() mxQuery: string;
        // @Output() mxSelected: EventEmitter<any> = new EventEmitter<any>();
        // --openLov--
        // --onError--
        // --onInit--
        // --onCustomEvent--
        this.mxClick = new EventEmitter();
        this.mxDblClick = new EventEmitter();
        this.mxChange = new EventEmitter();
        this.mxBlur = new EventEmitter();
        this.mxFocus = new EventEmitter();
        this.mxKeyPress = new EventEmitter();
        this.mxKeyDown = new EventEmitter();
        this.mxOpenLov = new EventEmitter();
        this.mxOnError = new EventEmitter();
        this.mxOnInit = new EventEmitter();
        this.mxCustomEvent = new EventEmitter();
        this.timerClick = null;
        this.preventSimpleClick = null;
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (!this.mxCustomInput) {
                this.mxCustomInput = new CustomInput();
            }
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.oldCustomInput = Object.assign({}, this.mxCustomInput);
                if (this.mxOnInit) {
                    this.mxOnInit.emit();
                }
            }), 300);
        }), 300);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxCustomInput(val) {
        this.mxCustomInputAux = val;
        this.mxCustomInputChange.emit(val);
    }
    /**
     * @return {?}
     */
    get mxCustomInput() {
        return this.mxCustomInputAux;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set mxModel(val) {
        this.mxIptModel = val;
        this.mxModelChange.emit(val);
    }
    /**
     * @return {?}
     */
    get mxModel() {
        return this.mxIptModel;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.mxCustomInput) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.mxCustomInput = new CustomInput();
            }), 300);
        }
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (this.mxCustomInput) {
            /** @type {?} */
            const list = this.mxCustomInput.checkChange(this.oldCustomInput);
            if (list.indexOf('cursor') >= 0 && this.mxCustomInput.cursor) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.iptElement.nativeElement.focus();
                }), 100);
            }
            if (list.length > 0) {
                this.oldCustomInput = this.mxCustomInput.updateOldValue(this.oldCustomInput);
                this.changeRef.detectChanges();
            }
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onChange($event) {
        if (this.mxChange) {
            this.mxChange.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onBlur($event) {
        if (this.mxBlur) {
            this.mxBlur.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onFocus($event) {
        if (this.mxFocus) {
            this.mxFocus.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onKeyPress($event) {
        if (this.mxModel) {
            this.mxModel = this.mxModel.toUpperCase();
        }
        if (this.mxKeyPress) {
            this.mxKeyPress.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onKeyDown($event) {
        if ($event.code === 'F9') {
            this.openLov($event);
        }
        if (this.mxKeyDown) {
            this.mxKeyDown.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        this.timerClick = null;
        this.preventSimpleClick = false;
        this.timerClick = setTimeout((/**
         * @return {?}
         */
        () => {
            if (!this.preventSimpleClick) {
                this.mxClick.emit($event);
            }
        }), 250);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onDblClick($event) {
        this.preventSimpleClick = true;
        clearTimeout(this.timerClick);
        this.mxDblClick.emit($event);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onError($event) {
        if (this.mxOnError) {
            this.mxOnError.emit($event);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    openLov($event) {
        if (this.mxLovConfiguration) {
            this.lovService.openLov(this.mxLovConfiguration, this.mxModel, this.mxChange);
        }
        else if (this.mxOpenLov) {
            this.mxOpenLov.emit($event);
        }
    }
}
MxMaxysInputComponent.decorators = [
    { type: Component, args: [{
                selector: 'mx-maxys-input',
                template: "<div class=\"form-group\">\n    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"mxModel\" #iptElement ngDefaultControl\n        (blur)=\"onBlur($event)\" (focus)=\"onFocus($event)\" (change)=\"onChange($event)\" \n        (keypress)=\"onKeyPress($event)\" (keydown)=\"onKeyDown($event)\"\n        (click)=\"onClick($event)\"(dblclick)=\"onDblClick($event)\" (error)=\"onError($event)\"\n        [style.visibility]=\"(mxCustomInput?.visible) ? 'unset' : 'hidden'\"\n        [readonly]=\"mxCustomInput?.readonly\" />\n</div>",
                styles: [".form-group,.form-group .form-control{margin:0;height:100%}"]
            }] }
];
/** @nocollapse */
MxMaxysInputComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: MxModalLovMaxysService }
];
MxMaxysInputComponent.propDecorators = {
    iptElement: [{ type: ViewChild, args: ['iptElement', { read: ElementRef, static: true },] }],
    mxCustomInputChange: [{ type: Output }],
    mxCustomInput: [{ type: Input }],
    mxModelChange: [{ type: Output }],
    mxModel: [{ type: Input }],
    mxLovConfiguration: [{ type: Input }],
    mxClick: [{ type: Output }],
    mxDblClick: [{ type: Output }],
    mxChange: [{ type: Output }],
    mxBlur: [{ type: Output }],
    mxFocus: [{ type: Output }],
    mxKeyPress: [{ type: Output }],
    mxKeyDown: [{ type: Output }],
    mxOpenLov: [{ type: Output }],
    mxOnError: [{ type: Output }],
    mxOnInit: [{ type: Output }],
    mxCustomEvent: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MxMaxysInputComponent.prototype.iptElement;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxCustomInputChange;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxCustomInputAux;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxModelChange;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxIptModel;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxLovConfiguration;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxClick;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxDblClick;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxChange;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxBlur;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxFocus;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxKeyPress;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxKeyDown;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxOpenLov;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxOnError;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxOnInit;
    /** @type {?} */
    MxMaxysInputComponent.prototype.mxCustomEvent;
    /**
     * @type {?}
     * @private
     */
    MxMaxysInputComponent.prototype.oldCustomInput;
    /**
     * @type {?}
     * @private
     */
    MxMaxysInputComponent.prototype.timerClick;
    /**
     * @type {?}
     * @private
     */
    MxMaxysInputComponent.prototype.preventSimpleClick;
    /**
     * @type {?}
     * @private
     */
    MxMaxysInputComponent.prototype.changeRef;
    /** @type {?} */
    MxMaxysInputComponent.prototype.lovService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxCommonsModule {
}
MxCommonsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    MxModalConfirmComponent,
                    MxModalListComponent,
                    MxModalLovComponent,
                    MxModalInfoComponent,
                    MxDataTableComponent,
                    MxDataTablePaginatorComponent,
                    MxDataTableListComponent,
                    MxInputTextComponent,
                    MxInputDateComponent,
                    MxSelectOneComponent,
                    MxInputDateRangeComponent,
                    MxInputCheckBoxComponent,
                    MxInputLovComponent,
                    MxSelectDualListComponent,
                    MxInputFormComponent,
                    MxSelectSearchFormComponent,
                    MxSwithFormComponent,
                    MxTextAreaFormComponent,
                    MxInputSugestionComponent,
                    MxInputTextareaComponent,
                    MxCurrencyFormComponent,
                    MxInputColorFormComponent,
                    MxInputTimePickerComponent,
                    MxMaxysInputLovComponent,
                    MxMaxysLovComponent,
                    MxMaxysInputComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ModalModule.forRoot(),
                    PaginationModule.forRoot(),
                    BsDatepickerModule.forRoot(),
                    AngularDualListBoxModule,
                    ToastrModule.forRoot(),
                    MxLanguageTranslationModule,
                    BrMaskerModule,
                    ReactiveFormsModule,
                    NgSelectModule,
                    LoadingBarRouterModule,
                    LoadingBarHttpClientModule,
                    TypeaheadModule.forRoot(),
                    NgxCurrencyModule,
                    TooltipModule.forRoot(),
                    ColorPickerModule,
                    AmazingTimePickerModule
                ],
                entryComponents: [
                    MxModalConfirmComponent,
                    MxModalListComponent,
                    MxModalLovComponent,
                    MxModalInfoComponent,
                    MxInputTextComponent,
                    MxInputDateComponent,
                    MxSelectOneComponent,
                    MxInputDateRangeComponent,
                    MxInputCheckBoxComponent,
                    MxInputLovComponent,
                    MxSelectDualListComponent,
                    MxDataTableComponent,
                    MxDataTablePaginatorComponent,
                    MxDataTableListComponent,
                    MxInputFormComponent,
                    MxSelectSearchFormComponent,
                    MxTextAreaFormComponent,
                    MxSwithFormComponent,
                    MxInputTextareaComponent,
                    MxCurrencyFormComponent,
                    MxInputColorFormComponent,
                    MxInputTimePickerComponent,
                    MxMaxysInputLovComponent,
                    MxMaxysLovComponent,
                    MxMaxysInputComponent
                ],
                exports: [
                    MxModalConfirmComponent,
                    MxModalListComponent,
                    MxModalLovComponent,
                    MxModalInfoComponent,
                    MxInputTextComponent,
                    MxInputDateComponent,
                    MxSelectOneComponent,
                    MxInputDateRangeComponent,
                    MxInputCheckBoxComponent,
                    MxInputLovComponent,
                    MxSelectDualListComponent,
                    MxDataTableComponent,
                    MxDataTablePaginatorComponent,
                    MxDataTableListComponent,
                    MxInputFormComponent,
                    MxSelectSearchFormComponent,
                    MxSwithFormComponent,
                    MxTextAreaFormComponent,
                    MxInputSugestionComponent,
                    MxInputTextareaComponent,
                    MxCurrencyFormComponent,
                    MxInputColorFormComponent,
                    MxInputTimePickerComponent,
                    MxMaxysInputLovComponent,
                    MxMaxysLovComponent,
                    MxMaxysInputComponent
                ],
                bootstrap: [
                    MxInputTextComponent,
                    MxInputDateComponent,
                    MxSelectOneComponent,
                    MxInputDateRangeComponent,
                    MxInputCheckBoxComponent,
                    MxInputLovComponent,
                    MxSelectDualListComponent,
                    MxDataTableComponent,
                    MxDataTablePaginatorComponent,
                    MxDataTableListComponent,
                    MxInputFormComponent,
                    MxSelectSearchFormComponent,
                    MxSwithFormComponent,
                    MxInputTextareaComponent,
                    MxTextAreaFormComponent,
                    MxCurrencyFormComponent,
                    MxInputColorFormComponent,
                    MxInputTimePickerComponent,
                    MxMaxysInputLovComponent,
                    MxMaxysLovComponent,
                    MxMaxysInputComponent
                ],
                providers: [
                    BrMaskDirective
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MxBaseRestModule {
    /**
     * @param {?} env
     * @return {?}
     */
    static forRoot(env) {
        return {
            ngModule: MxBaseRestModule,
            providers: [
                MxBaseRestService,
                {
                    provide: Environment, useValue: env
                }
            ],
        };
    }
}
MxBaseRestModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Totalizator {
    constructor() {
        this.type = ColumnTypes.CURRENCY;
    }
}
if (false) {
    /** @type {?} */
    Totalizator.prototype.label;
    /** @type {?} */
    Totalizator.prototype.name;
    /** @type {?} */
    Totalizator.prototype.value;
    /** @type {?} */
    Totalizator.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ActionDataList, AlertHistoryModel, AlertType, ColumnModel, ColumnTypes, CustomInput, Environment, HttpLoaderFactory, LovModel, MxAlertService, MxBaseRestModule, MxBaseRestService, MxCommonsModule, MxCurrencyFormComponent, MxDataTableComponent, MxDataTableListComponent, MxDataTablePaginatorComponent, MxInputCheckBoxComponent, MxInputColorFormComponent, MxInputDateComponent, MxInputDateRangeComponent, MxInputFormComponent, MxInputLovComponent, MxInputSugestionComponent, MxInputTextComponent, MxInputTextareaComponent, MxInputTimePickerComponent, MxLanguageTranslationModule, MxMaxysInputComponent, MxMaxysInputLovComponent, MxMaxysLovComponent, MxModalConfirmComponent, MxModalInfoComponent, MxModalListComponent, MxModalLovComponent, MxModalLovMaxysService, MxModalService, MxSelectDualListComponent, MxSelectOneComponent, MxSelectSearchFormComponent, MxSwithFormComponent, MxTextAreaFormComponent, ParamLovModal, Totalizator, noTransition, routerTransition, slideToBottom, slideToLeft, slideToRight, slideToTop, BaseFormField as ɵa };
//# sourceMappingURL=mx-commons.js.map
